<template>
  <div class="page-wrapper" style="font-family: Pretendard;">

    <div class="background-page">


      <transition name="slide-fade">
        <div class="background-page level-2"  style="overflow-y: scroll; background:white;" v-if="currentMerchantItem != false"  v-on:scroll="handleScroll" id="menu-page">
          <div class="container " style="background:white;" id="restaurant-panel">

            <div class="restaurant-image">
              <slider animation="fade" style="height:100%"
                      v-model="restaurantSliderIndex"
                      :autoplay="false"
                      @change="onRestaurantSliderChanged">
                <slider-item
                  v-for="(img, index) in images"
                  :key="index"
                  style="z-index: 0; height:200px;"
                >
                  <video
                    v-if="isVideoUrl(img)"
                    :ref="'restaurantSliderVideo' + index"
                    class="gcs-video"
                    :src="img"
                    muted
                    playsinline
                    preload="auto"
                    @ended="onRestaurantSliderVideoEnded(index)"
                  >
                    Your browser does not support the video tag.
                  </video>
                  <div v-else class="restaurant-image" v-bind:style="{backgroundImage: 'url(' + getMainLargeImage(img) + ')'}"></div>
                </slider-item>
              </slider>
            </div>
            <div style="margin-left:-15px; margin-right: -15px; margin-top: 10px; padding-bottom: 33%; background-size: cover; background-repeat: no-repeat; background-position: center;"
                 v-if="currentMerchantItem.webSetting !== undefined && currentMerchantItem.webSetting !== null && currentMerchantItem.webSetting.bannerImage !== null && currentMerchantItem.webSetting.bannerImage.length > 0"
            v-bind:style="{backgroundImage: 'url(' + currentMerchantItem.webSetting.bannerImage + ')'}">

            </div>
          </div>

          <div class="restaurant-title-container level-2" style="position:sticky; top:0;">

            <div class="place-title-container" id="place-title">
              {{currentMerchantItem.title}}
            </div>

            <div class="place-table-container">
              <div v-if="type === 'table'" class="table-type-button">Table:{{tableItem.name}}</div>
              <div v-else-if="type === 'collection'" class="table-type-button" v-bind:class="{'selected': type ==='collection'}" v-on:click="onTypeClicked('collection')">Collect</div>
              <div v-else-if="type === 'takeaway'" class="table-type-button" v-bind:class="{'selected': type ==='takeaway'}" v-on:click="onTypeClicked('takeaway')">Collect</div>
              <div v-else-if="type === 'room'" class="table-type-button" v-bind:class="{'selected': type ==='takeaway'}" v-on:click="onTypeClicked('room')">Room Service</div>
              <div v-else-if="type === 'delivery'" class="table-type-button" v-bind:class="{'selected': type ==='delivery'}" v-on:click="onTypeClicked('delivery')">Delivery</div>
<!--              <div v-if="type !== 'table' && enableDelivery === true" class="table-type-button" v-bind:class="{'selected': type === 'delivery'}" v-on:click="onTypeClicked('delivery')">Delivery</div>-->

            </div>
          </div>
          <div class="left-top-back level-3" id="back-btn" v-on:click="closeTop">
            <span><i class="fas fa-arrow-left"></i></span>
          </div>
          <div class="place-info-container" style="padding-top:0px;">


            <div class="place-tag-container">
              {{currentMerchantItem.types}}
            </div>
            <div class="place-bottom-container">
              <table style="width: 100%;">
                <tr>
                  <td style="width: 25px; vertical-align: top;">
                    <span><img class="info-icon" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-marker.png"/></span>
                  </td>
                  <td>
                    <a :href="'http://maps.google.com/?q=' + currentMerchantItem.address" target="_blank" >{{currentMerchantItem.address}}</a>
                  </td>
                </tr>
                <tr>
                  <td style="width: 30px;">
                    <span><img class="info-icon" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-phone.png"/></span>
                  </td>
                  <td>
                    <a :href="'tel:' + currentMerchantItem.contact">{{currentMerchantItem.contact}}</a>
                  </td>
                </tr>
                <tr>
                  <td style="width: 30px;">
                    <span><img class="info-icon" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-clock.png"/></span>
                  </td>
                  <td>
                    Today <span v-if="isShopOpen==false">Closed</span><template v-else><span v-if="shopSlots.length > 0" v-for="(slot, si) in shopSlots"><span v-if="si > 0"> ,</span>{{slot.fromString}}~{{slot.toString}}</span><span v-else>Closed</span></template>
                  </td>
                </tr>
              </table>



            </div>

          </div>
          <div class="container level-2" style="position:sticky; top:55px; background-color: white; padding-top: 10px;">
            <div class="row text-style-1" style="padding-top:10px; padding-bottom:10px;background-color: #e8e8e8; display: none;">
              <div v-if="tableItem != false" class="col-6" style="padding-right:0; display:flex;">

                <div v-if="type !== 'table'" class="mode-small-button" v-bind:class="{'selected': type ==='takeaway'}" v-on:click="onTypeClicked('takeaway')">Collect</div>
                <div v-if="type !== 'table'" class="mode-small-button" v-bind:class="{'selected': type ==='room'}" v-on:click="onTypeClicked('room')">Room <span v-if="tableItem !== null">{{tableItem.name}}</span></div>
                <div v-if="type !== 'table' && enableDelivery === true" class="mode-small-button" v-bind:class="{'selected': type === 'delivery'}" v-on:click="onTypeClicked('delivery')">Delivery</div>
                <div v-if="type === 'table'" class="mode-small-button selected">Table:{{tableItem.name}}</div>
                <!--                <div class="elapsed-text-box">-->
                <!--                  <div v-if="tableItem != false" v-on:click="onTypeClicked"><span v-if="type=='takeaway'"><i class="fas fa-shopping-bag"></i> Collect</span><span v-else-if="type=='delivery'"><i class="fas fa-car"></i> {{(distance/1600).toFixed(1)}}m</span><span v-else>Table:{{tableItem.name}}</span></div>-->
                <!--                </div>-->
              </div>
              <div class="col-6" v-if="(preorder === true || (checkIfOpen() === true && (parseInt(currentMerchantItem.canTakeOrder) === 1 || currentMerchantItem.canTakeOrder === true  || type === 'table'))) && order !== undefined && order !== false && order.list !== undefined" v-on:click="showBasketView" >
                <div class="eemo-yellow basket-box" id="basket-box">
                  <span class="basket-count">
<!--                    <i class="fas fa-shopping-basket"></i>-->
                    <img height="20px" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-bag.png"/>

                    {{getTotalCount()}}</span> <span>&#160;&#160;&#124;&#160;&#160;</span> £{{Number(order.totalDue/100).toFixed(2)}}
                </div>
              </div>
              <template v-if="type === 'takeaway' || type === 'collection' || type === 'room'">
                <div class="col-6" v-if="preorder === false && checkIfOpen() === true && (parseInt(currentMerchantItem.canTakeOrder) === 0 && type !== 'table')">
                  <div class="nav-button negative-button">
                    Cannot take order
                  </div>
                </div>
                <div class="col-6" v-if="preorder === false && checkIfOpen() === false" >
                  <div class="nav-button negative-button">
                    Closed
                  </div>
                </div>
              </template>
              <template v-else-if="type === 'delivery'">
                <div class="col-6" v-if="preorder === false && checkIfOpen() === true && parseInt(currentMerchantItem.canTakeOrder) === 0">
                  <div class="nav-button negative-button">
                    Cannot take order
                  </div>
                </div>
                <div class="col-6" v-if="preorder === false && checkIfOpen() === false" >
                  <div class="nav-button negative-button">
                    <!--                    <div v-if="slots.length > 0" v-for="slot in slots">{{slot.fromString}}~{{slot.toString}}</div>-->
                    <span>Currently No Delivery</span>

                  </div>
                </div>
              </template>
            </div>
            <div class="row" style="background-color: white;">
              <div class="col-12">
                <div class="search-bar-container">
                  <input type="text" v-model="searchWord" placeholder="Search"/>
                  <img @click="searchWord = ''" src="https://storage.googleapis.com/menus-275719.appspot.com/icons/ic-cancel-circle.svg"/>
                </div>
              </div>
<!--              <div class="col-10" style="padding-right: 0;">-->
<!--                -->
<!--              </div>-->
<!--              <div class="col-2" style="padding:0;">-->
<!--                <img @click="searchWord = ''"-->
<!--                     style="height: 38px; width: 38px; margin:auto; line-height: 38px; border-radius: 19px;"-->
<!--                  src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-cancel.png"/>-->



<!--              </div>-->
            </div>
            <div class="row" style="padding-top:10px; padding-bottom: 10px; min-height:40px;border-bottom:1px solid #efeff6;" v-if="currentMerchantItem != false && currentMerchantItem.categories != undefined">
              <div class="col-12 hide-scrollbar horizontal-scroll-container" id="cat-container" style="overflow-x: scroll;scroll-behavior: smooth;-webkit-overflow-scrolling: touch;">
                <ul class="nav nav-tabs" >
                  <li v-for="(cat, index) in currentMerchantItem.categories" >
                    <a class="button-outlined-container button-text cat-button" v-bind:class="{'active': index == 0}" :id="'cat-'+cat.id" v-on:click="onCatClicked(index)" data-toggle="tab" :href="'#cat-' + cat.id">
                    <span v-if="cat.public_name !== undefined && cat.public_name !== null && cat.public_name.length > 0">{{cat.public_name}}</span><span v-else>{{cat.name}}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
<!--          <div class="container" style="padding-top:310px;" id="menu-list-container">-->
          <div class="container" id="menu-list-container" v-bind:style="showDeliveryAddressBar ? {paddingBottom: '150px'} : null">
            <div class="row" v-if="currentMerchantItem !== false && currentMerchantItem.categories !== undefined">
              <div class="col-12">
                <div class="tab-content">
                  <div v-for="(cat, index) in currentMerchantItem.categories" :id="'cat-menu-container-' + cat.id">
<!--                  <div v-for="(cat, index) in currentMerchantItem.categories" :id="'cat-menu-container-' + cat.id">-->

                    <div>
                      <div class="category-section-title" :id="'category-title-'+cat.id" v-if="searchWord == null || searchWord === ''">
                        <span v-if="cat.public_name !== undefined && cat.public_name !== null && cat.public_name.length > 0">{{cat.public_name}}</span><span v-else>{{cat.name}}</span>
                        <div class="category-section-description" v-if="cat.description !== undefined && cat.description !== null && cat.description.length > 0">{{cat.description}}</div>
                      </div>


                    </div>
                    <template v-if="cat.horizontal !== undefined && cat.horizontal === true">
                      <div class="horizontal-menu-container">
                        <div class="horizontal-menu-item-card" v-for="menu in cat.list"
                             v-if="parseInt(menu.lastSelection) === 0 && (searchWord === null || searchWord.length === 0 || searchWordIncluded(menu) === true)"
                             v-bind:class="{'sold-out-item': parseInt(menu.soldOut) === 1 || menu.tableAvailable === false}"
                             v-on:click="selectMenu(menu)">
                          <div class="merchant-card-wrapper" v-bind:class="{'menu-soldout': parseInt(menu.soldOut) === 1}">
                            <div class="menu-card-info" v-bind:class="{'menu-card-no-image': menu.imgs.length === 0}" style="position: relative;">
                              <div class="menu-card-image" style="margin-top: 0; position: relative;" v-if="menu.imgs.length > 0"  v-bind:style="{backgroundImage: 'url(' + getThumbnamil(menu.imgs[0]) + ')'}">
                                <div v-if="getMenuAmount(menu) != ''" class="menu-item-amount">{{getMenuAmount(menu)}}</div>
                              </div>
                              <div v-else class="menu-card-image" style="margin-top: 0; position: relative">
                                <div v-if="getMenuAmount(menu) != ''" class="menu-item-amount">{{getMenuAmount(menu)}}</div>
                              </div>
                              <div class="menu-card-title">
                                <span v-if="menu.public_name == null || menu.public_name.length === 0">{{menu.name}}</span><span v-else>{{menu.public_name}}</span>
                                <span v-if="(menu.productType !== undefined && menu.productType != null && menu.productType === 'Alcohol') || (menu.alcohol !== undefined && menu.alcohol === true)">
                                    <img class=" alcohol-icon" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-beer.png"/>

                              </span>

                              </div>
                              <div v-if="menu.delay > 0" class="delay-message">* currently {{menu.delay}} min<span v-if="menu.delay > 1">s</span> delay</div>
                              <p class="menu-item-description" style="margin-top:10px; white-space: initial;" v-if="menu.description != null && menu.description.length > 0"><span v-html="menu.description.replace(/(?:\r\n|\r|\n)/g, '<br>')"></span></p>
                              <div v-if="menu.tableAvailable == false" class="stressed-info"><br>*{{menu.tableMessage}}</div>
                              <div v-if="menu.min_order > 1" class="stressed-info"><br>Minimum {{menu.min_order}} <span v-if="menu.groupTags != null && menu.groupTags.length > 0">{{menu.groupTags}}</span></div>
                              <div class="menu-item-price" style="margin-top:10px;">
                                <span v-html="promotionEligable(menu)"></span>

                                <template  v-if="menu.icons.length > 0">
                                <span v-for="(icon, ici) in menu.icons">
                                  <img v-if="icon.selected === true" class="icon-item-image" :src="icon.url" height="30px" v-bind:key="'menu-icon-' + menu.id + '-' + ici"/>
                                  <!--                            <div v-for="icon in menu.icons" v-if="icon.selected == true" class="icon-item" v-bind:style="{backgroundImage: 'url(' + icon.url + ')'}"/>-->
                                </span>
                                </template>

                                <span v-if="menu.soldOut == 1" style="color:#FF795C;"><br>Sold Out</span>
                                <span v-if="menu.soldOut == 0 && menu.pricePoints > 0 &&
                              (order == false || order.pointsUsed == 0) &&
                              userPoint != undefined && userPoint != false && userPoint.balance > 0 && userPoint.balance > menu.pricePoints">
                                or <span class="points-usable-price" >{{menu.pricePoints}} {{points.unitTitle}}s</span>
                              </span>


                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="menu-item-card" v-for="menu in cat.list"
                           v-if="parseInt(menu.lastSelection) === 0 && (searchWord === null || searchWord.length === 0 || searchWordIncluded(menu) === true)"
                           v-bind:class="{'sold-out-item': parseInt(menu.soldOut) === 1 || menu.tableAvailable === false}"
                           v-on:click="selectMenu(menu)">
                        <div class="merchant-card-wrapper" v-bind:class="{'menu-soldout': parseInt(menu.soldOut) === 1}">

                          <div class="menu-card-info" v-bind:class="{'menu-card-no-image': menu.imgs.length === 0}" style="position: relative;">
                            <div class="menu-card-title">
                              <span v-if="menu.public_name == null || menu.public_name.length === 0">{{menu.name}}</span><span v-else>{{menu.public_name}}</span>
                              <span v-if="(menu.productType !== undefined && menu.productType != null && menu.productType === 'Alcohol') || (menu.alcohol !== undefined && menu.alcohol === true)">
                                    <img class=" alcohol-icon" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-beer.png"/>

                              </span>

                            </div>
                            <div v-if="menu.delay > 0" class="delay-message">* currently {{menu.delay}} min<span v-if="menu.delay > 1">s</span> delay</div>
                            <p class="menu-item-description" style="margin-top:10px;" v-if="menu.description != null"><span v-html="menu.description.replace(/(?:\r\n|\r|\n)/g, '<br>')"></span></p>
                            <div v-if="menu.tableAvailable == false" class="stressed-info"><br>*{{menu.tableMessage}}</div>
                            <div v-if="menu.min_order > 1" class="stressed-info"><br>Minimum {{menu.min_order}} <span v-if="menu.groupTags != null && menu.groupTags.length > 0">{{menu.groupTags}}</span></div>
                            <div class="menu-item-price" style="margin-top:10px;">
                              <span v-html="promotionEligable(menu)"></span>

                              <template  v-if="menu.icons.length > 0">
                                <span v-for="(icon, ici) in menu.icons">
                                  <img v-if="icon.selected === true" class="icon-item-image" :src="icon.url" height="30px" v-bind:key="'menu-icon-' + menu.id + '-' + ici"/>
                                  <!--                            <div v-for="icon in menu.icons" v-if="icon.selected == true" class="icon-item" v-bind:style="{backgroundImage: 'url(' + icon.url + ')'}"/>-->
                                </span>
                              </template>

                              <span v-if="parseInt(menu.soldOut) === 1" style="color:#FF795C;"><br>Sold Out</span>
                              <span v-if="parseInt(menu.soldOut) === 0 && menu.pricePoints > 0 &&
                              (order == false || order.pointsUsed == 0) &&
                              userPoint != undefined && userPoint != false && userPoint.balance > 0 && userPoint.balance > menu.pricePoints">
                                or <span class="points-usable-price" >{{menu.pricePoints}} {{points.unitTitle}}s</span>
                              </span>


                            </div>
                          </div>
                          <div class="menu-card-image" style="margin-top: 0; position: relative;" v-if="menu.imgs.length > 0"  v-bind:style="{backgroundImage: 'url(' + getThumbnamil(menu.imgs[0]) + ')'}">
                            <div v-if="getMenuAmount(menu) != ''" class="menu-item-amount">{{getMenuAmount(menu)}}</div>
                          </div>
                          <div v-else class="menu-card-image" style="margin-top: 0; position: relative">
                            <div v-if="getMenuAmount(menu) != ''" class="menu-item-amount">{{getMenuAmount(menu)}}</div>
                          </div>

                        </div>
                      </div>
                    </template>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <Bottom
            :item="currentMerchantItem">

          </Bottom>
          <div v-if="type == 'table' && currentMerchantItem != false && currentMerchantItem.appMessage != null && currentMerchantItem.appMessage.length > 0" style="position: fixed; width:100%; bottom: 0; left: 0; padding:10px; text-align: center; background:white;" v-html="currentMerchantItem.appMessage"></div>
          <div class="history-icon" v-if="orderHistory != undefined && orderHistory != null && orderHistory.length > 0" v-on:click="showHistoryList">
            <span><i class="fas fa-history"></i></span>
          </div>
          <div class="point-icon" v-if="(type === 'takeaway' || type === 'collection' || type === 'room') && userPoint != undefined && userPoint != false && userPoint.balance > 0">
            <span>{{userPoint.balance}} {{points.unitTitle}}s</span>
          </div>
          <div class="bill-icon" v-if="type === 'table' && currentMerchantItem != null && currentMerchantItem != false && currentMerchantItem.useBillBtn == true &&
          order != undefined && order != false && order.list != undefined && order.list.length > 0" v-on:click="sendBillRequest">
            <span>
              <span><img style="height: 25px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-bill.png"/></span>
<!--              <i class="fas fa-receipt"></i>-->
              BILL</span>
          </div>

          <div class="container" v-bind:class="{'has-delivery-address-bar': showDeliveryAddressBar}" style="position: fixed; bottom: 0; left: 0; background-color: white; z-index: 100;">
            <div class="row" v-if="showDeliveryAddressBar">
              <div class="col-12">
                <div class="delivery-address-bar" v-on:click="searchAddress">
                  <div class="delivery-address-bar-main">
                    <div class="delivery-address-bar-label">Deliver to</div>
                    <div class="delivery-address-bar-text">{{deliveryAddressText}}</div>
                  </div>
                  <div class="delivery-address-bar-meta">
                    <span>{{(distance/1600).toFixed(1)}} miles<template v-if="deliveryTravelTimeText"> &middot; {{deliveryTravelTimeText}}</template></span>
                    <span class="delivery-address-bar-change">Change</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12" v-if="(preorder === true || (checkIfOpen() === true && (parseInt(currentMerchantItem.canTakeOrder) === 1 || currentMerchantItem.canTakeOrder === true  || type === 'table'))) && order !== undefined && order !== false && order.list !== undefined" v-on:click="showBasketView" >
                <div class="bottom-btn-container" id="basket-box">
                  <div style="text-align: left; padding-left: 20px;">
                    <span>
  <!--                    <i class="fas fa-shopping-basket"></i>-->
                      <img src="https://storage.googleapis.com/menus-275719.appspot.com/icons/ic-basket-line.svg"/>
                    </span>
                      {{getTotalCount()}}

                  </div>
                  <div>
                    Basket
                  </div>
                  <div style="text-align: right; padding-right: 20px;">
                    £{{Number(order.totalDue/100).toFixed(2)}}
                  </div>


                </div>
              </div>
              <template v-if="type === 'takeaway' || type === 'collection' || type === 'room'">
                <div class="col-12" v-if="preorder === false && checkIfOpen() === true && (parseInt(currentMerchantItem.canTakeOrder) === 0 && type !== 'table')">
                  <div class="bottom-negative-btn-container negative-button">
                    Cannot take order
                  </div>
                </div>
                <div class="col-12" v-if="preorder === false && checkIfOpen() === false" >
                  <div class="positive-button negative-button">
                    Closed
                  </div>
                </div>
              </template>
              <template v-else-if="type === 'delivery'">
                <div class="col-12" v-if="preorder === false && checkIfOpen() === true && parseInt(currentMerchantItem.canTakeOrder) === 0">
                  <div class="nav-button negative-button">
                    Cannot take order
                  </div>
                </div>
                <div class="col-12" v-if="preorder === false && checkIfOpen() === false" >
                  <div class="nav-button negative-button">
                    <!--                    <div v-if="slots.length > 0" v-for="slot in slots">{{slot.fromString}}~{{slot.toString}}</div>-->
                    <span>Currently No Delivery</span>

                  </div>
                </div>
              </template>
            </div>

          </div>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="background-page level-3 eemo-gray h-100" v-if="optionSelectItem != false">
          <div class="container" style="overflow-y: scroll; padding-bottom: 20px; height: calc(100% - 140px); background-color: white;">

            <div class="row" style="margin-bottom: 10px;">
              <div class="col-12" v-if="optionSelectItem.imgs.length > 1" style="padding-bottom: 0px; display: flex; overflow-x: scroll; position: relative;">
                <img v-for="img in optionSelectItem.imgs" class="selection-image" height="300px" style="border-radius: 10px; margin-left:10px;" :src="getLargeImage(img)"/>

              </div>
              <div class="col-12 single-image" v-else-if="optionSelectItem.imgs.length == 1" style="padding-bottom: 0px;" v-bind:style="{backgroundImage: 'url(' + getLargeImage(optionSelectItem.imgs[0]) + ')'}">

              </div>
              <div class="col-12" v-else style="height: 70px;">

              </div>
              <div class="col-12" style="font-size: 10px; background-color:white; color:#c2c2c2;">
                Pictures may differ from original foods
              </div>
<!--              <div class="col-12 option-title">-->
<!--                {{optionSelectItem.publicMenuName}}-->
<!--              </div>-->
              <div class="col-12 big-name text-left" style="background: white;">
                {{optionSelectItem.publicMenuName}}<span v-if="optionSelectItem.groupTags != null && optionSelectItem.groupTags.length > 0">&nbsp;({{optionSelectItem.groupTags}})</span>
                <div class="icon-container"  v-if="optionSelectItem.icons.length > 0">
                  <div v-for="icon in optionSelectItem.icons" v-if="icon.selected == true" class="icon-item" v-bind:style="{backgroundImage: 'url(' + icon.url + ')'}"/>

                </div>
                <p v-if="(optionSelectItem.alcohol != undefined && optionSelectItem.alcohol == true) || (getMenuType(optionSelectItem.menuId)  !== null && getMenuType(optionSelectItem.menuId) == 'Alcohol')" class="alcohol" style="font-size: small;">
                  This is alcoholic product. You must be over 18.<br>
                  Staff will check your age and may ask your ID at <span>{{type=='table'?'serving':'food collection'}}</span>
                </p>
              </div>
              <div class="col-12 option-description bottom-divider" v-if="getMenuDescription(optionSelectItem.menuId) !== ''">

                <span v-html="getMenuDescription(optionSelectItem.menuId).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
              </div>
              <div class="col-12 option-description bottom-divider" v-if="optionSelectItem.note !== null && optionSelectItem.note !== ''">

                <div v-html="optionSelectItem.note"></div>
              </div>
              <div v-if="optionSelectItem.youtube != undefined && optionSelectItem.youtube != null && optionSelectItem.youtube.length > 0" class="youtube-container bottom-divider">
                <iframe :src="optionSelectItem.youtube"  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <div class="col-12 option-ingredients text-left bottom-divider" v-if="getMenuIngredients(optionSelectItem.menuId) !== ''">
                <div class="option-section-title text-left">Ingredients</div>
                {{getMenuIngredients(optionSelectItem.menuId)}}
              </div>
              <div class="col-12 option-ingredients text-left bottom-divider" v-if="getMenuAllergens(optionSelectItem.menuId) !== ''">
                <div class="option-section-title text-left">Allergens</div>
                <div style="font-weight: bold;">{{getMenuAllergens(optionSelectItem.menuId)}}</div>
              </div>

            </div>
            <div class="row option-selection-title bottom-divider">
              <template v-if="optionSelectItem.itemOption !== undefined && optionSelectItem.itemOption.priceList !== undefined && optionSelectItem.itemOption.priceList.length > 0">
                <div class="col-6" v-for="(priceItem, pi) in optionSelectItem.itemOption.priceList" v-bind:key="'price-list-item-desc-' + pi" style="padding-bottom: 10px;">
                  £{{Number(priceItem.price).toFixed(2)}} for {{priceItem.numberOfItems}} items
                </div>
              </template>
              <template v-else>
              <div class="col-6">
                Price
              </div>
              <div class="col-6 price" style="font-weight: bold;">
                £{{(optionSelectItem.price/100).toFixed(2)}}<span v-if="optionSelectItem.originalPrice > optionSelectItem.price">&nbsp;&nbsp;<del>£{{(optionSelectItem.originalPrice/100).toFixed(2)}}</del></span>
              </div>
              </template>
            </div>
            <div class="row bottom-divider" style="background-color: white;" v-if="optionSelectItem.itemOption !== undefined && optionSelectItem.itemOption !== null && optionSelectItem.itemOption !== false">
              <template v-if="optionSelectItem.itemOption.type === 'variable_price'">
                <div class="col-12 option-selection-title">
                  Select items
                </div>
                <div class="col-12">
                  <div v-for="(selectItem, si) in optionSelectItem.itemOption.selectedItems" v-bind:key="'select-list-item-' + si"
                       class="select-item-container"
                       style="width: 100%; display: flex;"
                        v-bind:class="{'select-item-container-active': selectItem.amount > 0}">
                    <div style="width: calc(100% - 160px); text-align: left;">
                      {{selectItem.item}}
                    </div>
                    <div style="width: 40px; text-align: center;" @click="changeChoiceItem(si, -1)">
                      <div class="item-amount-button ic-minus"></div>
                    </div>
                    <div style="width: 80px; text-align: center;">
                      {{selectItem.amount}}
                    </div>
                    <div style="width: 40px; text-align: center;" @click="changeChoiceItem(si, 1)">
                      <div class="item-amount-button ic-plus"></div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="optionSelectItem.itemOption.type === 'change_choice'">
                <div class="col-12 option-selection-title">
                  {{optionSelectItem.itemOption.defaultDescription}}
                </div>
                <div class="col-12">
                  <ul class="list-group" :key="'default-selector-container'" v-if="optionSelectItem.itemOption.defaultItems !== undefined && optionSelectItem.itemOption.defaultItems !== null && optionSelectItem.itemOption.defaultItems.length > 0">

                    <li class="list-group-item option-item option-selected" v-for="(defaultItem, di) in optionSelectItem.itemOption.defaultItems"
                         :key="'default-selector-item-' + di"
                         v-bind:class="{'option-unselected': defaultItem.selected === false}" v-on:click="toggleItemOptionDefault(di)">
                      {{defaultItem.title}} <span v-if="defaultItem.selected === true"><i class="fas fa-check"></i></span>

                    </li>

                  </ul>
                </div>


                <template v-if="showAlternativeOption() === true">
                <div class="col-12 option-selection-title">
                  {{optionSelectItem.itemOption.alternativeDescription}}
                </div>
                <div class="col-12">
                  <ul class="list-group" :key="'default-selector-container'" v-if="optionSelectItem.itemOption.alternativeItems !== undefined && optionSelectItem.itemOption.alternativeItems !== null && optionSelectItem.itemOption.alternativeItems.length > 0">

                    <li class="list-group-item option-item option-selected" v-for="(alternativeItem, di) in optionSelectItem.itemOption.alternativeItems"
                        :key="'default-selector-item-' + di"
                        v-bind:class="{'option-unselected': alternativeItem.selected === false}" v-on:click="toggleItemOptionAlternative(di)">
                      {{alternativeItem.title}} <span v-if="alternativeItem.selected === true"><i class="fas fa-check"></i></span>
                    </li>

                  </ul>
                </div>
                </template>
              </template>
            </div>
            <div class="row" style="margin-top:10px;margin-bottom: 10px; background-color: white;" v-for="(option, index) in optionSelectItem.options">
              <div class="col-12 option-selection-title">
                {{option.name}}<span v-if="option.min_order > 1"> (Max {{option.min_order}} selections)</span>
              </div>

              <template v-if="option.multiple !== undefined && option.multiple === true" >
                <div class="col-12">
                  <ul class="list-group">
                    <div class="list-group-item option-item"
                         v-for="(optionItem, oi) in option.list"
                         v-bind:key="'option-multi-selector-' + oi"
                         v-bind:class="{'selected': optionItem.amount > 0, 'sold-out-item': optionItem.soldOut !== undefined && optionItem.soldOut === true}"
                        style="line-height: 40px;">
                      <template v-if="optionItem.soldOut !== undefined && optionItem.soldOut === true">
                        {{optionItem.field_name}} <span v-if="optionItem.field_price > 0">({{Number(optionItem.field_price).toFixed(2)}})</span>
                        <span style="padding-left: 20px; color: #E7344C;">Sold Out</span>
                        <span v-if="optionItem.field_icon !== undefined && optionItem.field_icon != null" v-html="getFieldIcon(optionItem.field_icon)"></span>
                        <span style="float:right; line-height: 40px; width: 30px; text-align: center;" v-if="optionItem.amount > 0">{{optionItem.amount}}</span>
                        <span style="float:right;" class="item-amount-btn-container" @click.stop="toggleMultiSelectionOption(index, oi,-1)" v-if="optionItem.amount > 0">
                          <img style="width: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-minus-gray-ic.png"/>
                        </span>
                      </template>
                      <template v-else>
                      {{optionItem.field_name}} <span v-if="optionItem.field_price > 0">({{Number(optionItem.field_price).toFixed(2)}})</span>

                      <span style="float:right" class="item-amount-btn-container" @click.stop="toggleMultiSelectionOption(index, oi, 1)">
                        <img style="width: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-plus-orange-ic.png"/>
                      </span>
<!--                      <span v-if="optionItem.amount > 0 && optionItem.field_price > 0" style="float:right; height: 40px; line-height: 40px;margin-right: 10px; ">(+{{Number(optionItem.total_price).toFixed(2)}})</span>-->
                      <span style="float:right; line-height: 40px; width: 30px; text-align: center;" v-if="optionItem.amount > 0">{{optionItem.amount}}</span>

                      <span style="float:right;" class="item-amount-btn-container" @click.stop="toggleMultiSelectionOption(index, oi,-1)" v-if="optionItem.amount > 0">
                        <img style="width: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-minus-gray-ic.png"/>

                      </span>

<!--                      <button class="btn btn-success" style="float:right; margin-left: 10px;" @click="toggleMultiSelectionOption(index, oi, 1)"><i class="fas fa-plus"></i></button>-->
<!--                      <span  style="float:right;">{{optionItem.amount}}</span>-->
<!--                      <button class="btn btn-danger"  style="float:right; margin-left: 10px;" @click="toggleMultiSelectionOption(index, oi, -1)"><i class="fas fa-minus"></i></button>-->
                      <span v-if="optionItem.field_icon !== undefined && optionItem.field_icon != null" v-html="getFieldIcon(optionItem.field_icon)"></span>
<!--                      <span v-if="optionItem.amount === 0 && optionItem.field_price > 0" style="float:right; height: 40px; line-height: 40px; margin-right:10px;">&nbsp;{{Number(optionItem.field_price).toFixed(2)}}</span>-->
                      <span v-if="optionItem.amount > 0 && optionItem.field_price > 0" style="float:right; height: 40px; line-height: 40px; margin-right:10px;">&nbsp;+{{Number(optionItem.total_price).toFixed(2)}}</span>
                      </template>

                    </div>
                  </ul>
                </div>
              </template>
              <template v-else>
                <div class="col-12 bottom-divider">
                  <ul class="list-group">
                    <div class="list-group-item option-item"  v-for="(optionItem, oi) in option.list"
                         :key="'option-' + index + '-' + oi"
                         v-bind:class="{'selected': optionItem.selected === true}"
                         v-on:click="toggleOption(index, oi)">
                      {{optionItem.field_name}}

                      <template v-if="optionItem.soldOut !== undefined && optionItem.soldOut === true">
                        <span style="padding-left: 20px; color: #E7344C;">Sold Out</span>
                      </template>
                      <template v-else>
                      <span v-if="optionItem.field_icon !== undefined && optionItem.field_icon != null" v-html="getFieldIcon(optionItem.field_icon)"></span>
                      <div class="option-selector-icon" style="float: right;"></div>
                      <span v-if="optionItem.field_price > 0 && (option.base_price === undefined || option.base_price === false)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{Number(optionItem.originalPrice).toFixed(2)}}</del>&nbsp;+{{Number(optionItem.field_price).toFixed(2)}}</span>
                      <span v-if="optionItem.field_price >= 0 && (option.base_price !== undefined && option.base_price === true)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{(Number(optionSelectItem.originalPrice/100)+ Number(optionItem.originalPrice)).toFixed(2)}}</del>&nbsp;{{(Number(optionSelectItem.price/100)+Number(optionItem.field_price)).toFixed(2)}}</span>
                      </template>
                    </div>
                  </ul>

                </div>

                <div style="width:100%;" v-if="option.children != undefined && option.children != null && option.children.length > 0 && isOptionSelected(option)" v-for="(co, ci) in option.children">
                  <div class="col-12 option-name bottom-divider">
                    {{co.name}}
                  </div>

                  <div class="col-12" v-if="co.list != undefined && co.list.length > 0">
                    <ul class="list-group">
                      <li class="list-group-item option-item"  v-for="(childOptionItem, cci) in co.list"
                           :id="'option-selection-' + index + '-' + ci + '-' + cci"
                           :key="'option-' + index + '-' + ci + '-' + cci"
                           v-bind:class="{'selected': childOptionItem.selected == true}"
                           v-on:click="toggleOption(index, ci, cci)">
                        {{childOptionItem.field_name}} <span v-if="childOptionItem.field_icon != undefined && childOptionItem.field_icon != null "v-html="getFieldIcon(childOptionItem.field_icon)"></span> <span v-if="childOptionItem.field_price > 0" style="float:right;"><del v-if="childOptionItem.originalPrice > childOptionItem.field_price">{{(childOptionItem.originalPrice).toFixed(2)}}</del>&nbsp;+{{(childOptionItem.field_price).toFixed(2)}}</span>
                      </li>
                    </ul>

                  </div>

                </div>
              </template>
            </div>
            <div class="row"  style="margin-top:10px;margin-bottom: 10px; background-color: white;" v-if="currentMerchantItem.disableMemo == undefined || currentMerchantItem.disableMemo == 0">
              <div class="col-12 option-selection-title bottom-divider">

              </div>
              <div class="col-12" style="padding-bottom: 10px;">
                <div class="option-selection-title">
                  Memo <span style="color: #E7344C; font-weight: normal;">(Please tell us if you have any food allergy)</span>
                </div>
                <textarea class="form-control" style="border: 1px solid #DBDBDB; border-radius: 10px; background: #F5F5F5;" rows="2" v-model="optionSelectItem.memo"></textarea>
              </div>
            </div>
<!--            <div class="row">-->
<!--              -->
<!--            </div>-->
            <div class="row" style="margin-top: 10px;margin-bottom: 10px; background-color: white;padding-bottom:20px;padding-top:20px; display: none;">
              <div class="col-12" v-if="optionSelectItem.minOrder > 1" style="background-color: white;padding-bottom: 10px; color:#FF795C;">
                Minimum {{optionSelectItem.minOrder}}<span v-if="optionSelectItem.groupTags != null && optionSelectItem.groupTags.length > 0"> {{optionSelectItem.groupTags}} items</span>
              </div>
              <div class="col-4 amount-chooser text-right">
                <span v-if="optionSelectItem.pointsUsed == 0" v-on:click="optionSelectionChangeAmount(-1)">
<!--                  <i class="fas fa-minus-circle"></i>-->
                  <img style="width: 24px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-minus-gray-ic.png"/>
                </span>
              </div>
              <div class="col-4 amount-chooser" style="line-height: 30px;">
                {{optionSelectItem.amount}}
              </div>
              <div class="col-4 amount-chooser text-left">
                <span v-if="optionSelectItem.pointsUsed == 0" v-on:click="optionSelectionChangeAmount(1)">
<!--                  <i class="fas fa-plus-circle"></i>-->
                  <img style="width: 24px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-plus-orange-ic.png"/>
                </span>
              </div>
            </div>
            <div class="row" v-if="optionSelectItem.pricePoints > 0 &&
                            optionSelectItem.pointsUsed == 0 &&
                            (order == false || order.pointsUsed == 0) &&

                            userPoint != undefined && userPoint != false && userPoint.balance > 0 && userPoint.balance > optionSelectItem.pricePoints">
              <div class="col-12">
                <button type="button" class="add-button redeem-button" v-on:click="redeemPoint()">Redeem {{optionSelectItem.pricePoints}} {{points.unitTitle}}s</button>
              </div>

            </div>
            <div class="row" v-if="type == 'table' && currentMerchantItem != false && currentMerchantItem.appMessage != null && currentMerchantItem.appMessage.length > 0"  style="background: white;">
              <div class="col-12" v-html="currentMerchantItem.appMessage"></div>
            </div>
<!--            <div class="float-back" v-on:click="closeTop" ><i class="fas fa-chevron-left"></i></div>-->
          </div>
          <div class="container" style="position: absolute; bottom:0; left:0; padding-top: 18px; background-color: white;">
            <div class="row" style="background-color: white;">
              <div class="col-12" v-if="optionSelectItem.minOrder > 1" style="background-color: white;padding-bottom: 10px; color:#FF795C;">
                Minimum {{optionSelectItem.minOrder}}<span v-if="optionSelectItem.groupTags != null && optionSelectItem.groupTags.length > 0"> {{optionSelectItem.groupTags}} items</span>
              </div>
              <div class="col-4 amount-chooser text-right">
                <span v-if="optionSelectItem.pointsUsed == 0" v-on:click="optionSelectionChangeAmount(-1)">
<!--                  <i class="fas fa-minus-circle"></i>-->
                  <img style="width: 24px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-minus-gray-ic.png"/>
                </span>
              </div>
              <div class="col-4 amount-chooser" style="line-height: 30px;">
                {{optionSelectItem.amount}}
              </div>
              <div class="col-4 amount-chooser text-left">
                <span v-if="optionSelectItem.pointsUsed == 0" v-on:click="optionSelectionChangeAmount(1)">
<!--                  <i class="fas fa-plus-circle"></i>-->
                  <img style="width: 24px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-plus-orange-ic.png"/>
                </span>
              </div>
            </div>

            <div class="row" style="background: white; padding: 20px 10px 20px 10px;">
              <div class="col-12 delay-message" v-if="optionSelectItem.delay > 0" >
                ** Currently {{optionSelectItem.delay}} minute<span v-if="optionSelectItem.delay > 1">s</span> longer waiting time **
              </div>
              <div class="col-12" v-if="(checkBeforeLastOrder() === true && checkIfOpen() === true) || preorder == true" v-on:click="addToOrder">
                <div class="positive-button">
                Add £{{(optionSelectItem.totalPrice/100).toFixed(2)}}
                </div>
              </div>
              <div class="col-12" v-else v-on:click="closeTop">
                <div class="positive-button negative-button">
                <template v-if="type === 'delivery' && slots.length > 0">Delivery:<span  v-for="(slot, si) in slots"><span v-if="si > 0">, </span>{{slot.fromString}}~{{slot.toString}}</span></template>
                <span v-else>Closed</span>
                </div>
              </div>
            </div>
<!--            <div class="row eemo-yellow fixed-bottom positive-button" style="padding-top:10px;padding-bottom: 10px; box-shadow: 0px -2px 20px 2px rgba(0,0,0,0.3);" >-->
<!--              <div class="col-12" v-if="(checkBeforeLastOrder() == true && checkIfOpen() == true) || preorder == true" v-on:click="addToOrder">-->
<!--               Add £{{(optionSelectItem.totalPrice/100).toFixed(2)}}-->
<!--              </div>-->
<!--              <div class="col-12" v-else v-on:click="closeTop">-->
<!--                <template v-if="type === 'delivery' && slots.length > 0">Delivery:<span  v-for="(slot, si) in slots"><span v-if="si > 0">, </span>{{slot.fromString}}~{{slot.toString}}</span></template>-->
<!--                <span v-else>Closed</span>-->

<!--              </div>-->
<!--            </div>-->
            <!--          <div class="row" v-if="optionSelectItem.content.options != null && selectOrderItem.content.options.length > 0">-->


            <!--          </div>-->
          </div>
          <div style="position: absolute; left:15px;top:15px; background:#FFF; color:#000; width:40px;height: 40px;border-radius: 20px;line-height: 40px;" v-on:click="closeTop"><i class="fas fa-chevron-left"></i></div>
        </div>
      </transition>


      <transition name="slide-fade">
        <div class="background-page level-3 eemo-gray h-100" v-if="setSelectItem != false">
          <div class="container h-100" style="overflow-y: scroll; padding-bottom: 250px;">

            <div class="row" style="margin-bottom: 10px;">
              <div class="col-12" v-if="setSelectItem.imgs.length > 1" style="padding-bottom: 0px; display: flex; overflow-x: scroll; position: relative;">
                <img v-for="img in setSelectItem.imgs" class="selection-image" height="200px" style="border-radius: 10px; margin-left:10px;" :src="img"/>

              </div>
              <div class="col-12 single-image" v-else-if="setSelectItem.imgs.length == 1" style="padding-bottom: 0px;" v-bind:style="{backgroundImage: 'url(' + setSelectItem.imgs + ')'}">

              </div>
              <div class="col-12" v-else style="height: 70px;">

              </div>
              <div class="col-12" style="font-size: 10px; background-color:white;">
                Pictures may differ from original foods
              </div>
              <!--              <div class="col-12 option-title">-->
              <!--                {{optionSelectItem.publicMenuName}}-->
              <!--              </div>-->
              <div class="col-12 big-name text-left" style="background: white;">
                {{setSelectItem.publicMenuName}}
                <p v-if="setSelectItem.alcohol != undefined && setSelectItem.alcohol == true" class="alcohol" style="font-size: small;">
                  This is alcoholic product. You must be over 18.<br>
                  Staff will check your age and may ask your ID at <span>{{type=='table'?'serving':'food collection'}}</span>
                </p>
              </div>
              <div class="col-12 option-description" v-if="getMenuDescription(setSelectItem.menuId) !== ''">

                {{getMenuDescription(setSelectItem.menuId)}}
              </div>
              <div class="col-12 option-ingredients text-left" v-if="getMenuIngredients(setSelectItem.menuId) !== ''">
                <div class="option-section-title text-left">Ingredients</div>
                {{getMenuIngredients(setSelectItem.menuId)}}
              </div>

            </div>
            <div class="row option-selection-title">
              <div class="col-6">
                Basic
              </div>
              <div class="col-6 price">
                £{{(setSelectItem.price/100).toFixed(2)}}<span v-if="setSelectItem.originalPrice > setSelectItem.price">&nbsp;&nbsp;<del>£{{(setSelectItem.originalPrice/100).toFixed(2)}}</del></span>
              </div>

            </div>


            <div class="row" style="margin-top:10px;margin-bottom: 10px; background-color: white;" v-for="(section, index) in setSelectItem.sections">
              <div class="col-12 option-selection-title">
                {{section.section_title}}
              </div>
              <div class="col-12">
                <ul class="list-group">
                  <template v-for="(selectProduct, pi) in section.products">
                    <div class="list-group-item option-item"
                         :key="'select-product-' + index + '-' + pi"
                         v-bind:class="{'set-selected': selectProduct.selected === true}"
                         v-on:click="toggleSetSection(index, pi)">
                      {{selectProduct.public_name != null && selectProduct.public_name.length > 0 ? selectProduct.public_name : selectProduct.name}}
                      <span v-if="selectProduct.soldOut === '1'" style="padding-left: 20px; color: #E7344C;">Sold Out</span>
                    </div>
                    <div class="set-product-option-container" v-if="selectProduct.selected == true">
                      <div v-for="(option, optionIndex) in selectProduct.options">

                        <div class="option-section-title" style="padding-left: 15px; text-align: left;">{{option.name}}</div>
                        <ul class="list-group">
                          <div class="list-group-item option-item"  v-for="(optionItem, optionItemIndex) in option.list"
                               :key="'option-' + index + '-' + optionItemIndex"
                               v-bind:class="{'set-option-item selected': optionItem.selected == true}"
                               v-on:click="toggleSetSectionProductOption(index, pi, optionIndex, optionItemIndex)">
                            {{optionItem.field_name}}
                            <span v-if="optionItem.field_icon !== undefined && optionItem.field_icon !== null " v-html="getFieldIcon(optionItem.field_icon)"></span>
                            <span v-if="optionItem.field_price > 0 && (option.base_price === undefined || option.base_price === false)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{Number(optionItem.originalPrice).toFixed(2)}}</del>&nbsp;+{{Number(optionItem.field_price).toFixed(2)}}</span>
                            <span v-if="optionItem.field_price >= 0 && (option.base_price !== undefined && option.base_price === true)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{(Number(optionSelectItem.originalPrice/100)+ Number(optionItem.originalPrice)).toFixed(2)}}</del>&nbsp;{{(Number(optionSelectItem.price/100)+Number(optionItem.field_price)).toFixed(2)}}</span>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </template>

                </ul>
              </div>
            </div>


<!--            <div class="row" style="margin-top:10px;margin-bottom: 10px; background-color: white;" v-for="(option, index) in optionSelectItem.options">-->
<!--              <div class="col-12 option-selection-title">-->
<!--                {{option.name}}-->
<!--              </div>-->

<!--              <div class="col-12">-->
<!--                <ul class="list-group">-->
<!--                  <div class="list-group-item option-item"  v-for="(optionItem, oi) in option.list"-->
<!--                       :key="'option-' + index + '-' + oi"-->
<!--                       v-bind:class="{'selected': optionItem.selected == true}"-->
<!--                       v-on:click="toggleOption(index, oi)">-->
<!--                    {{optionItem.field_name}}-->
<!--                    <span v-if="optionItem.field_icon != undefined && optionItem.field_icon != null "v-html="getFieldIcon(optionItem.field_icon)"></span>-->
<!--                    <span v-if="optionItem.field_price > 0 && (option.base_price == undefined || option.base_price == false)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{Number(optionItem.originalPrice).toFixed(2)}}</del>&nbsp;+{{Number(optionItem.field_price).toFixed(2)}}</span>-->
<!--                    <span v-if="optionItem.field_price >= 0 && (option.base_price != undefined && option.base_price == true)" style="float:right;"><del v-if="optionItem.originalPrice > optionItem.field_price">{{(Number(optionSelectItem.originalPrice/100)+ Number(optionItem.originalPrice)).toFixed(2)}}</del>&nbsp;{{(Number(optionSelectItem.price/100)+Number(optionItem.field_price)).toFixed(2)}}</span>-->
<!--                  </div>-->
<!--                </ul>-->

<!--              </div>-->

<!--              <div style="width:100%;" v-if="option.children != undefined && option.children != null && option.children.length > 0 && isOptionSelected(option)" v-for="(co, ci) in option.children">-->
<!--                <div class="col-12 option-name">-->
<!--                  {{co.name}}-->
<!--                </div>-->

<!--                <div class="col-12" v-if="co.list != undefined && co.list.length > 0">-->
<!--                  <ul class="list-group">-->
<!--                    <li class="list-group-item option-item"  v-for="(childOptionItem, cci) in co.list"-->
<!--                        :id="'option-selection-' + index + '-' + ci + '-' + cci"-->
<!--                        :key="'option-' + index + '-' + ci + '-' + cci"-->
<!--                        v-bind:class="{'selected': childOptionItem.selected == true}"-->
<!--                        v-on:click="toggleOption(index, ci, cci)">-->
<!--                      {{childOptionItem.field_name}} <span v-if="childOptionItem.field_icon != undefined && childOptionItem.field_icon != null "v-html="getFieldIcon(childOptionItem.field_icon)"></span> <span v-if="childOptionItem.field_price > 0" style="float:right;"><del v-if="childOptionItem.originalPrice > childOptionItem.field_price">{{(childOptionItem.originalPrice).toFixed(2)}}</del>&nbsp;+{{(childOptionItem.field_price).toFixed(2)}}</span>-->
<!--                    </li>-->
<!--                  </ul>-->

<!--                </div>-->

<!--              </div>-->
<!--            </div>-->
            <div class="row"  style="margin-top:10px;margin-bottom: 10px; background-color: white;" v-if="currentMerchantItem.disableMemo == undefined || currentMerchantItem.disableMemo == 0">
              <div class="col-12 option-selection-title">
                Memo (Please tell us if you have any food allergy)
              </div>
              <div class="col-12" style="padding-bottom: 10px;">

                <textarea class="form-control" rows="2" v-model="setSelectItem.memo"></textarea>
              </div>
            </div>
            <div class="row" style="margin-top: 10px;margin-bottom: 10px; background-color: white;padding-bottom:20px;padding-top:20px;">
              <div class="col-4 amount-chooser text-right">
                <span v-if="setSelectItem.pointsUsed == 0" v-on:click="setSelectionChangeAmount(-1)">
<!--                  <i class="fas fa-minus-circle"></i>-->
                  <img style="width: 50px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-minus-gray-ic.png"/>
                </span>
              </div>
              <div class="col-4 amount-chooser" style="line-height: 30px;">
                {{setSelectItem.amount}}
              </div>
              <div class="col-4 amount-chooser text-left">
                <span v-if="setSelectItem.pointsUsed == 0" v-on:click="setSelectionChangeAmount(1)">
<!--                  <i class="fas fa-plus-circle"></i>-->
                  <img style="width: 30px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-plus-orange-ic.png"/>
                </span>
              </div>
            </div>

            <div class="row" v-if="type == 'table' && currentMerchantItem != false && currentMerchantItem.appMessage != null && currentMerchantItem.appMessage.length > 0"  style="background: white;">
              <div class="col-12" v-html="currentMerchantItem.appMessage"></div>
            </div>

            <div class="row" v-if="setSelectItem.pricePoints > 0 &&
                            setSelectItem.pointsUsed == 0 &&
                            (order == false || order.pointsUsed == 0) &&

                            userPoint != undefined && userPoint != false && userPoint.balance > 0 && userPoint.balance > setSelectItem.pricePoints">
              <div class="col-12">
                <button type="button" class="add-button redeem-button" v-on:click="redeemPoint()">Redeem {{setSelectItem.pricePoints}} {{points.unitTitle}}s</button>
              </div>

            </div>
            <div class="row eemo-yellow eemo-btn fixed-bottom" style="padding-top:20px;padding-bottom: 20px; box-shadow: 0px -2px 20px 2px gray;" >
              <div class="col-12" v-if="checkIfOpen() == true || preorder == true" v-on:click="addSetToOrder">
                Add £{{(setSelectItem.totalPrice/100).toFixed(2)}}
              </div>
              <div class="col-12" v-else v-on:click="closeTop">
                <template v-if="type === 'delivery' && slots.length > 0">Delivery:<span  v-for="(slot, si) in slots"><span v-if="si > 0">, </span>{{slot.fromString}}~{{slot.toString}}</span></template>
                <span v-else>Closed</span>

              </div>
            </div>
            <!--          <div class="row" v-if="optionSelectItem.content.options != null && selectOrderItem.content.options.length > 0">-->


            <!--          </div>-->
          </div>
          <div style="position: absolute; left:15px;top:15px; background:yellow; width:40px;height: 40px;border-radius: 20px;line-height: 40px;" v-on:click="closeTop"><i class="fas fa-chevron-left"></i></div>
          <div class="float-back" v-on:click="closeTop" ><i class="fas fa-chevron-left"></i></div>
        </div>
      </transition>


      <transition name="vertical">
        <div class="background-page level-3 popup-background basket-page" v-if="order != false && showBasket === true">
          <div class="basket-page-inner">
            <div class="container" id="basket-scroll-container">
              <div class="row">
                <div class="col-12 basket-title" style="line-height: 50px;box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);">
                  Basket
                  <span style="position: absolute; left: 20px; top:0;" v-on:click="closeTop"><i class="fas fa-chevron-left"></i></span>
                </div>




              </div>
            </div>
            <div class="container" id="basket-body-scroll">
              <div class="row" style="border:1px solid grey; border-radius:5px; margin-left:5px; margin-right: 5px; margin-bottom: 5px; display: none;" v-if="type=='table'">
                <div class="col-12 text-left" >
                  Order Status Description
                </div>
                <div class="col-12 text-left">
                  <span><div class="lds-dual-ring"></div></span>: Wait for acceptance
                </div>
                <div class="col-12 text-left">
                  <span><i class="fas fa-check" style="width: 24px;font-size: 24px;"></i></span>: Order Accepted
                </div>
              </div>
              <div class="row" v-if="type=='table'">
                <div class="col-12">
                  <div class="order-section-selector-container">
                    <div class="order-section-selector" v-bind:class="{'active': showMine === false}" v-on:click="toggleMyOrder">All</div>
                    <div class="order-section-selector" v-bind:class="{'active': showMine === true}" v-on:click="toggleMyOrder">My Items</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right" style="display: none;" v-if="type=='table'">
                  <span class="toggler" v-bind:class="{'eemo-yellow':showMine==false}" v-on:click="toggleMyOrder">All</span><span class="toggler" v-bind:class="{'eemo-yellow':showMine==true}" v-on:click="toggleMyOrder">My items</span>
                </div>
                <div class="col-12 text-left " style="margin-top:10px;padding-left: 0; padding-right:0">
                  <table class="basket-table">
                    <tr>
                      <td style="font-weight: 600; font-size: 16px; padding-left: 15px;">Items</td>
                      <td colspan="5"/>
                    </tr>
                    <tbody v-if="order.list != undefined && order.list.length > 0">
                    <tr v-for="(item, index) in order.list" v-if="(item.tags == null || item.tags !== UUID) && showMine == false" v-bind:class="{'wait-accept': item.state >= 1 && item.state < 4}">
                      <td style="width: 50%; padding-left: 15px;"><div v-html="getOrderItemName(index)"></div><span v-if="item.memo != undefined && item.memo.length > 0"><br>*{{item.memo}}</span></td>
                      <td class="text-center"><span v-if="item.state < 1" v-on:click.stop="itemAmountChanged(-1, index)">
<!--                        <i class="fas fa-minus-circle"></i>-->
                        <img style="height: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-minus-gray-ic.png"/>
                      </span></td>
                      <td class="text-center">{{item.amount}}</td>
                      <td class="text-center"><span v-if="item.state < 1" v-on:click.stop="itemAmountChanged(1, index)">
<!--                        <i class="fas fa-plus-circle"></i>-->
                        <img style="height: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-plus-orange-ic.png"/>
                      </span></td>
                      <td class="text-right">{{Number(item.totalPrice/100).toFixed(2)}}</td>
                      <td class="text-right" style="padding-right: 15px;">
                        <span v-if="item.state < 1" v-on:click.stop="confirmDeleteItem(index)">
<!--                          <i class="fas fa-trash"></i>-->
                          <img style="height: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-x-gray-ic.png"/>
                        </span>
                        <span v-else-if="item.state == 1">
<!--                          <img src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/anim/anim-test.svg"/>-->
                          <div class="lds-dual-ring"></div>
                        </span>
                        <span v-else-if="item.state >= 4"><i class="fas fa-check"></i></span>
                      </td>

                    </tr>
                    </tbody>
                    <tbody v-if="order.list != undefined && order.list.length > 0">
                    <tr v-for="(item, index) in order.list"  v-if="item.tags != null && item.tags === UUID" v-bind:class="{'wait-accept': item.state >= 1 && item.state < 4}">
                      <td style="width: 50%;padding-left: 15px;"><div v-html="getOrderItemName(index)"></div><span v-if="item.memo != undefined && item.memo.length > 0"><br>*{{item.memo}}</span></td>
                      <td class="text-center"><span v-if="item.state < 1" v-on:click.stop="itemAmountChanged(-1, index)">
<!--                        <i class="fas fa-minus-circle"></i>-->
                        <img style="width: 24px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-minus-gray-ic.png"/>
                      </span></td>
                      <td class="text-center">{{item.amount}}</td>
                      <td class="text-center"><span v-if="item.state < 1" v-on:click.stop="itemAmountChanged(1, index)">
<!--                        <i class="fas fa-plus-circle"></i>-->
                        <img style="width: 24px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-plus-orange-ic.png"/>
                      </span></td>
                      <td class="text-right" style="font-weight: bold;">£{{Number(item.totalPrice/100).toFixed(2)}}</td>
                      <td class="text-right" style="position: relative;padding-right: 15px;">
                        <span v-if="item.state < 1" v-on:click.stop="confirmDeleteItem(index)">
<!--                          <i class="fas fa-trash"></i>-->
                          <img style="height: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-x-gray-ic.png"/>
                        </span>
                        <div v-else-if="item.state === 1" class="lds-dual-ring"></div>
<!--                          <object type="image/svg+xml" data="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/anim/anim-test.svg">-->
<!--                          <img src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/anim/anim-test.svg"/>-->
<!--                            </object>-->
<!--                          <div v-else-if="item.state == 1" class="spinner-container" id="container">-->
<!--                            <svg viewBox="0 0 100 100">-->
<!--                              <defs>-->
<!--                                <filter id="shadow">-->
<!--                                  <feDropShadow dx="0" dy="0" stdDeviation="1.5"-->
<!--                                                flood-color="#fc6767"/>-->
<!--                                </filter>-->
<!--                              </defs>-->
<!--                              <circle id="spinner-anim" style="fill:transparent;stroke:#dd2476;stroke-width: 7px;stroke-linecap: round;filter:url(#shadow);" cx="50" cy="50" r="45"/>-->
<!--                           </svg>-->
<!--                          </div>-->
                        <span v-else-if="item.state >= 4"><i class="fas fa-check"></i></span>
                      </td>

                    </tr>
                    </tbody>
                    <tr>
                      <td colspan="6">
                        <hr/>
                      </td>
                    </tr>
                    <tr class="text-right summary-row" v-if="Number(order.totalPrice) != Number(order.totalDue)">
                      <td colspan="4" class="text-left">Sub Total</td>
                      <td colspan="2" style="padding-right: 15px;">£{{Number(order.totalPrice/100).toFixed(2)}}</td>
                    </tr>
                    <tr class="text-right summary-row" v-if="order.serviceCharge > 0">
                      <td colspan="4" class="text-left">Service Charge ({{Number(order.serviceChargeRate/100).toFixed(1)}}%)</td>
                      <td colspan="2" style="padding-right: 15px;">£{{Number(order.serviceCharge/100).toFixed(2)}}</td>
                    </tr>
                    <tr class="text-right summary-row" style="font-weight: bold; color:red;" v-if="promotion != false && order.discountAmount > 0">
                      <td colspan="4" class="text-left">{{promotion.title}}</td>
                      <td colspan="2" style="padding-right: 15px;">£{{Number(order.discountAmount/100).toFixed(2)}}</td>
                    </tr>
                    <tr class="text-right summary-row" style="font-weight: bold; color:red;" v-if="order.pointsUsed > 0">
                      <td colspan="4" class="text-left">Redeemed</td>
                      <td colspan="2" style="padding-right: 15px;">{{order.pointsUsed}} {{points.unitTitle}}s</td>
                    </tr>
                    <tr class="text-right summary-row" v-if="type=='table' && showMine == true">
                      <td colspan="4" class="text-left">My Total</td>
                      <td colspan="2" style="padding-right: 15px;">£{{myTotal()}}</td>
                    </tr>
                    <tr class="text-right summary-row" v-if="type==='delivery'">
                      <td colspan="4" class="text-left">Delivery Charge</td>
                      <td colspan="2" style="padding-right: 15px;">£{{Number(order.deliveryCharge/100).toFixed(2)}}</td>
                    </tr>
                    <tr class="text-right total-price summary-row">
                      <td colspan="4" class="text-left"><span v-if="type==='table' && showMine == true">Table Total</span><span v-else>Total</span></td>
                      <td colspan="2" style="padding-right: 15px;">£{{Number(order.totalDue/100).toFixed(2)}}</td>
                    </tr>

                    <tr class="text-right summary-row" style="font-weight: bold; color: red;" v-if="type==='delivery' && order.totalDue < minOrder">
                      <td colspan="4" class="text-left">Min Order</td>
                      <td>{{Number(minOrder/100).toFixed(2)}}</td>
                    </tr>

                    <tr class="text-right summary-row" v-if="points != false && order.points > 0">
                      <td colspan="4" class="text-left">{{points.unitTitle}} you earn</td>
                      <td>{{order.points}}</td>
                    </tr>
                  </table>

                </div>

              </div>

              <template class="row" v-if="type === 'collection'">
                <div class="row">
                  <div class="col-12 text-left basket-section">
                    Date to collect <span class="mandatory-text">*</span>
                  </div>
                  <div class="col-12">
                    <select v-model="order.pickupDate" class="form-control" @change="onCollectionDateChanged">
                      <option value="">Select Date</option>
                      <option v-for="collectionDate in collectionTimeList" :key="'collection-date-selector-' + collectionDate.date" :value="collectionDate.date">{{collectionDate.dateLocale}}</option>
                    </select>
                  </div>
                  <div class="col-12 text-left basket-section">
                    Time to Collect <span class="mandatory-text">*</span>
                  </div>
                  <div class="col-12">
                    <select v-model="order.pickupTime" class="form-control">
                      <option value="">Select Time</option>
                      <option v-for="time in collectionDateTimeList" :key="'collection-date-time-selector-' + time.milliseconds" :value="time.timeLocale">{{time.timeLocale}}</option>
                    </select>
                  </div>
                  <div class="col-12 text-left basket-section">
                    Your Name <span class="mandatory-text">*</span>
                    <input type="text" class="form-control" v-model="order.name"/>
                  </div>
                  <div class="col-12 text-left basket-section">
                    Phone Number <span class="mandatory-text">*</span>
                    <select class="form-control" v-model="order.countryCode">
                      <option  v-for="(c, ci) in countryCodeList" v-bind:key="'collection-country-code-selector-option-' + ci" :value="c.mobileCode">
                        {{c.mobileCode}} ({{c.name}})
                      </option>
                    </select>
                    <input type="tel" class="form-control" v-model="order.phoneNumber"/>
                  </div>
                  <div class="col-12 text-left basket-section">
                    Email <span class="basket-section-description">(If you wish to receive update of your order)</span>
                    <input type="text" class="form-control" v-model="order.email"/>
                  </div>
                </div>
              </template>
              <template v-else-if="type === 'takeaway' || type === 'room' || type === 'delivery'">
                <div class="row">
                  <div class="col-12">
                    <div v-if="type === 'takeaway' || (type === 'delivery' && currentMerchantItem.boriumDelivery == 0 && showWebCardOption)">
                      <div class="basket-section" style="display: flex; justify-content: space-between; align-items: center;">
                        <span>
                          <span v-if="type=='delivery'">Delivery time</span><span v-if="type==='takeaway'">Pickup Time</span>
                          <span class="mandatory-text">*</span>
                        </span>
                        <span class="mandatory-text">*(Required)</span>
                      </div>
                      <select class="form-control" v-model="order.pickupTime">
                        <option v-for="slot in timeSlots" :value="slot">{{slot}}</option>
                      </select>
                    </div>
                    <div class="text-left" v-if="type === 'delivery'" style="margin-top: 20px;">
                      <strong>Estimated Delivery Time: {{order.pickupTime}}</strong>
                    </div>
                    <div class="text-left basket-section" id="none-table-head-count-input" v-if="currentMerchantItem.headCountMandatory != undefined && currentMerchantItem.headCountMandatory == 1">
                      How many people?<span class="mandatory-text">*</span>
                      <div class="head-count-stepper" v-bind:class="{'need-selection': order.headCount === null || order.headCount === 0}">
                        <span class="head-count-stepper-btn" v-on:click="changeHeadCount(-1)">
                          <img style="height: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-minus-gray-ic.png"/>
                        </span>
                        <span class="head-count-stepper-value">{{ order.headCount > 0 ? order.headCount : 'Select' }}</span>
                        <span class="head-count-stepper-btn" v-on:click="changeHeadCount(1)">
                          <img style="height: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-plus-orange-ic.png"/>
                        </span>
                      </div>
                    </div>
                    <div class="text-left basket-section" v-if="type=='delivery'" style="display: none;">
                      Post Code
                      <input type="text" class="form-control" v-model="order.postCode" disabled/>
                    </div>
                    <div class="text-left basket-section" v-if="type=='delivery'">
                      <template v-if="usePreEnteredAddress === true">
                        <span style="font-size: 20px; font-weight: bold;">To: {{order.address}}</span>
                      </template>
                      <template v-else>
                        <div class="basket-address-header">
                          <span>Address <span> ({{getDistanceString(distance)}})</span></span>
                          <span class="basket-address-change" v-on:click="searchAddress">Change</span>
                        </div>
                        <textarea rows="2" class="form-control" v-model="order.address" disabled/>
                      </template>
                    </div>
                    <div class="text-left basket-section" v-if="currentMerchantItem.cutlery != undefined && currentMerchantItem.cutlery == true">
                      How many sets of cutlery required?
                      <select class="form-control" v-model="order.cutleryCount">
                        <option value="0">Don't need</option>
                        <option v-for="n in 20" :value="n">{{n}}</option>
                      </select>
                    </div>
                    <template v-if="currentMerchantItem.lastSelections != undefined && currentMerchantItem.lastSelections != null && currentMerchantItem.lastSelections.length > 0">
                      <div class="text-left basket-section">Do you need?</div>
                      <ul class="list-group">
                        <template v-for="(lastItem, li) in currentMerchantItem.lastSelections">
                          <div class="list-group-item option-item"
                               :key="'last-product-' + li + '-' + lastItem.id"
                               v-bind:class="{'set-selected': lastItem.selected == true}"
                               v-on:click="toggleLastSelection(li, lastItem.id)">
                            {{lastItem.public_name != null && lastItem.public_name.length > 0 ? lastItem.public_name : lastItem.name}}
                          </div>
                        </template>
                      </ul>
                    </template>
                    <div class="text-left basket-section">
                      Your Name <span class="mandatory-text">*</span>
                      <input type="text" class="form-control" v-model="order.name"/>
                    </div>
                    <div class="text-left basket-section">
                      Phone Number <span class="mandatory-text">*</span>
                      <select class="form-control" v-model="order.countryCode">
                        <template v-for="(c, ci) in countryCodeList">
                          <option v-bind:key="'country-code-selector-option-' + ci" :value="c.mobileCode">
                            {{c.mobileCode}} ({{c.name}})
                          </option>
                        </template>
                      </select>
                      <input type="tel" class="form-control" v-model="order.phoneNumber"/>
                    </div>
                    <div class="text-left basket-section" v-if="type === 'delivery'">
                      Delivery Option
                      <select class="form-control" v-model="order.deliveryOption">
                        <option value="Leave at door">Leave at door</option>
                        <option value="Knock at door">knock at door</option>
                      </select>
                    </div>
                    <div class="text-left basket-section" v-if="type === 'delivery'">
                      Delivery Instruction to rider
                      <textarea class="form-control" rows="2" v-model="order.deliveryInstruction"></textarea>
                    </div>
                    <div class="text-left basket-section">
                      Email <span class="basket-section-description">(If you wish to receive update of your order)</span>
                      <input type="text" class="form-control" v-model="order.email"/>
                    </div>
                  </div>
                </div>
              </template>
              <div class="row" v-if="type=='table' && currentMerchantItem.headCountMandatory != undefined && currentMerchantItem.headCountMandatory == 1" id="table-head-count-input">
                <div class="col-12 text-left basket-section">
                  How many people? <span class="mandatory-text">*</span>
                  <div class="head-count-stepper" v-bind:class="{'need-selection': order.headCount === null || order.headCount === 0}">
                    <span class="head-count-stepper-btn" v-on:click="changeHeadCount(-1)">
                      <img style="height: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-minus-gray-ic.png"/>
                    </span>
                    <span class="head-count-stepper-value">{{ order.headCount > 0 ? order.headCount : 'Select' }}</span>
                    <span class="head-count-stepper-btn" v-on:click="changeHeadCount(1)">
                      <img style="height: 20px;" src="https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-plus-orange-ic.png"/>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-left basket-section" v-if="tableOrderable() == true && (currentMerchantItem.disableMemo == undefined || currentMerchantItem.disableMemo == 0)">
                  Memo <span class="basket-section-description">(Please tell us if you have any food allergy)</span>
                  <textarea class="form-control" rows="2" v-model="order.memo"></textarea>
                </div>
                <div class="col-12 text-left alcohol" style="font-size: small; padding-bottom:30px;" v-if="containAlcohol() == true">
                  <strong>Important!</strong><br>
                  Your order contains alcoholic product. You must be over 18.<br>
                  Staff will check your age and may ask your ID at <span>{{type=='table'?'serving':'food collection'}}</span>
                </div>
              </div>
              <div class="row" v-if="type==='table'">
                <template v-if="currentMerchantItem != false && currentMerchantItem.appMessage != null && currentMerchantItem.appMessage.length > 0">
                  <div class="col-12" style="padding-top:20px;padding-bottom:20px;" v-html="currentMerchantItem.appMessage"></div>
                </template>
                <div class="col-12 text-left" style="padding-bottom: 70px;">
                  Payment can be made after meal. Food can be ordered at any time before meal finished.
                </div>
              </div>
              <template v-if="preorder === true">
                <div class="row">
<!--                  <div class="col-12" style="padding-top:10px;">-->
<!--                    <button class="form-control btn btn-success" v-on:click="placeOrder('tillCash')">CASH PAYMENT</button>-->
<!--                  </div>-->
                  <div class="col-12" style="padding-top:10px;">
                    <CardSchemeLogos/>
                    <button class="form-control" :class="showTeyaOption ? 'teya-pay-button' : (showWebCardOption ? 'dojo-pay-button' : 'btn btn-danger')" v-on:click="placeOrder(showTeyaOption ? 'teya' : (showWebCardOption ? 'dojo' : 'stripe'))">{{ showTeyaOption ? 'PAY BY CARD' : (showWebCardOption ? 'Pay by card' : 'CARD PAYMENT') }}</button>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row" v-if="type === 'takeaway' && currentMerchantItem.taNotice !== undefined && currentMerchantItem.taNotice != null && currentMerchantItem.taNotice.length > 0">
                  <div class="col-12 basket-section text-left">
                    <strong>Notice</strong>
                    <div>
                      {{currentMerchantItem.taNotice}}
                    </div>
                  </div>
                </div>
                <div class="row" v-else-if="type === 'delivery' && currentMerchantItem.dlNotice !== undefined && currentMerchantItem.dlNotice != null && currentMerchantItem.dlNotice.length > 0">
                  <div class="col-12 basket-section text-left">
                    <strong>Notice</strong>
                    <div>
                      {{currentMerchantItem.dlNotice}}
                    </div>
                  </div>
                </div>
                <div class="row" v-bind:class="{'fixed-bottom': type ==='table'}" v-if="checkIfOpen() === true">
                  <template v-if="type === 'takeaway' || type === 'collection'">
                    <div v-if="acceptCash === true && (cashLimit === 0 || order.totalDue < cashLimit*100)" class="col-12" v-bind:class="{'col-12': acceptCash === false}" style="padding-top:10px;">
                      <div class="positive-button" v-on:click="placeOrder('tillCash')">{{cashBtnTitle}}</div>
                    </div>
                    <div v-if="showWebCardOption || showTeyaOption || showStripeOption" class="col-12">
                      <CardSchemeLogos/>
                    </div>
                    <div v-if="showWebCardOption" class="col-12" style="padding-top:10px;">
                      <div class="positive-button dojo-pay-button" v-on:click="placeOrder('dojo')">Pay by card</div>
                    </div>
                    <div v-if="showTeyaOption" class="col-12" style="padding-top:10px;">
                      <div class="positive-button teya-pay-button" v-on:click="placeOrder('teya')">PAY BY CARD</div>
                    </div>
                    <div v-if="showStripeOption" class="col-12" style="padding-top:10px;">
                      <div class="positive-button" v-on:click="placeOrder('stripe')">{{stripeBtnTitle}}</div>
                    </div>

                  </template>
                  <template v-else-if="type === 'delivery'">
                    <template v-if="distanceOk === true || usePreEnteredAddress === true">
                      <div v-if="order.totalDue < minOrder" class="col-12" style="padding-top:10px;">
                        <button class="form-control btn btn-secondary">Min £{{Number(minOrder/100).toFixed(2)}}</button>
                      </div>
                      <template v-else>
                        <div v-if="acceptCash === true && (cashLimit === 0 || order.totalDue < cashLimit*100)" class="col-12" style="padding-top:10px;">
                          <button class="form-control btn btn-primary" v-on:click="placeOrder('tillCash')">Pay at Delivery</button>
                        </div>
                        <div v-if="showWebCardOption || showTeyaOption || showStripeOption" class="col-12">
                          <CardSchemeLogos/>
                        </div>
                        <div v-if="showWebCardOption" class="col-12" style="padding-top:10px;">
                          <button class="form-control dojo-pay-button" v-on:click="placeOrder('dojo')">Pay by card</button>
                        </div>
                        <div v-if="showTeyaOption" class="col-12" style="padding-top:10px;">
                          <button class="teya-pay-button" v-on:click="placeOrder('teya')">PAY BY CARD</button>
                        </div>
                        <div v-if="showStripeOption" class="col-12" style="padding-top:10px;">
                          <button class="form-control btn btn-primary" v-on:click="placeOrder('stripe')">{{stripeBtnTitle}}</button>
                        </div>
                      </template>
                    </template>
                    <div v-if="distanceOk === false && usePreEnteredAddress === false" class="col-12">
                      <button class="form-control btn btn-danger" v-on:click="searchAddress">Change Address</button>
                    </div>
                  </template>
                  <template v-else-if="type==='table'">
                    <div class="col-12">
                      <div v-if="checkBeforeLastOrder() === false" class="eemo-yellow eemo-btn" style="margin-top:20px;padding-top:20px;padding-bottom: 20px; background-color: grey;">
                        Kitchen Closed
                      </div>
                      <div class="positive-button" v-else-if="tableOrderable() === true" v-on:click="askTableOrderTable">
                       Place Order
                      </div>
                      <div v-else-if="currentMerchantItem.useBillBtn === true && canSensBillRequest() === true" class="eemo-yellow eemo-btn" style="margin-top:20px;padding-top:20px;padding-bottom: 20px; background-color: #3FADF1; color:white;" v-on:click="sendBillRequest">
                        <span><i class="fas fa-receipt"></i></span> Request Bill
                      </div>

                    </div>
                  </template>
                </div>
                <div class="row" v-else>
                  <div class="col-12">
                    <div class="elapsed-text-box" style="background: #feeb48">
                      Closed
                    </div>
                  </div>
                </div>
              </template>
              <div v-if="(type === 'takeaway' || type === 'delivery' || type === 'collection') && currentMerchantItem != false" class="basket-footer">
                <Bottom :item="currentMerchantItem"></Bottom>
              </div>
            </div>
          </div>
          <div class="float-back" v-on:click="closeTop"><i class="fas fa-chevron-left"></i></div>
        </div>
      </transition>
      <transition name="vertical">
        <div class="background-page level-popup popup-background" v-if="showTableOrderConfirm == true">
          <div class="popup-container">
            <div class="container">
              <div class="col-12 text-center">
                <span><img class="popup-logo" src="https://storage.googleapis.com/menus-275719.appspot.com/logos/SMTM-logo_300x300.png"/></span>
              </div>
              <div class="row">
                <div class="col-12" style="padding-bottom: 20px; font-weight: bold">
                  Please let us know if you have any Allergy and inquiry
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  Is everyone on your table ready to place order?<br>Placing order together will help our kitchen prepare better.
                </div>

              </div>
              <div class="row" style="margin-top:20px;">
                <div class="col-6 dialog-btn" v-on:click="waitForTableOrder">
                  <div class="positive-button negative-button">I will wait</div>
                </div>
                <div class="col-6 dialog-btn" v-on:click="placeTableOrder">
                  <div class="positive-button">Yes, Place Order</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="vertical">
        <div class="background-page level-4 popup-background" v-if="showHistory == true && orderHistory != null && orderHistory.length > 0" >
          <div class="floating-container eemo-gray">
            <div id="history-container" class="container h-100" style="overflow-y: scroll; padding-top:10px; padding-bottom: 10px;">
              <div class="row">
                <div class="col-12 big-name">
                  <span style="float:left" v-on:click="closeTop"><i class="fas fa-arrow-left"></i></span>Your Orders
                </div>
              </div>
              <div class="row" v-for="(h, index) in orderHistory" :id="'history-item-' + h.id">
                <div class="col-12">
                  <div class="order-item-container" :class="'order-status-' + h.state">
                    <div class="order-item-merchant">#{{h.id}} {{h.merchantName}}</div>
                    <template v-if="h.state >= 0">
                      <div class="order-item-merchant-info" v-if="h.merchantInfo != undefined && h.merchantInfo != null">
                        <div v-if="h.merchantInfo.merchantAddress != undefined && h.merchantInfo.merchantAddress != null" v-html="h.merchantInfo.merchantAddress.replace(/\n/g, '<br>')"></div>
                        <div v-if="h.merchantInfo.contact != undefined && h.merchantInfo.contact != null"><a :href="'tel:'+ h.merchantInfo.contact">{{h.merchantInfo.contact}}</a></div>
                      </div>
                      <hr>
                      <div class="order-item-title">Order Time: {{new Date(h.createdTimestamp).toLocaleString()}}</div>
                      <p v-if="h.state > 1 && h.state < 5 && h.pickupTime != null && h.pickupTime.length > 0"><strong>Pickup Time:</strong> {{h.pickupTime}}</p>
                      <div class="order-item-status"><strong>Status</strong></div>
                      <div class="lds-ring" v-if="h.state == 0"><div></div><div></div><div></div><div></div></div>
                      <div v-html="getOrderStateString(h.state, h.recordType, h.merchantName)"></div>
                      <qrcode-vue v-if="h.salesReference != null && h.salesReference.length == 12 && h.state >= 4 && h.state < 6":value="h.salesReference" :size="150" level="H"></qrcode-vue>
                      <div class="order-item-message-to-confirm" v-if="h.state == 1">

                        <p>{{h.message}}</p>
                        <button class="btn btn-primary" v-on:click="acceptChange(h)">Accept</button>
                        <button class="btn btn-danger" v-on:click="cancelChange(h)">Cancel</button>
                      </div>

                      <div class="order-item-description">
                        <div class="order-section-title">Order details</div>
                        <table class="table">
                          <tr v-for="order in h.list">
                            <td>{{getHistoryOrderItemName(order)}} x {{order.amount}}<span v-if="order.memo != null && order.memo.length > 0"><br>Memo:{{order.memo}}</span></td>
                            <td class="text-right">£{{(order.totalPrice/100).toFixed(2)}}</td>
                          </tr>
                          <tr v-if="h.deliveryCharge > 0">
                            <td>Delivery Charge</td>
                            <td class="text-right">£{{(h.deliveryCharge/100).toFixed(2)}}</td>
                          </tr>
                        </table>

                      </div>
                      <div v-if="h.memo != null && h.memo.length > 0">Memo: {{h.memo}}</div>


                      <div v-if="h.postCode != null && h.postCode.length > 0">{{h.postCode}}</div>
                      <div v-if="h.address != null && h.address.length > 0" v-html="h.address.replace(/\n/g, '<br>')"></div>
                      <div class="order-item-price">£{{((h.totalDue/100).toFixed(2))}}</div>
                      <div v-if="points != false && h.points > 0">
                        {{h.points}} {{points.unitTitle}}
                      </div>
                    </template>
                    <template v-else>
                      <div v-if="h.state < 0 && (h.paymentMethod === 'webCard' || h.paymentMethod === 'paymentSense' || h.paymentMethod === 'paymentsense' || h.paymentMethod === 'dojo')" style="color:red;"><strong>Payment Failed (Code: {{h.state}})</strong></div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="float-back" v-on:click="closeTop"><i class="fas fa-chevron-left"></i></div>
        </div>
      </transition>
      <transition name="vertical">
        <div class="background-page level-3 popup-background" style="padding-top:100px" v-if="newPreOrder != false">
          <div class="floating-container" style="background-color:white">
            <div class="container h-100" style="overflow-x: scroll; padding-top:10px; padding-bottom: 10px;">
              <div class="row">
                <div class="col-12">
                  <h3>New PreOrder Session</h3>
                  <h4>{{currentMerchantItem.title}}</h4>
                  <p>Please enter your name or group name and contact number</p>
                </div>
              </div>
              <div class="row" style="margin-top:50px;">
                <div class="col-12">
                  <input class="form-control" type="text" v-model="newPreOrder.name" placeholder="name / group name"/>
                </div>
              </div>

              <div class="row" style="margin-top:20px;">
                <div class="col-12">
                  <input class="form-control" type="text" v-model="newPreOrder.phoneNumber" placeholder="Phone number"/>
                </div>
              </div>

              <div class="row" style="margin-top:100px;">
                <div class="col-12">
                  <button class="btn btn-success" v-on:click="createNewPreSession">CREATE SESSION</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="background-page level-popup popup-background" v-if="showPostCodeInput == true">
        <div class="address-finder-container">
          <div class="container" style="position: sticky; top:0; z-index:2; background-color: #B5DBFF; padding-bottom:10px;">
            <div class="row">
              <div class="col-12 text-left" style="font-size: 20px; height: 60px; line-height:60px;">
                Delivery Address
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <input type="text" class="form-control text-center" v-model="postCodeSearchWord" placeholder="POST CODE" @input="postCodeSearchWord = $event.target.value.toUpperCase()" v-on:keyup.enter="getAddressCandidates"/>
              </div>
              <div class="col-6">
                <button class="btn btn-primary form-control" v-on:click="getAddressCandidates"><i class="fas fa-search"></i> Find</button>
              </div>
            </div>

            <div class="row" v-if="selectedCandidate != null && selectedCandidate.length > 0" style="">
              <div class="col-12 text-left" style="padding-top:10px;">
                <div style="border: 1px solid gray; padding:10px; border-radius: 5px; background-color: #D1E9FF;">
                  {{selectedCandidate}}
                </div>
              </div>
              <div class="col-12 text-left" style="padding-top:10px; padding-bottom:10px;">
                <button class="btn btn-dark" v-on:click="processAddress">Use This Address</button>
              </div>
            </div>
          </div>
          <div class="container" v-if="addressCandidates.length > 0">
            <div class="row">
              <div class="col-12 text-left" v-for="can in addressCandidates" v-bind:key="'postcode-candidate-' + can.summaryline">
                <div class="address-candidate" v-on:click="selectCandidate(can.summaryline)">
                {{can.summaryline}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="background-page level-popup popup-background" v-if="false">
        <div class="popup-container">
          <div class="container">
            <div class="row">
              <div class="col-12 text-left" style="margin-top: 20px;">

                <h6>Please search your address for delivery</h6>

              </div>
              <div class="col-12" style="margin-top:20px;">
                <vue-google-autocomplete
                  v-if="address == false"
                  id="address-searcher"
                  :country="['uk']"
                  classname="form-control"
                  placeholder="Type Road Name"
                  v-on:placechanged="getAddressData"
                >
                </vue-google-autocomplete>

              </div>
              <div class="col-12 text-left" style="margin-top:20px;" v-if="address != false">
                {{address.text}}
<!--                <div class="col-12 text-left" style="margin-top: 20px;">-->
<!--                  Street/Flat Number-->
<!--                  <input type="text" class="form-control" v-model="address.streetNumber"/>-->
<!--                </div>-->
<!--                <div class="col-12 text-left">-->
<!--                  <div class="address-line" v-for="(ac, index) in address.address_components" v-if="address.streetName != '' && >-->
<!--                    {{ac.long_name}}-->
<!--                  </div>-->
<!--                </div>-->



              </div>
<!--              <div class="col-12" style="margin-top: 20px;">-->
<!--                <input type="text" class="form-control text-center" v-model="postCode" @input="postCode = $event.target.value.toUpperCase()"/>-->
<!--              </div>-->

            </div>
            <div class="row" v-if="address != false">
              <div class="col-6" style="margin-top: 40px;">
                <div  v-on:click="startAddressSearch" class="search-btn" style=""><i class="fas fa-search"></i> Search</div>
              </div>
              <div class="col-6" style="margin-top: 40px;">
                <div class="search-btn" style="background-color: blue;" v-on:click="onPostCodeEntered">OK</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12" style="margin-top: 40px;">
                <span v-if="minOrder > 0">Minimum Order is £{{(minOrder/100).toFixed(2)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="background-page level-popup" style="background-color: rgba(0,0,0,0.7);" v-if="advertImage != false" v-on:click="closeAdvert">
        <div class="popup-container" style="padding:0; border-radius: 10px; overflow: hidden;">
          <img :src="advertImage" style="width: 100%" v-on:click.stop="doNothingOnClick"/>
          <div style="width: 100%;height: 50px; line-height: 50px; background: white;" class="text-center" v-on:click.stop="closeAdvert">
            CLOSE
          </div>

        </div>
      </div>
      <div class="background-page level-popup" style="background-color: rgba(0,0,0,0.7);" v-if="customerNotification != false" v-on:click="customerNotification = false">
        <div class="popup-container" style="position: absolute; width: calc(100% - 30px); max-width: 460px; height: 90%; max-height: 90%; top: 50%; left: 50%; transform: translate(-50%, -50%);  padding:0; border-radius: 10px; overflow: hidden;">
          <div style="width: 100%; height: 50px; line-height: 50px; font-size: 20px; font-weight: bold; border-bottom: 1px solid #b2b2b2;">
            {{customerNotification.title}}
          </div>
          <div style="width: 100%; height: calc(100% - 100px); overflow-y: auto;">
            <div v-html="customerNotification.content"></div>
          </div>
          <div style="width: 100%;height: 50px; line-height: 50px; background: white; border-top: 1px solid #b2b2b2;" class="text-center" v-on:click.stop="customerNotification = false">
            CLOSE
          </div>

        </div>
      </div>
      <div class="background-page level-popup popup-background" v-if="popup.show == true" v-on:click="clickedOnBackground">
        <div class="popup-container">
          <div class="container">
            <div class="row">
              <div class="col-12 text-center">
                <span v-if="popup.icon !== undefined && popup.icon !== null && popup.icon.length > 0">
                  <img class="popup-logo" :src="popup.icon"/>
                </span>
                <span v-else><img class="popup-logo" src="https://storage.googleapis.com/menus-275719.appspot.com/logos/SMTM-logo_300x300.png"/></span>
              </div>
              <div class="col-12 popup-title" style="margin-top: 10px;">
                {{popup.title}}
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p v-html="popup.message"></p>
              </div>
            </div>
            <div class="row" style="padding-bottom: 20px;">
              <div class="col-6"  v-if="popup.noBtnTitle.length > 0" v-on:click.stop="clickedOnNo">
                <div class="positive-button negative-button">
                  {{popup.noBtnTitle}}
                </div>
              </div>
              <div class="col-6"  v-if="popup.yesBtnTitle.length > 0" v-on:click.stop="clickedOnYes">
                <div class="positive-button">
                {{popup.yesBtnTitle}}
                </div>
              </div>
              <div class="col-12" v-if="popup.closeBtnTitle !== undefined && popup.closeBtnTitle.length > 0" v-on:click.stop="intialisePopup">
                <div class="smtm-btn">{{popup.closeBtnTitle}}</div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="background-page level-popup popup-background" v-if="redeemables != false && redeemables.length > 0" v-on:click="closeRedeemManual">
        <div class="popup-container">
          <div class="container text-left">
            <div class="row">
              <div class="col-12">
                <h5><strong>You have {{userPoint.balance}} {{points.unitTitle}}s!!!</strong></h5>
              </div>
            </div>
            <div class="row">
              <hr>
              <div class="col-12">
                Look at menu with {{points.unitTitle}}s next to price
                <div style="border:1px solid grey;margin-top:10px;margin-bottom: 10px;">
                  <img src="/static/img/redeemable.png" width="100%;"/>
                </div>
              </div>
              <div class="col-12">
                Select the menu and click "Redeem" button
                <div style="border:1px solid grey;margin-top:10px;margin-bottom: 30px;">
                  <img src="/static/img/redeem.png" width="100%;"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <button class="btn btn-dark form-control" v-on:click.stop="closeRedeemManual">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="background-page level-popup popup-background" v-if="stripeCardPayment != false">
      <div class="popup-container">
        <div class="container">
          <div class="row">
            <form>
              <input type="text" placeholder="Credit Card #" v-model="stripeCardPayment.cardNumber">
              <input type="text" placeholder="Expiration Month" v-model="stripeCardPayment.expMonth">
              <input type="text" placeholder="Expiration Year" v-model="stripeCardPayment.expYear">
              <input type="text" placeholder="CVC" v-model="stripeCardPayment.cvc">
              <button v-on:click="chargeCreditCard">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-background" v-if="isLoading">
      <div class="wrapper">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <span>{{loadingMessage}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import EventBus from "../api/event-bus";
  import VueTimepicker from 'vue2-timepicker';
  import 'vue2-timepicker/dist/VueTimepicker.css';
  import {getCountryCodeList, millisToDate, millisToReadable} from "../api/utils";
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  import Bottom from "./Bottom";
  import CardSchemeLogos from "./CardSchemeLogos";
  require('@/assets/css/styles.css')
  require('@/assets/css/transitions.css')
  const axios = require('axios');
  import {
    getMerchant,
    getMerchantMenus,
    getTableMerchant,
    submitOrder,
    getDojoPaymentConfigStatus,
    getTeyaPaymentConfigStatus,
    getMyOrder,
    updateMyOrder,
    getDistance,
    getDeliveryAddresses,
    getUserPoint,
    updatePaymentItem,
    addItemsToTable,
    getTablePendingOrder,
    submitTableOrder,
    deleteTableItem,
    updateTableItem,
    submitLog,
    getPreOrder,
    createNewPreOrder,
    addPreOrderItem,
    updatePreOrder,
    deletePreOrderItem, sendTableRequest, getMerchantPermalink, getCollectionTimeSlots, getMerchantSettings
  } from "../api/borium";
  import QrcodeVue from 'qrcode.vue'
  import { Slider, SliderItem } from 'vue-easy-slider'
  import {millisToHM} from "../api/utils";
  import Router from '../router';
  export default {
    name: "Restaurant",
    data() {
      return {
        currentPath:'',
        basePath:'',
        animDuration: 300,
        canTakeOrder:false,
        // connectE: null,
        mqtt:null,
        topics:[],
        images:[],
        restaurantSliderIndex: 0,
        restaurantSliderTimer: null,
        restaurantSliderImageTimeout: 3000,
        mqttDisconnect: false,

        currentMode: 0, //테이크아웃: 0, 방문예약: 1, 자동주문예약: 2, QR코드주문: 3

        merchantId:0,
        tableItem: false,
        tableTags:[],
        currentMerchantItem: false, //매장정보

        searchWord:'',
        bookingItem: false, //예약상세

        orderItem: false, //주문상세


        merchants:[],
        order:false,
        selectOrderItem: false,
        optionSelectItem: false,
        setSelectItem: false,


        popup: {
          show:false,
          title:"",
          message:'',
          noBtnTitle:'',
          yesBtnTitle:'',
          noCb:null,
          yesCb:null,
          bgCb:null,

        },
        orderHistory:[],
        type:'dinein',
        showBasket: false,
        orderItemToPay: false,
        showHistory: false,
        timeSlots:[],
        preScrollPosition: 0,
        postCode:'',
        showPostCodeInput:false,
        distance:0,
        openingTime:false,
        deliveryTime:false,
        isOpen: false,
        slots: [],
        isShopOpen:false,
        shopSlots:[],
        interval:15,
        taDelay:30,
        deliveryDelay:45,
        deliveryTimePerMile:5,
        delayTime:0,
        lastOrder: 30,
        lastTableOrder:0,
        lastTableOrderMessage:'',
        lastDeliveryOrder:45,
        additionalDelayPrice: 10000,
        additionalDelay:10,
        minOrder:0,
        conditionalMinOrder:0,
        acceptCash:true,
        acceptCard:false,
        cashLimit:0,
        acceptStripe: false,
        /** True when the venue has a Dojo secret key for hosted checkout. */
        dojoPaymentReady: false,
        /** True when Teya Hosted Checkout is enabled with client id, secret and store id (see /order/teya/config). */
        teyaPaymentReady: false,
        cashBtnTitle:'CASH',
        cardBtnTitle:'CARD',
        stripeBtnTitle:'CARD',
        enableTakeaway: true,
        enableDelivery: true,
        promotions:[],
        promotion:false,
        points:false,
        userPoint:false,
        cardPayItem:false,

        distanceChargeList:[],
        deliveryPriceByDistance:false,
        fixedDeliveryCharge: 0,
        /** Estimated driving time in seconds from the Google Directions response (0 = unknown). */
        travelDurationSeconds: 0,
        deliveryChargeType: 0,
        deliveryChargeAmount: 0,
        freeDeliveryOver: 0,
        deliveryBaseCharge: 0,
        deliveryChargePerMilePrice: 0,
        limitType: 'distance',

        isLoading:false,
        loadingMessage:'',
        position: {
          lat:0,
          lng:0,
        },
        UUID:'',
        count:0,
        showMine:false,
        showTableOrderConfirm: false,
        toLeave: false,

        advertImage:false,

        customerNotification: false,
        redeemables:[],
        redeemableManualSeen:false,
        stripeCardPayment: false,
        stripe:false,

        lastCount:0,

        address:false,
        distanceOk:false,
        postCodeSearchWord:'',
        addressCandidates:[],
        selectedCandidate:'',
        showLog:false,
        postCodeList:[],

        preorder:false,
        orderId:0,

        newPreOrder:false,
        useSession:false,
        sessionAuthorised:true,
        sessionId:0,
        additionalOffSet:0,
        takeRoomNumber:false,
        usePreEnteredAddress:false,
        countryCodeList:getCountryCodeList(),
        collectionTimeList:[],
        collectionDateTimeList:[],
        collectionTag:'',
      }
    },
    components: {
        VueTimepicker,
        QrcodeVue,
        Slider,
        SliderItem,
        Bottom,
        CardSchemeLogos,
      VueGoogleAutocomplete
    },
    // beforeRouteUpdate(to, from, next) {
    //   // console.log("beforeRouteUpdate");
    //   // console.log("beforeRouteUpdate");
    //   // if(this.$data.toLeave == false) {
    //   //   if (this.backPressed() == true) {
    //   //     next(false);
    //   //   } else {
    //   //     next();
    //   //   }
    //   // }
    // },
    // beforeRouteLeave(to, from, next) {
    //   // console.log("beforeRouteUpdate");
    //   // if(this.$data.toLeave == false) {
    //   //   if (this.backPressed() == true) {
    //   //     console.log("back key handled");
    //   //     next(false);
    //   //   } else {
    //   //     console.log("move to home");
    //   //     next();
    //   //   }
    //   // }
    // },
    created() {
      //console.log("created");

      if(this.$route.query.hasOwnProperty('error-view')) {
        this.$router.push('error-view');
        return;
      }
      this.$data.currentPath = this.$route.fullPath;
      this.$data.basePath = this.$route.fullPath;
      // console.log("base path");
      // console.log(this.$data.basePath);
      // console.log("URL: " + window.location.host)
      registerBackKeyHandler(this.backPressed);
      EventBus.$off('backPressed', this.backPressed);
      EventBus.$on('backPressed', this.backPressed);
      EventBus.$emit("modeChanged", 1);
      this.connect();
    },
    beforeRouteEnter(to, from, next) {
      // console.log("From " + from);
      // console.log(from);
      next(vm => {
        vm.prevRoute = from;
      });
    },
    destroyed() {
      // console.log("Destoryed");
      if (this.restaurantSliderTimer !== null) {
        clearTimeout(this.restaurantSliderTimer);
        this.restaurantSliderTimer = null;
      }
      this.disconnect();
    },
    mounted() {
      // registerBackKeyHandler(this.backPressed);

      this.getUUID();
      this.updatePage();
      $("#nav-top").addClass("transparent-background");
      // const plugin = document.createElement("script");
      // plugin.setAttribute(
      //   "src",
      //   "https://web.e.test.connect.paymentsense.cloud/assets/js/client.js"
      // );
      // plugin.async = true;
      // document.head.appendChild(plugin);
    },
    // beforeDestroy() {
    //   // console.log("breforeDestroy");
    //   registerBackKeyHandler(false);
    //   // registerBackKeyHandler(false);
    //   // document.removeEventListener("backbutton", this.backPressed);
    //   EventBus.$off('backPressed', this.backPressed);
    //   this.disconnect();
    // },
    watch: {
        $route() {
            // console.log("route changed");
            if(this.$data.basePath === this.$route.fullPath) {
              this.backPressed();
            }
            // this.updatePage();
        },
        'order.memo': function (newVal, oldVal) {
          if (this.$data.order == false) {
            return;
          }
          if (newVal.includes('"') || newVal.includes("'")) {
            this.$data.order.memo = newVal.replace('"', '').replace("'", "");
            window.alert("Cannot accept special characters")
          }
          var ranges = [
            '(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])' // U+1F680 to U+1F6FF
          ];
          if(this.$data.order.memo.match(ranges.join('|'))) {
            window.alert("Emoji cannot be used");
            var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
            this.$data.order.memo = this.$data.order.memo.replace(regex, '');
          }

        },
        'optionSelectItem.memo': function (newVal, oldVal) {
          if (this.$data.optionSelectItem == false) {
            return;
          }
          if (newVal.includes('"') || newVal.includes("'")) {
            this.$data.optionSelectItem.memo = newVal.replace('"', '').replace("'", "");
            window.alert("Cannot accept special characters")
          }
          var ranges = [
            '(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])' // U+1F680 to U+1F6FF
          ];
          if(this.$data.optionSelectItem.memo.match(ranges.join('|'))) {
            window.alert("Emoji cannot be used");
            var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
            this.$data.optionSelectItem.memo = this.$data.optionSelectItem.memo.replace(regex, '');
          }
        }
    },
    computed: {
      /** Dojo hosted checkout when Teya Hosted Checkout is not configured. */
      showWebCardOption: function() {
        if (this.teyaPaymentReady === true) {
          return false;
        }
        return this.dojoPaymentReady === true;
      },
      /** Stripe checkout only when allowed and Dojo / Teya are not taking priority. */
      showStripeOption: function() {
        return this.acceptStripe === true && this.dojoPaymentReady !== true && this.teyaPaymentReady !== true;
      },
      /** Teya Hosted Checkout replaces Card when dashboard Teya online payment is ready. */
      showTeyaOption: function() {
        return this.teyaPaymentReady === true;
      },
      deliveryAddressText: function() {
        if (this.order != false && this.order.address) {
          return this.order.address;
        }
        if (this.address && this.address !== false) {
          return this.address;
        }
        return '';
      },
      deliveryTravelTimeText: function() {
        var seconds = Number(this.travelDurationSeconds);
        if (!isFinite(seconds) || seconds <= 0) {
          return '';
        }
        var mins = Math.max(1, Math.round(seconds / 60));
        return '~' + mins + ' mins';
      },
      showDeliveryAddressBar: function() {
        if (this.type !== 'delivery') {
          return false;
        }
        if (this.showBasket === true || this.showPostCodeInput === true) {
          return false;
        }
        if (this.optionSelectItem != false || this.setSelectItem != false) {
          return false;
        }
        if (this.distanceOk !== true) {
          return false;
        }
        return this.deliveryAddressText.length > 0;
      },
    },
    methods:{
      refreshDojoPaymentReady: function() {
        var self = this;
        var m = this.$data.currentMerchantItem;
        if (!m || !m.merchantId) {
          this.$data.dojoPaymentReady = false;
          this.$data.teyaPaymentReady = false;
          return;
        }
        getDojoPaymentConfigStatus(m.merchantId)
          .then(function(cfg) {
            self.$data.dojoPaymentReady = !!(cfg && cfg.success && cfg.item && cfg.item.ready === true);
          })
          .catch(function() {
            self.$data.dojoPaymentReady = false;
          });
        this.refreshTeyaPaymentReady();
      },
      refreshTeyaPaymentReady: function() {
        var self = this;
        var m = this.$data.currentMerchantItem;
        if (!m || !m.merchantId) {
          this.$data.teyaPaymentReady = false;
          return;
        }
        getTeyaPaymentConfigStatus(m.merchantId)
          .then(function(cfg) {
            self.$data.teyaPaymentReady = !!(cfg && cfg.success && cfg.item && cfg.item.ready === true);
          })
          .catch(function() {
            self.$data.teyaPaymentReady = false;
          });
      },
      startAddressSearch: function() {
        this.$data.address = false;
      },

      getAddressData: function (addressData, placeResultData, id) {
        // console.log("address data " + addressData);
        // console.log(addressData);
        // console.log(placeResultData);
        this.$data.address = placeResultData;

        // console.log("address now " + this.$data.address);
        // console.log(this.$data.address);
        if(addressData.latitude != undefined) {
          this.$data.address.lat = addressData.latitude;
        }
        if(addressData.latitude != undefined) {
          this.$data.address.lat = addressData.latitude;
        }
        if(addressData.postal_code != undefined) {
          this.$data.address.postCode = addressData.postal_code;
        } else {
          this.$data.address.postCode = '';
        }
        if(addressData.street_number != undefined) {
          this.$data.address.streetNumber = addressData.street_number;
        } else {
          this.$data.address.streetNumber = '';
        }
        if(addressData.route != undefined) {
          this.$data.address.route = addressData.route;
        } else {
          this.$data.address.route = '';
        }



        let el = document.getElementById("address-searcher");
        if(el != null && el != undefined) {
          // console.log("Address " + el.value);
          this.$data.address.text = el.value;
        }


      },
      getUUID: function() {
        if(localStorage.getItem("UUID") == null) {
          let uuid = new Date().getTime();
          localStorage.setItem("UUID", uuid);
        }
        this.$data.UUID = localStorage.getItem("UUID");
      },
      onSearchFocused: function() {
        // console.log("on focused");
        $("#menu-page").animate({scrollTop : 150}, 300);
      },
      onCatClicked: function(index) {
        let catDiv = document.getElementById("cat-" + index);
        if(catDiv != null) {
          // console.log(catDiv.offsetLeft);
          let container = document.getElementById("cat-container");
          $("#cat-container").animate({scrollLeft : catDiv.offsetLeft -15}, 300);
          // container.scrollLeft = catDiv.offsetLeft -15;
        }

        let id = "category-title-" + this.$data.currentMerchantItem.categories[index].id;


        let containerDiv = document.getElementById(id);
        // console.log("offset top " + containerDiv.offsetTop);
        let diff = 0;
        // if(containerDiv.offsetTop > 325) {
          diff = 340 + this.$data.additionalOffSet;
        // }
        if(containerDiv != null) {
          $("#menu-page").animate({scrollTop : containerDiv.offsetTop + diff}, 300);
          // containerDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // console.log("scroll");
        }


      },
      registerBackHandler: function() {
        let self = this;
        // console.log("register back handler");
        this.$router.beforeEach((to, from, next) => {
          // ...
          // console.log("router guard");
          if(self.backPressed() == true) {
            next(false);
          } else {
            next('/home');
          }
        })
      },
      deregisterBackHanlder: function() {
        // console.log("Deregister back handler");
        // let self = this;
        // this.$router.beforeEach((to, from, next) => {
        //   console.log("unregisterRouterGuard")
        //   self.backPressed()
        //
        //   next()
        // })
      },
      getHistory: function() {
         // console.log("getHistory");
          if(localStorage.getItem("tel") != null && localStorage.getItem("tel").length == 11) {
              let self = this;
              getMyOrder(localStorage.getItem("tel"), this.$data.currentMerchantItem.merchantId)
              .then(function(data) {
                  // console.log("my order list ");
                  // console.log(data);
                  if(data.success == true) {
                      for(let i = 0 ; i < data.item.length ; i++) {
                          // console.log(data.item[i])
                          if(data.item[i].title != null && data.item[i].title.length > 0) {
                              data.item[i].merchantInfo = JSON.parse(data.item[i].title);
                          }
                      }
                      self.$data.orderHistory = data.item;

                  }
              })
              .catch(function(err) {
                  // console.log(err);
                  // if(err.response != undefined) {
                  //   console.log(err.response);
                  // }
              })
              this.subscribe(localStorage.getItem("tel"));
          } else {
              // console.log("getHistory no tel");
          }


      },
      updatePage: function() {
        let self = this;
        if(this.$route.query.hasOwnProperty("debug")) {
          // console.log("enable debug");
          this.$data.showLog = true;
        }
        if(this.$route.query.hasOwnProperty("collectionTag")) {

          this.$data.collectionTag = this.$route.query.collectionTag;
        } else {
          this.$data.collectionTag = null;
        }
        if(this.$route.params.hasOwnProperty('permalink')) {
          let type = this.$route.params.type;
          this.$data.type = type;
          getMerchantPermalink(this.$route.params.permalink, type)
            .then(function(data) {
              if(data.success === true) {


                if (data.table !== undefined) {
                  self.$data.tableItem = data.table;
                  self.$data.merchantId = data.table.subscription_id;
                }
                self.merchantSelected(data.item);
                // console.log("call gethistory")
                self.getHistory();
              } else {
                console.error('Request failed');
              }
            })
            .catch(function(err) {
              console.error('Request failed', err && err.response ? err.response.status : '');
            })

        } else if(this.$route.params.hasOwnProperty('type') && this.$route.params.type == 'table') {
            this.$data.type = 'table';
            getTableMerchant(this.$route.params.id)
              .then(function(data) {
                // console.log("table response");
                // console.log(data);
                if (data.success == true) {
                  self.$data.tableItem = data.table;
                  // console.log("Table Tag");

                  if (data.table.tags != null && data.table.tags.length > 0) {
                    self.$data.tableTags = data.table.tags.splice(',');
                  }
                  self.merchantSelected(data.item);
                  self.getPendingTable();
                }
              })
              .catch(function(err) {

              })
          } else  if(this.$route.params.hasOwnProperty('id') || this.$route.query.hasOwnProperty('id')) {
              if(this.$route.params.hasOwnProperty('id')) {
                // console.log("Params " + this.$route.params.id);
                this.$data.merchantId = this.$route.params.id;
              } else if(this.$route.query.hasOwnProperty('id')) {
                this.$data.merchantId = this.$route.query.id;
                // console.log("Query " + this.$route.query.id);
              }


              let type = null;
              if(this.$route.params.hasOwnProperty('type')) {
                type = this.$route.params.type;
                this.$data.type = type;
              } else if(this.$route.query.hasOwnProperty('type')) {
                type = this.$route.query.type;
                this.$data.type = type;
              }

              // console.log(this.$route.params);
              if(this.$route.params.hasOwnProperty("orderType")) {
                // console.log("Order Type " + this.$route.params.orderType);
                if(this.$route.params.orderType === 'preorder') {
                  this.$data.preorder = true;
                }


                if(this.$route.params.hasOwnProperty("orderId")) {
                 this.$data.orderId = parseInt(this.$route.params.orderId);
                }
              }
              // if(type=='pretakeaway') {
              //   this.$data.type = 'takeaway';
              //   this.$data.preorder = true;
              //   type='takeaway';
              // } else if(type=='predelivery') {
              //   this.$data.type = 'delivery';
              //   this.$data.preorder = true;
              //   type='delivery';
              // }
              // console.log("call getMerchant")


              // let fromTime = new Date().getTime();
              getMerchant(this.$data.merchantId, type)
              .then(function(data) {
                  // let nowTime = new Date().getTime();
                  // console.log("response took " + (nowTime - fromTime));
                  if(data.success == true) {
                      // console.log("Merchant Response");
                      // console.log(data);
                      if(data.table != undefined) {
                          self.$data.tableItem = data.table;
                      }
                      self.merchantSelected(data.item);
                      // console.log("call gethistory")
                      self.getHistory();
                  } else {
                    // console.log("Failed to get merchant " + data.message)
                  }
              })
              .catch(function(err) {
                // console.log("err " + err)
              })
          } else if(this.$route.query.hasOwnProperty('table')) {


              this.$data.type = 'table';
              getTableMerchant(this.$route.query.table)
              .then(function(data) {
                  // console.log("table query response");
                  // console.log(data);
                  if(data.success == true) {

                      self.$data.tableItem = data.table;
                      if(self.$data.tableItem.table_type === 'Take Away') {
                        // console.log("path: " + self.$route.path)
                        let basePath = self.$route.path.split('/')[1];
                        let newPath = '/' + basePath + '/' + self.$data.tableItem.subscription_id + '/takeaway';
                        // console.log("Move to " + newPath);
                        window.location.href = newPath;
                      } else if(self.$data.tableItem.table_type === 'Delivery') {
                        // console.log("path: " + self.$route.path)
                        let basePath = self.$route.path.split('/')[1];
                        let newPath = '/' + basePath + '/' + self.$data.tableItem.subscription_id + '/delivery';
                        // console.log("Move to " + newPath);
                        window.location.href = newPath;
                      }
                    // console.log("Table Tag " + data.table.tags);
                    if(data.table.tags != null && data.table.tags.length > 0) {
                      self.$data.tableTags = data.table.tags.split(',');
                      // console.log(self.$data.tableTags);
                    }
                    if(data.item.tableOrderAuth === '1') {

                      if(self.$route.query.hasOwnProperty('session') === false) {
                        self.showPopup("Please ask staff for QR code");
                        return;
                      }
                      self.$data.useSession = true;
                      self.$data.sessionId = parseInt(self.$route.query.session);
                    }
                    self.merchantSelected(data.item);
                    // console.log("getPendingTable call 2");
                    self.getPendingTable();
                  }
              })
              .catch(function(err) {
                // console.log(err)
              })
          } else if(this.$route.params.hasOwnProperty('table')) {

            this.$data.type = 'table';
            getTableMerchant(this.$route.query.table)
              .then(function(data) {
                // console.log("table param response");
                // console.log(data);
                if(data.success == true) {
                  // console.log(data);
                  self.$data.tableItem = data.table;
                  // console.log("Table Tag");
                  if(self.$data.tableItem.table_type === 'Take Away') {
                    // console.log("path: " + self.$route.path)
                    let basePath = self.$route.path.split('/')[1];
                    let newPath = '/' + basePath + '/' + self.$data.tableItem.subscription_id + '/takeaway';
                    // console.log("Move to " + newPath);
                    window.location.href = newPath;
                  } else if(self.$data.tableItem.table_type === 'Delivery') {
                    // console.log("path: " + self.$route.path)
                    let basePath = self.$route.path.split('/')[1];
                    let newPath = '/' + basePath + '/' + self.$data.tableItem.subscription_id + '/delivery';
                    // console.log("Move to " + newPath);
                    window.location.href = newPath;
                  }
                  if(data.table.tags != null && data.table.tags.length > 0) {
                    self.$data.tableTags = data.table.tags.splice(',');
                    // console.log(self.$data.tableTags);
                  }


                  self.merchantSelected(data.item);

                  // console.log("getPendingTable call 3");
                  self.getPendingTable();
                }
              })
              .catch(function(err) {

              })
          }
      },
      toggleMyOrder: function() {
        this.$data.showMine = !this.$data.showMine;
      },
      closeTop: function() {
          // console.log("close top");
        // if(this.$data.currentPath !== this.$data.basePath) {
          this.$router.go(-1);
        // }
      },
      backPressed: function(fromNav = false) {
        // console.log("backPressed " + this.$data.optionSelectItem);
        // console.log("backPressed on Restaurant");
        // if($("#basket-table").length > 0 && $("#basket-table").hasClass("show")) {
        //   $("#basket-table").removeClass("show");
        //   return;
        // }

        if(this.$data.showHistory == true) {
            this.$data.showHistory = false;
          // console.log("backPressed on Restaurant hide history");
            // unregisterRouterGuard();
            //this.deregisterBackHanlder();
            return true;
        }
        if(this.$data.showBasket == true) {
            this.$data.showBasket = false;
          // console.log("backPressed on Restaurant hide basket");
          //this.deregisterBackHanlder();
            return true;
        }
        if(this.$data.setSelectItem != false) {
          // console.log("backPressed on Restaurant hide option");
          this.$data.setSelectItem = false;
          //this.deregisterBackHanlder();
          return true;
        }
        if(this.$data.optionSelectItem != false) {
          // console.log("backPressed on Restaurant hide option");
          this.$data.optionSelectItem = false;
          //this.deregisterBackHanlder();
          return true;
        }
        // if(this.$data.currentMerchantItem != false) {
        //   this.$data.currentMerchantItem = false;
        //   return;
        // }
        // if(fromNav == true) {
        //   // Router.push('/home');
        //   history.go(-1)
        //   return false;
        // }
        // Router.push('/home?type=' + this.$data.type);
        // console.log("backPressed on Restaurant return false");
        // history.go(-1);
        this.$data.toLeave = true;
        return false;
      },
      getUserPoint: function() {
        this.$data.userPoint = false;
        if(this.$data.currentMerchantItem == undefined || this.$data.currentMerchantItem == false) {
          return;
        }
        if(localStorage.getItem("tel") == null || localStorage.getItem("tel").length < 11) {
          return;
        }
        let self = this;
        // console.log("getUserPoint")
        getUserPoint(localStorage.getItem("tel"), this.$data.currentMerchantItem.merchantId)
        .then(function(data) {
          // console.log("userPoint Res");
          // console.log(data);
          if(data.success == true) {
            self.$data.userPoint = data.item;
            self.checkPointsUsable();
          }
        })
        .catch(function(err) {

        })
      },
      checkPointsUsable: function() {
        // console.log("check Points Usable");
        this.$data.redeemables = [];
        if(this.$data.redeemableManualSeen == true) {
          // console.log("check Points Usable return");
          return;
        }
        let redeemables = [];
        if(this.$data.userPoint != false && this.$data.userPoint.balance > 0) {
          for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
            if(this.$data.currentMerchantItem.categories[i].list.length > 0) {
              for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
                if(this.$data.currentMerchantItem.categories[i].list[j].pricePoints > 0 &&
                  this.$data.currentMerchantItem.categories[i].list[j].pricePoints < this.$data.userPoint.balance) {
                  let menuName = this.$data.currentMerchantItem.categories[i].list[j].name;
                  if(this.$data.currentMerchantItem.categories[i].list[j].public_name != null && this.$data.currentMerchantItem.categories[i].list[j].public_name.length > 0) {
                    menuName = this.$data.currentMerchantItem.categories[i].list[j].public_name;
                  }
                  redeemables.push(menuName);
                }
              }
            }
          }
        }

        if(redeemables.length > 0) {
          this.$data.redeemables = redeemables;
          this.$data.redeemableManualSeen = true;
        }
      },
      getMenuImage: function(menuId) {
          // console.log("getMenuImage " + menuId);
          if(this.$data.currentMerchantItem == undefined || this.$data.currentMerchantItem == false) {
              // console.log("getMenuImage no current Merchant Item");
              return '';
          }
          if(this.$data.currentMerchantItem.categories == undefined || this.$data.currentMerchantItem.categories == null) {
              // console.log("getMenuImage current Merchant Item no categories");
              return '';
          }


          for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
              if(this.$data.currentMerchantItem.categories[i].list == undefined || this.$data.currentMerchantItem.categories[i].list == null) {
                  continue;
              }

              for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
                  if(this.$data.currentMerchantItem.categories[i].list[j].id == menuId) {
                      // console.log("Return no menu image "+ this.$data.currentMerchantItem.categories[i].list[j].image_url);
                      if(this.$data.currentMerchantItem.categories[i].list[j].imgs != undefined && this.$data.currentMerchantItem.categories[i].list[j].imgs.length > 0) {
                        return this.$data.currentMerchantItem.categories[i].list[j].imgs[0];
                      } else {
                        return "";
                      }

                  }
              }
          }
          // console.log("Return no menu image for " + menuId);
          return '';
      },
      getMenuDescription: function(menuId) {
        if(this.$data.currentMerchantItem == undefined || this.$data.currentMerchantItem == false) {
          return '';
        }
        if(this.$data.currentMerchantItem.categories == undefined || this.$data.currentMerchantItem.categories == null) {
          return '';
        }


        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          if(this.$data.currentMerchantItem.categories[i].list == undefined || this.$data.currentMerchantItem.categories[i].list == null) {
            continue;
          }

          for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
            if(this.$data.currentMerchantItem.categories[i].list[j].id == menuId) {
              if(this.$data.currentMerchantItem.categories[i].list[j].description != null) {
                return this.$data.currentMerchantItem.categories[i].list[j].description;
              } else {
                return '';
              }

            }
          }
        }
        return '';
      },
      getMenuIngredients: function(menuId) {
        if(this.$data.currentMerchantItem == undefined || this.$data.currentMerchantItem == false) {
          return '';
        }
        if(this.$data.currentMerchantItem.categories == undefined || this.$data.currentMerchantItem.categories == null) {
          return '';
        }
        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          if(this.$data.currentMerchantItem.categories[i].list == undefined || this.$data.currentMerchantItem.categories[i].list == null) {
            continue;
          }

          for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
            if(this.$data.currentMerchantItem.categories[i].list[j].id == menuId) {
              if(this.$data.currentMerchantItem.categories[i].list[j].ingredients != null) {
                return this.$data.currentMerchantItem.categories[i].list[j].ingredients;
              } else {
                return '';
              }

            }
          }
        }
        return '';
      },
      getMenuAllergens: function(menuId) {
        if(this.$data.currentMerchantItem === undefined || this.$data.currentMerchantItem === false) {
          return '';
        }
        if(this.$data.currentMerchantItem.categories === undefined || this.$data.currentMerchantItem.categories === null) {
          return '';
        }
        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          if(this.$data.currentMerchantItem.categories[i].list === undefined || this.$data.currentMerchantItem.categories[i].list === null) {
            continue;
          }

          for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
            if(this.$data.currentMerchantItem.categories[i].list[j].id == menuId) {
              if(this.$data.currentMerchantItem.categories[i].list[j].allergens !== null && this.$data.currentMerchantItem.categories[i].list[j].allergens.length > 0) {
                return this.$data.currentMerchantItem.categories[i].list[j].allergens;
              } else {
                return '';
              }

            }
          }
        }
        return '';
      },
      canSensBillRequest: function() {
        if(this.$data.order == undefined || this.$data.order == null || this.$data.order == false || this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return false;
        }
        let billable = false;
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].state >= 4) {
            billable = true;
            return true;
          }
        }

        return false;

      },
      sendBillRequest: function() {
        if(this.$data.order == undefined || this.$data.order == null || this.$data.order == false || this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          this.showPopup("", "Nothing is ordered yet. Please request when you finish meal.");
          return;
        }
        let billable = false;
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].state >= 4) {
            billable = true;
            break;
          }
        }
        if(billable == true) {
          this.showPopup("", "Did you finish meal? Do you want to request a bill for your table?", "Yes Request Bill", "No", this.sendBillRequestConfirmed, null, null);
        } else {
          this.showPopup("", "No item found ordered from this application. Please check basket or ask one of staff for your bill");
        }
      },
      sendBillRequestConfirmed: function() {
        if(this.$data.tableItem == null || this.$data.tableItem == false) {
          return;
        }
        let self = this;
        sendTableRequest(this.$data.currentMerchantItem.merchantId, "tableRequest", "bill", this.$data.tableItem.id)
        .then(function(data) {
          if(data.success == true) {
            self.showPopup("", "Bill has been requested");
          } else {
            self.showPopup("Sorry", "Failed to send bill request to till. Please ask a member of staff for your bill");
          }
        })
        .catch(function(err) {
          // console.log(err);
          // if(err.response != undefined) {
          //   console.log(err.response);
          // }
          self.showPopup("OOPS!", "Some propblem occured. Please ask a member of staff for your bill")
        })

      },
      showHistoryList: function() {
          if(this.$data.orderHistory.length > 0) {
            this.$data.showHistory = true;
            let path = this.$data.basePath + "?history";
            this.$router.push(path);
          }
      },
      clickedOnYes: function() {
        this.$data.popup.show = false;
        if(this.$data.popup.yesCb != null) {
          this.$data.popup.yesCb();
        }
        this.intialisePopup();

      },
      clickedOnNo: function() {
        this.$data.popup.show = false;
        if(this.$data.popup.noCb != null) {
          this.$data.popup.noCb();
        }
        this.intialisePopup();

      },
      closeRedeemManual: function() {
        this.$data.redeemables = false;
      },
      clickedOnBackground: function() {
        if(this.$data.popup.bgCb != null) {
          this.$data.popup.bgCb();
        }
        this.intialisePopup();
      },
      doNothingOnClick: function() {

      },
      closeAdvert: function() {
        this.$data.advertImage = false;
      },
      intialisePopup: function() {
        this.$data.popup.show = false;
        this.$data.popup.title = '';
        this.$data.popup.message = '';
        this.$data.popup.yesBtnTitle = '';
        this.$data.popup.noBtnTitle = '';
        this.$data.popup.closeBtnTitle = '';
        this.$data.popup.yesCb = null;
        this.$data.popup.noCb = null;
        this.$data.popup.bgCb = null;
      },
      showPopup: function(title, message, yesBtnTitle = "", noBtnTitle = "", yesCb = null, noCb = null, bgCb = null, icon = null) {
        this.$data.popup.title = title;
        this.$data.popup.message = message;
        this.$data.popup.yesBtnTitle = yesBtnTitle;
        this.$data.popup.noBtnTitle = noBtnTitle;
        this.$data.popup.yesCb = yesCb;
        this.$data.popup.noCb = noCb;
        this.$data.popup.show = true;
        this.$data.popup.bgCb = bgCb
        this.$data.popup.icon = icon;
        // console.log(this.$data.popup);
      },
      showPopupWithClose: function(title, message, closeBtnTitle = "") {
        this.$data.popup.title = title;
        this.$data.popup.message = message;
        this.$data.popup.yesBtnTitle = "";
        this.$data.popup.closeBtnTitle = closeBtnTitle;
        this.$data.popup.noBtnTitle = "";
        this.$data.popup.yesCb = null;
        this.$data.popup.noCb = null;
        this.$data.popup.show = true;
        this.$data.popup.bgCb = null
        // console.log(this.$data.popup);
      },

      /**
       * Open / Select Restaurant
       * Select -> Get menus -> Sort menus
       * @param merchant
       */
      merchantSelected: function(merchant) {
        merchant.categories = [];
        merchant.options = [];
        merchant.priceSchedules = [];
        merchant.discounts = [];
        merchant.priceOptions = [];
        merchant.lastSelections = [];


        // console.log("MERCHANT");
        // console.log(merchant);
        this.$data.images = [];

        let imageList = [];
        // console.log("now check websetting")
        if(merchant.webSetting !== undefined && merchant.webSetting !== null && merchant.webSetting.imageUrls !== undefined && merchant.webSetting.imageUrls.length > 0) {
          imageList = merchant.webSetting.imageUrls.split(',');
        } else if(merchant.imageUrl != null && merchant.imageUrl.length > 0) {


          merchant.imageUrl = merchant.imageUrl.replace(
            new RegExp('https://borium-rest-menus.s3.eu-west-2.amazonaws.com/boriumPos', 'g'), 'https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus/aws');
          imageList = merchant.imageUrl.split(',');
        }

        if(imageList !== null && imageList.length > 0) {
          for(let i = 0 ; i < imageList.length ; i++) {
            this.$data.images.push(imageList[i]);
            if(this.$data.images.length >= 3) {
              break;
            }
          }

        }
        this.$nextTick(() => {
          this.startRestaurantSlider();
        });
        if(merchant.webSetting !== undefined && merchant.webSetting !== null && merchant.webSetting.bannerImage !== null && merchant.webSetting.bannerImage.length > 0) {
          this.$data.additionalOffSet = screen.width * 0.33 + 10;
        }

        // console.log(this.$data.images);
        this.$data.minOrder = 0;
        this.$data.delayTime = 0;
        if(merchant.delayTime != undefined) {
          this.$data.delayTime = merchant.delayTime;
        }
        this.$data.currentMerchantItem = JSON.parse(JSON.stringify(merchant));


        EventBus.$emit("setTitle", this.$data.currentMerchantItem.title);

        this.setPageMeta();
        submitLog(this.$data.currentMerchantItem.merchantId, 'OrderPage', this.$data.type)
        .then(function(data){

        })
        .catch(function(err){

        })
        // console.log(this.$data.currentMerchantItem);
        // console.log("Merchant Selected " + this.$data.type + " SC rate " + this.$data.currentMerchantItem.serviceChargeRate);
        this.setOpeningTime();
        // console.log("preORder " + this.$data.preorder);
        if(this.$data.preorder == true) {
          // console.log("pre order = true");
          if(this.$data.orderId == 0) {
            this.newPreSession();

          } else {
            this.getPreOrder(this.$data.orderId);
          }
        } else {
          if (this.$data.type === 'delivery') {
            if (this.$data.enableDelivery == true) {

              if(this.$route.query.hasOwnProperty("address")) {
                this.$data.address = this.$route.query.address;
                this.$data.usePreEnteredAddress = true;
              }
              this.checkDelivery();
            } else {
              let res = window.confirm("We cannot take delivery order at the moment.\nWould you like to order collection?");
              // self.$data.showPostCodeInput = false;
              this.$route.params.type = 'takeaway';
              this.$data.type = 'takeaway';
              let basePath = this.$route.path.split('/')[1];

              if (this.$route.query.hasOwnProperty("id")) {
                // console.log("move to " + '/' +basePath + '/' + this.$route.query.id + '/takeaway');
                window.location.href = '/' + basePath + '/' + this.$route.query.id + '/takeaway';
                // Router.push('/' +basePath + '/' + this.$route.query.id + '/takeaway');
              } else if (this.$route.params.hasOwnProperty("id")) {
                // console.log("move to " + '/' +basePath + '/' + this.$route.params.id + '/takeaway');
                window.location.href = '/' + basePath + '/' + this.$route.params.id + '/takeaway';
                // Router.push('/' +basePath + '/' + this.$route.params.id + '/takeaway');
              }
              // if(res == true) {
              //
              //   console.log("move to takeaway");
              //
              //   Router.push('/restaurant?id='+this.$route.query.id + '&type=takeaway');
              // } else {
              //   console.log("move to takeaway 2");
              //   Router.push('/restaurant?id='+this.$route.query.id + '&type=takeaway');
              // }
              // return;

            }

          } else if (this.$data.type == 'table') {
            // this.checkForTableOrder();


          }
          let msg;
          if(this.$data.type === 'takeaway' || this.$data.type === 'delivery') {
            // Allergen wording for orders eaten off-premises: no staff to ask in person.
            msg = "<br/><b>Allergy & ingredient information can be found on each menu item.</b>";
            let title = merchant.title || '';
            let contact = (merchant.contact !== undefined && merchant.contact !== null) ? String(merchant.contact).trim() : '';
            if(title.length > 0 || contact.length > 0) {
              msg += "<br/><b>If not found, please contact" + (title.length > 0 ? " " + title : "") + "</b>";
              if(contact.length > 0) {
                let telHref = contact.replace(/[^+0-9]/g, '');
                msg += "<br/><a href=\"tel:" + telHref + "\">" + contact + "</a>";
              }
            }
          } else {
            msg = "<br/><b>Please let us know if you have any Allergy and inquiry</b>";
          }
          if(this.$data.type === 'delivery') {
            let deliveryInfo = this.getDeliveryNoticeMessage();
            if(deliveryInfo.length > 0) {
              msg += "<br/><br/>" + deliveryInfo;
            }
          }
          // Merchant notice (e.g. "Please call a staff for bill after meal") is dine-in only.
          if(this.$data.type === 'table' && merchant.notice !== undefined && merchant.notice !== null && merchant.notice.length > 0) {
            msg += "<br/><br/>" +merchant.notice;
          }
          this.showPopupWithClose("Important Notice", msg, "OK");

          // console.log("type: " + this.$data.type + " takeaway " + this.$data.enableTakeaway);
          if(this.$data.type === 'takeaway' && this.$data.enableTakeaway == false) {

            let basePath = this.$route.path.split('/')[1];
            if(this.$route.query.hasOwnProperty("id")) {
              Router.push('/' +basePath + '/' + this.$route.query.id + '/takeaway');
            } else if(this.$route.params.hasOwnProperty("id")) {
              Router.push('/' +basePath + '/' + this.$route.params.id + '/takeaway');
            }
          }

          // console.log("Type " + this.$data.type);

          this.subscribe("merchant/" + this.$data.currentMerchantItem.merchantId);
        }

        if(this.$data.sessionAuthorised === false) {
          return;
        }
        this.getMenus(this.$data.currentMerchantItem.merchantId);
        // console.log("Call Get menus")




        // console.log("Now check advert");
        // console.log(this.$data.currentMerchantItem);
        if(this.$data.currentMerchantItem.adverts !== undefined && this.$data.currentMerchantItem.adverts.length > 0) {
          // console.log("Adverts");
          // console.log(this.$data.currentMerchantItem.adverts);

          let adverts = JSON.parse(this.$data.currentMerchantItem.adverts);
          for(let i = 0 ; i < adverts.length ; i++) {
            // console.log(adverts[i]);
            let advert = adverts[i];
            let today = millisToDate();
            if(today >= advert.from && today <= advert.to && this.$data.type === advert.type) {
              // console.log("Today is inside");
              this.$data.advertImage = advert.imageUrl;
              break;
            } else {
              // console.log("Today is not inside");
            }

          }
        }

        if(this.$data.type === 'collection') {
          this.getCollectionSettings();
        }


      },
      getCollectionSettings: function() {
        let self = this;
        getMerchantSettings(this.$data.currentMerchantItem.merchantId, "collectionOrder")
          .then(function(data) {
            if(data.success) {
              self.showCollectionInfo(data.item);
            } else {
              console.error('Request failed');
            }
          })
          .catch(function(err) {
            console.error('Request failed', err && err.response ? err.response.status : '');
          })
      },
      showCollectionInfo: function(settings) {
        for(let i = 0 ; i < settings.length ; i++) {
          if(settings[i].field === 'termsAndCondition') {
            this.$data.customerNotification = {
              title: 'Customer Notification',
              content: settings[i].textVal,
            }
          }
        }
      },
      newPreSession: function() {
        this.$data.newPreOrder = {
          id:0,
          merchantName:this.$data.currentMerchantItem.title,
          name:'',
          phoneNumber:'',
          email:'',
          subscriptionId: this.$data.currentMerchantItem.merchantId,
          state:-1000,
        }
      },
      createNewPreSession: function() {
        if(this.$data.newPreOrder == false) {
          return;
        }

        if(this.$data.newPreOrder.name === '') {
          this.showPopup("", "Name or group name required to create new session");
          return;
        }
        if(this.$data.newPreOrder.phoneNumber === '') {
          this.showPopup("", "Phone Number required to create new session");
          return;
        }
        let self = this;
        createNewPreOrder(this.$data.newPreOrder)
          .then(function(data){
            // console.log(data);
            if(data.success) {
              self.forwardToSession(data.item.id);
            } else {
              self.showPopup("Sorry", data.message);
            }
          })
        .catch(function(err) {
          // console.log(err);
          // if(err.response != undefined) {
          //   console.log(err.response);
          // }
        })
      },
      forwardToSession: function(id) {
        let basePath = this.$route.path.split('/')[1];
        if(this.$route.query.hasOwnProperty("id")) {
          Router.push('/' +basePath + '/' + this.$route.query.id + '/' + this.$data.type  + '/preorder/' + id);
        } else if(this.$route.params.hasOwnProperty("id")) {
          Router.push('/' +basePath + '/' + this.$route.params.id + '/' + this.$data.type  + '/preorder/' + id);
        }
      },
      getPreOrder: function(id) {
        let self = this;
        getPreOrder(id)
          .then(function(data) {

            if(data.success == true) {
              // console.log("Pending table " + data.item);
              // console.log(data.item);
              // if(data.item.list != undefined && data.item.list != null && data.item.list.length > 0) {
              //   for(let i = 0 ; i < data.item.list.length ; i++) {
              //     if(data.item.list[i].options != null && data.item.list[i].options.length > 0) {
              //       data.item.list[i].options = JSON.parse(data.item.list[i].options);
              //     }
              //     if(data.item.list[i].optionSelection != null && data.item.list[i].optionSelection.length > 0) {
              //       data.item.list[i].optionSelection = JSON.parse(data.item.list[i].optionSelection);
              //     }
              //   }
              // }
              self.$data.order = data.item;
              self.reorderItem();
              self.subscribeTableOrder();
              // console.log(self.$data.order);
            } else {
              self.$data.order = false;
                self.showPopup("", data.message, "", "", null, null,
                  function(){
                    window.location.href = "https://showmethemenu.net";
                  })

            }
          })
          .catch(function(err){

          })
      },
      checkForTableOrder: function() {

        /**
         * Check Location
         */
        let self = this;
        self.setLoadingView(false);
        self.onDistanceCheckedForTableOrder();

        return;

        if(navigator.geolocation) {
          // console.log("getting location");
          self.setLoadingView(true, "Checking Location..");
          navigator.geolocation.getCurrentPosition(position => {
            self.setLoadingView(false);
            // console.log("position");
            // console.log(position);
            self.$data.position.lat = position.coords.latitude;
            self.$data.position.lng = position.coords.longitude;
            // self.getRestaurantList();
            let from = position.coords.latitude + ',' + position.coords.longitude;
            let to = self.$data.currentMerchantItem.lat + ',' + self.$data.currentMerchantItem.lng;
            getDistance(from, to)
              .then(function(data){
                // console.log(data);
                if(data.success == true) {
                  let r = JSON.parse(data.message);
                  if(r.routes != undefined && r.routes.length > 0) {
                    // console.log("1")
                    if (r.routes[0].legs != undefined && r.routes[0].legs.length > 0) {
                      // console.log("2")
                      let leg = r.routes[0].legs[0];

                      if (leg.distance != undefined && leg.distance.value != undefined) {
                        // console.log("3")
                        self.$data.distance = Number(leg.distance.value);
                        // console.log("Distance is " + leg.distance.value + "metres");
                        if(self.$data.distance < 20) {
                          self.onDistanceCheckedForTableOrder();
                        } else {
                          self.onTooFar();
                        }
                      }
                    }
                  }
                }
              })
              .catch(function(err) {
                // console.log(err);
              })
          }, error => {
            self.setLoadingView(false);
            // console.log("Could not get position");
            // console.log(error);
            self.onTooFar();
            // self.getRestaurantList();
          });
        } else {
          self.setLoadingView(false);
          // console.log("No geolocation");
          self.onTooFar();
          // this.getRestaurantList();
        }
      },

      onTooFar: function() {

        // console.log("Merchant " + this.$data.currentMerchantItem);
        // console.log(this.$data.currentMerchantItem);
        if(this.$data.currentMerchantItem.merchantId == 1
          || this.$data.currentMerchantItem.merchantId == 10
          || this.$data.currentMerchantItem.merchantId == 15
          || this.$data.currentMerchantItem.merchantId == 19
          || this.$data.currentMerchantItem.merchantId == 26) {
          this.onDistanceCheckedForTableOrder();
          return;
        }
        let title = "Table Order";
        if(this.$data.distance > 0) {
          title += " " + this.$data.distance + " metres away";
        }
        // this.onDistanceCheckedForTableOrder();
        // return;
        this.showPopup(title, "Sorry, you do not seem to be in restaurant. If location is not enabled, please allow location to ensure that you are in restaurant when scan QR code again",
        "", "",
          function(){
            // console.log("yes call back");
            window.location.href = 'https://eemo.app';
          },
          function(){
            // console.log("yes call back");
            window.location.href = 'https://eemo.app';
          },
          function(){
            // console.log("yes call back");
            window.location.href = 'https://eemo.app';
          });

      },
      onDistanceCheckedForTableOrder: function() {
        // console.log("getPendingTable call 4 on onDestanceCheckedForTableOrder");
        this.getPendingTable();
      },

      checkIfOpen: function() {
        // console.log(this.$data.currentMerchantItem );
        // if(parseInt(this.$data.currentMerchantItem.canTakeOrder) === 1 || this.$data.currentMerchantItem.canTakeOrder === true) {
        //   console.log("open")
        // } else {
        //   console.log("busy");
        // }
        if(this.$data.isOpen === false) {

          return false;
        }

        if(this.$data.slots.length === 0) {

          return false;
        }

        let now = new Date().getTime();
        // console.log("time now " + now);
        for(let i = 0 ; i < this.$data.slots.length ; i++) {
          // console.log("compare from " + this.$data.slots[i].from + "  and " + this.$data.slots[i].to);
          if(now > this.$data.slots[i].from && now < this.$data.slots[i].to) {
            // console.log("return true");
            return true;
          }
        }



        return false;
      },
      checkDeliveryOpen: function() {

      },
      setOpeningTime: function() {
        // console.log("setOpeningTime " + this.$data.currentMerchantItem.openingTime);
        this.$data.slots = [];
        this.$data.isOpen = false;
        if(this.$data.preorder == true) {
          // console.log("preorder settime")
          this.$data.isOpen = true;

          let today = new Date();
          today.setHours(10, 0, 0, 0);
          let fromTime = today.getTime();
          today.setHours(23, 0, 0, 0);
          let toTime = today.getTime();
          let slot = {
            from: fromTime,
            to: toTime,
            fromString: '10:00',
            toString: '23:00',
          };
          this.$data.slots.push(slot);

        } else if(this.$data.currentMerchantItem.openingTime != null && this.$data.currentMerchantItem.openingTime.length > 3) {

          this.$data.openingTime = JSON.parse(this.$data.currentMerchantItem.openingTime);
          if(this.$data.type === 'delivery' && this.$data.currentMerchantItem.deliveryTime != null && this.$data.currentMerchantItem.deliveryTime.length > 0) {
            this.$data.deliveryTime = JSON.parse(this.$data.currentMerchantItem.deliveryTime);
          }


          if(this.$data.openingTime != null && this.$data.openingTime.length > 0) {
            // console.log("here")
            let today = new Date();
            let dayOfWeek = today.getDay();
            if(today.getHours() < 2) {
              dayOfWeek--;
              if(dayOfWeek < 0) {
                dayOfWeek = 6;
              }
              today.setDate(today.getDate() - 1);
            }
            let time = this.$data.openingTime[dayOfWeek];

            if(time != undefined && time != null) {
              // console.log(time);
              this.$data.isShopOpen = time.open;


              if (this.$data.isShopOpen == true && time.times != undefined && time.times != null && time.times.length > 0) {
                // this.$data.slots = time.times;

                for (let i = 0; i < time.times.length; i++) {

                  let from = time.times[i].from;
                  let to = time.times[i].to;


                  today.setHours(Number(from.split(':')[0]));
                  today.setMinutes(Number(from.split(':')[1]));

                  let fromMil = today.getTime();

                  // console.log("from " + fromMil);
                  if(to < from) {
                    today.setDate(today.getDate() + 1);
                  }
                  today.setHours(Number(to.split(':')[0]));
                  today.setMinutes(Number(to.split(':')[1]));

                  let toMil = today.getTime();
                  // console.log("to " + toMil);
                  let slot = {
                    from: fromMil,
                    to: toMil,
                    fromString: from,
                    toString: to,
                  };
                  this.$data.shopSlots.push(slot);
                }
              }
            }
          }

          if(this.$data.type === 'delivery' && this.$data.deliveryTime != false && this.$data.deliveryTime.length > 0) {
            let today = new Date();
            let dayOfWeek = today.getDay();

            let time = this.$data.deliveryTime[dayOfWeek];

            // console.log('delivery ' + dayOfWeek);
            // console.log(time);
            if(time != undefined && time != null) {
              // console.log(time);
              this.$data.isOpen = time.open;


              if (this.$data.isOpen == true && time.times != undefined && time.times != null && time.times.length > 0) {
                // this.$data.slots = time.times;

                for (let i = 0; i < time.times.length; i++) {

                  let from = time.times[i].from;
                  let to = time.times[i].to;


                  today.setHours(Number(from.split(':')[0]));
                  today.setMinutes(Number(from.split(':')[1]));

                  let fromMil = today.getTime();

                  if(to < from) {
                    today.setDate(today.getDate() + 1);
                  }
                  today.setHours(Number(to.split(':')[0]));
                  today.setMinutes(Number(to.split(':')[1]));

                  let toMil = today.getTime();

                  let slot = {
                    from: fromMil,
                    to: toMil,
                    fromString: from,
                    toString: to,
                  };
                  this.$data.slots.push(slot);
                }
              }
            }



            if(this.$data.slots.length == 0 || this.$data.isOpen == false ) {
              this.showPopup("", "No delivery available today.");
            } else if(this.$data.isOpen && this.$data.slots.length > 0) {
              let message = "Delivery available at";
              let available = false;
              let now = new Date().getTime();
              for(let i = 0 ; i < this.$data.slots.length ; i++) {
                message += '<br>' + this.$data.slots[i].fromString +' ~ ' + this.$data.slots[i].toString;
                if(now >= this.$data.slots[i].from && now < this.$data.slots[i].to) {
                  available = true;
                }
              }
              if(this.$data.isShopOpen) {
                message += '<br><br>Restaurants open at';
                for(let i = 0 ; i < this.$data.shopSlots.length ; i++) {
                  message += '<br>' + this.$data.shopSlots[i].fromString +' ~ ' + this.$data.shopSlots[i].toString;
                }
                message += '<br>Would you like to move to takeaway menus?';
              }
              message += '<br>';
              let self = this;
              if(available == false) {
                this.showPopup("", message, "Move to Takeaway", "Stay", function () {
                  self.$data.popup.show = false;
                  let basePath = self.$route.path.split('/')[1];

                  // basePath = 'order';
                  if (self.$route.query.hasOwnProperty("id")) {
                    // console.log("move to " + '/' +basePath + '/' + self.$route.query.id + '/'+newtype);
                    window.location.href = '/' + basePath + '/' + self.$route.query.id + '/takeaway';
                    // Router.push('/' +basePath + '/' + self.$route.query.id + '/' + newtype);
                    self.$route.query.type = newtype;
                  } else if (self.$route.params.hasOwnProperty("id")) {
                    // console.log("move to " + '/' +basePath + '/' + self.$route.params.id + '/'+newtype);
                    window.location.href = '/' + basePath + '/' + self.$route.params.id + '/takeaway';
                    // Router.push('/' +basePath + '/' + self.$route.params.id + '/' + newtype);
                    self.$route.params.type = newtype;
                  }
                });
              }
            }
          } else if(this.$data.openingTime != null && this.$data.openingTime.length > 0) {
            let today = new Date();
            let dayOfWeek = today.getDay();
            if(today.getHours() < 2) {
              dayOfWeek--;
              if(dayOfWeek < 0) {
                dayOfWeek = 6;
              }
              today.setDate(today.getDate() - 1);
            }
            let time = this.$data.openingTime[dayOfWeek];

            if(time != undefined && time != null) {
              // console.log(time);
              this.$data.isOpen = time.open;


              if (this.$data.isOpen == true && time.times != undefined && time.times != null && time.times.length > 0) {
                // this.$data.slots = time.times;

                for (let i = 0; i < time.times.length; i++) {

                  let from = time.times[i].from;
                  let to = time.times[i].to;


                  today.setHours(Number(from.split(':')[0]));
                  today.setMinutes(Number(from.split(':')[1]));

                  let fromMil = today.getTime();
                  if(to < from) {
                    today.setDate(today.getDate() + 1);
                  }
                  today.setHours(Number(to.split(':')[0]));
                  today.setMinutes(Number(to.split(':')[1]));

                  let toMil = today.getTime();

                  let slot = {
                    from: fromMil,
                    to: toMil,
                    fromString: from,
                    toString: to,
                  };
                  this.$data.slots.push(slot);
                }
              }
            }


          }


        }
        if(this.$data.currentMerchantItem.deliveryZone != null && this.$data.currentMerchantItem.deliveryZone.length > 3) {
          let deliverySetting = JSON.parse(this.$data.currentMerchantItem.deliveryZone);
          if(deliverySetting.acceptCash != undefined) {
            this.$data.acceptCash = deliverySetting.acceptCash;
          }
          if(deliverySetting.cashLimit != undefined) {
            this.$data.cashLimit = deliverySetting.cashLimit;
          }
          if(deliverySetting.acceptCard != undefined) {
            this.$data.acceptCard = deliverySetting.acceptCard;
          }

          if(deliverySetting.acceptStripe != undefined) {
            this.$data.acceptStripe = deliverySetting.acceptStripe;
          }

          if(deliverySetting.cashBtnTitle != undefined) {
            this.$data.cashBtnTitle = deliverySetting.cashBtnTitle;
          }
          if(deliverySetting.cardBtnTitle != undefined) {
            this.$data.cardBtnTitle = deliverySetting.cardBtnTitle;
          }
          if(deliverySetting.stripeBtnTitle != undefined) {
            this.$data.stripeBtnTitle = deliverySetting.stripeBtnTitle;
          }
          // if(deliverySetting.enableDelivery != undefined) {
          //   this.$data.enableDelivery = deliverySetting.enableDelivery;
          // }
          if(deliverySetting.enableTakeaway != undefined) {
            this.$data.enableTakeaway = deliverySetting.enableTakeaway;
          }
          if(deliverySetting.taDelay != undefined) {
            this.$data.taDelay = Number(deliverySetting.taDelay);
          }
          if(deliverySetting.deliveryDelay != undefined) {
            this.$data.deliveryDelay = Number(deliverySetting.deliveryDelay);
          }
          if(deliverySetting.deliveryTimePerMile != undefined) {
            this.$data.deliveryTimePerMile = Number(deliverySetting.deliveryTimePerMile);
          }
          if(deliverySetting.interval != undefined) {
            this.$data.interval = Number(deliverySetting.interval);
          }
          this.applyOrderTimingDefaults();
          if(deliverySetting.lastOrder != undefined) {
            this.$data.lastOrder = Number(deliverySetting.lastOrder);
          }
          if(deliverySetting.lastTableOrder != undefined) {
            this.$data.lastTableOrder = Number(deliverySetting.lastTableOrder);
          }
          if(deliverySetting.lastTableOrderMessage != undefined) {
            this.$data.lastTableOrderMessage = deliverySetting.lastTableOrderMessage;
          }
          if(deliverySetting.lastDeliveryOrder != undefined) {
            this.$data.lastDeliveryOrder = Number(deliverySetting.lastDeliveryOrder);
          }
          if(deliverySetting.additionalDelay != undefined) {
            this.$data.additionalDelay = Number(deliverySetting.additionalDelay);
          }
          if(deliverySetting.additionalDelayPrice != undefined) {
            this.$data.additionalDelayPrice = Number(deliverySetting.additionalDelayPrice)*100;
          }
          if(deliverySetting.deliveryPriceByDistance != undefined) {
            this.$data.deliveryPriceByDistance = deliverySetting.deliveryPriceByDistance;
          }
          if(deliverySetting.fixedDeliveryCharge !== undefined) {
            this.$data.fixedDeliveryCharge = Math.round(parseFloat(deliverySetting.fixedDeliveryCharge)*100);
          }
          if(deliverySetting.distanceChargeList != undefined) {
            this.$data.distanceChargeList = deliverySetting.distanceChargeList;
          }
          this.applyDeliveryChargeLimitSettings(deliverySetting);

        }
        this.$data.enableDelivery = this.$data.currentMerchantItem.webDelivery == 1?true:false;
        if((this.$data.type == 'takeaway' || this.$data.type == 'room') && this.$data.currentMerchantItem.promotion != undefined && this.$data.currentMerchantItem.promotion.length > 3) {
          this.$data.promotions = JSON.parse(this.$data.currentMerchantItem.promotion);

          if(this.$data.promotions.length > 0) {
            let today = millisToDate();
            for(let i = 0 ; i < this.$data.promotions.length ; i++) {
              // console.log("today " + today + " ");
              // console.log(this.$data.promotions[i]);
              if(today >= this.$data.promotions[i].from && today <= this.$data.promotions[i].to) {
                this.$data.promotion = this.$data.promotions[i];

                break;
              }
            }
          }
        }
        if(this.$data.currentMerchantItem.points != undefined && this.$data.currentMerchantItem.points.length > 3) {
          this.$data.points = JSON.parse(this.$data.currentMerchantItem.points);
        }

        this.refreshDojoPaymentReady();

      },
      updateTimes: function() {
        if(this.$data.currentMerchantItem.deliveryZone != null && this.$data.currentMerchantItem.deliveryZone.length > 3) {
          let deliverySetting = JSON.parse(this.$data.currentMerchantItem.deliveryZone);
          if(deliverySetting.acceptCash != undefined) {
            this.$data.acceptCash = deliverySetting.acceptCash;
          }
          if(deliverySetting.cashLimit != undefined) {
            this.$data.cashLimit = deliverySetting.cashLimit;
          }
          if(deliverySetting.acceptCard != undefined) {
            this.$data.acceptCard = deliverySetting.acceptCard;
          }

          if(deliverySetting.acceptStripe != undefined) {
            this.$data.acceptStripe = deliverySetting.acceptStripe;
          }

          if(deliverySetting.cashBtnTitle != undefined) {
            this.$data.cashBtnTitle = deliverySetting.cashBtnTitle;
          }
          if(deliverySetting.cardBtnTitle != undefined) {
            this.$data.cardBtnTitle = deliverySetting.cardBtnTitle;
          }
          if(deliverySetting.stripeBtnTitle != undefined) {
            this.$data.stripeBtnTitle = deliverySetting.stripeBtnTitle;
          }
          // if(deliverySetting.enableDelivery != undefined) {
          //   this.$data.enableDelivery = deliverySetting.enableDelivery;
          // }
          if(deliverySetting.enableTakeaway != undefined) {
            this.$data.enableTakeaway = deliverySetting.enableTakeaway;
          }
          if(deliverySetting.taDelay != undefined) {
            this.$data.taDelay = Number(deliverySetting.taDelay);
          }
          if(deliverySetting.deliveryDelay != undefined) {
            this.$data.deliveryDelay = Number(deliverySetting.deliveryDelay);
          }
          if(deliverySetting.deliveryTimePerMile != undefined) {
            this.$data.deliveryTimePerMile = Number(deliverySetting.deliveryTimePerMile);
          }
          if(deliverySetting.interval != undefined) {
            this.$data.interval = Number(deliverySetting.interval);
          }
          this.applyOrderTimingDefaults();
          if(deliverySetting.lastOrder != undefined) {
            this.$data.lastOrder = Number(deliverySetting.lastOrder);
          }
          if(deliverySetting.lastTableOrder != undefined) {
            this.$data.lastTableOrder = Number(deliverySetting.lastTableOrder);
          }
          if(deliverySetting.lastTableOrderMessage != undefined) {
            this.$data.lastTableOrderMessage = deliverySetting.lastTableOrderMessage;
          }
          if(deliverySetting.lastDeliveryOrder != undefined) {
            this.$data.lastDeliveryOrder = Number(deliverySetting.lastDeliveryOrder);
          }
          if(deliverySetting.additionalDelay != undefined) {
            this.$data.additionalDelay = Number(deliverySetting.additionalDelay);
          }
          if(deliverySetting.additionalDelayPrice != undefined) {
            this.$data.additionalDelayPrice = Number(deliverySetting.additionalDelayPrice)*100;
          }
          if(deliverySetting.deliveryPriceByDistance != undefined) {
            this.$data.deliveryPriceByDistance = deliverySetting.deliveryPriceByDistance;
          }
          if(deliverySetting.fixedDeliveryCharge !== undefined) {
            this.$data.fixedDeliveryCharge = Math.round(parseFloat(deliverySetting.fixedDeliveryCharge)*100);
          }
          if(deliverySetting.distanceChargeList != undefined) {
            this.$data.distanceChargeList = deliverySetting.distanceChargeList;
          }
          this.applyDeliveryChargeLimitSettings(deliverySetting);

        }
        this.refreshDojoPaymentReady();
      },
      /**
       * Parses the delivery charge type / delivery limit mode fields from the
       * merchant deliveryZone JSON, migrating legacy zones that only carry
       * fixedDeliveryCharge / usePostCode. Amounts are stored in pence.
       */
      applyDeliveryChargeLimitSettings: function(deliverySetting) {
        let toPence = function(value) {
          let n = parseFloat(value);
          return (isFinite(n) && n > 0) ? Math.round(n * 100) : 0;
        };
        let type = Number(deliverySetting.deliveryChargeType);
        if (!isFinite(type) || type < 0 || type > 3) {
          // Legacy zone: fixed charge > 0 behaved like an always-on fixed charge.
          type = this.$data.fixedDeliveryCharge > 0 ? 1 : 0;
        }
        this.$data.deliveryChargeType = Math.floor(type);
        if (deliverySetting.deliveryChargeAmount !== undefined) {
          this.$data.deliveryChargeAmount = toPence(deliverySetting.deliveryChargeAmount);
        } else {
          this.$data.deliveryChargeAmount = this.$data.fixedDeliveryCharge > 0 ? this.$data.fixedDeliveryCharge : 0;
        }
        this.$data.freeDeliveryOver = toPence(deliverySetting.freeDeliveryOver);
        this.$data.deliveryBaseCharge = toPence(deliverySetting.deliveryBaseCharge);
        this.$data.deliveryChargePerMilePrice = toPence(deliverySetting.deliveryChargePerMile);
        if (deliverySetting.limitType === 'distance' || deliverySetting.limitType === 'postcode') {
          this.$data.limitType = deliverySetting.limitType;
        } else {
          this.$data.limitType = (deliverySetting.usePostCode === true || deliverySetting.usePostCode === 'true') ? 'postcode' : 'distance';
        }
      },
      getPromotionPrice: function(price) {
        if(this.$data.promotion == false) {
          return "";
        }
        let today = millisToDate();
        if(today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
          let amount = this.$data.promotion.amount;
          if(this.$data.promotion.type == 0) {
            //Percent
            return price*(100-amount)/100;
          } else {
            //Amount
            return price;
          }
        }
      },
      promotionEligable: function(item) {

        // console.log("price cal");
        // console.log(item);

        let price = item.price;
        let preFix = '';
        if(item.priceFrom === true) {
          preFix = 'From ';
        }
        if(this.$data.type == 'takeaway' || this.$data.type == 'room') {
          if(item.price_ta > 0) {
            price = item.price_ta;
          }
        } else if(this.$data.type == 'delivery') {
          if(item.price_delivery > 0) {
            price = item.price_delivery;
          } else if(item.price_ta > 0) {
            price = item.price_ta;
          }
        }
        if(item.priceFrom === true && item.lowestPrice !== undefined) {

          price = parseFloat(price) + parseFloat(item.lowestPrice);
          // console.log("lowest price set to " + price + " adding " + item.lowestPrice);
        }

        if(item.originalPrice !== undefined && Number(item.originalPrice) > Number(price)) {

          let text = '<del>£' + Number(item.originalPrice).toFixed(2) + '</del>&nbsp;&nbsp;' + preFix + "£" + Number(price).toFixed(2);
          if(item.promotion !== undefined && item.promotion !== null && item.promotion.length > 0) {
            text += '<br/><span style="color: #FF3131; font-weight: 500">' + item.promotion + '</span>';

            return text;
          }
        }
        // console.log(item.name + " " + item.priceBeforeDC + " vs " + price);
        if(Number(item.priceBeforeDC) > Number(price)) {
          // console.log(item.priceBeforeDC + " vs " + price);
          return '<del>£' + Number(item.priceBeforeDC).toFixed(2) + '</del>&nbsp;&nbsp;' + preFix + "£" + Number(price).toFixed(2);
        }
        if(this.$data.promotion == false || item.excludeFromPromotion == 1 || this.$data.promotion.minimum > 0) {
          return preFix + "£" + Number(price).toFixed(2);
        }

        let newPrice = 0;
        let today = millisToDate();

        if(today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
          let amount = this.$data.promotion.amount;
          if(this.$data.promotion.type == 0) {
            //Percent
            newPrice = (price*(100-amount)/100);
          }

        }

        if(newPrice < price) {
          return this.$data.promotion.title + ' ' + this.$data.promotion.amount + '%<br>' + '<del>'+ preFix + '£' + Number(price).toFixed(2) + '</del>&nbsp;&nbsp;' + "£" + Number(newPrice).toFixed(2);
        } else {


          return preFix + "£" + Number(price).toFixed(2);
        }
      },
      // promotionEligable: function(item) {
      //   let price = item.price;
      //   if(this.$data.type == 'takeaway' || this.$data.type == 'delivery') {
      //     if(item.price_ta > 0) {
      //       price = item.price_ta;
      //     }
      //   }
      //   if(this.$data.promotion == false) {
      //     return "£" + (price).toFixed(2);
      //   }
      //
      //   let newPrice = 0;
      //   let today = millisToDate();
      //   if(today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
      //     let amount = this.$data.promotion.amount;
      //     if(this.$data.promotion.type == 0) {
      //       //Percent
      //       newPrice = (price*(100-amount)/100);
      //     }
      //
      //   }
      //
      //   if(newPrice < price) {
      //     return this.$data.promotion.title + ' ' + this.$data.promotion.amount + '%<br>' + '<del>£' + Number(price).toFixed(2) + '</del>&nbsp;&nbsp;' + "£" + Number(newPrice).toFixed(2);
      //   } else {
      //     return "£" + Number(price).toFixed(2);
      //   }
      // },
      getPrice: function(price) {
        // let price = 0;
        let today = millisToDate();
        if(today >= this.$data.promotion.from && today <= this.$data.promotion.to) {
          let amount = this.$data.promotion.amount;
          if(this.$data.promotion.type == 0) {
            //Percent
            price = (price*(100-amount)/100);
          }

        }
        return price;
      },
      checkDelivery: function() {
        if(this.$data.currentMerchantItem.deliveryZone != null && this.$data.currentMerchantItem.deliveryZone.length > 3) {
          this.$data.currentMerchantItem.delivery = JSON.parse(this.$data.currentMerchantItem.deliveryZone);

          if(this.$data.currentMerchantItem.delivery.minOrder != undefined) {
            this.$data.minOrder = this.$data.currentMerchantItem.delivery.minOrder*100;
            if(this.$data.conditionalMinOrder > 0) {
              this.$data.minOrder = this.$data.conditionalMinOrder*100;
            }
          }
        }
        if (this.$data.usePreEnteredAddress !== true && this.$data.address === false) {
          this.searchAddress();
        }
      },
      searchAddress:function() {
        this.$data.showPostCodeInput = true;
        this.$data.postCodeSearchWord = '';
        this.$data.addressCandidates = [];
        this.$data.selectedCandidate = '';
      },
      getAddressCandidates: function() {
        var postcode = (this.$data.postCodeSearchWord || '').replace(/[^A-Za-z0-9 ]/g, '').trim();
        if(postcode == '') {
          this.showPopup("", "Please Enter Post code");
          return;
        }
        this.$data.postCodeSearchWord = postcode.toUpperCase();
        this.$data.addressCandidates = [];
        this.$data.selectedCandidate = '';
        var self = this;
        getDeliveryAddresses(this.$data.postCodeSearchWord)
          .then(function(data) {
            if (data != null && data.success == true && data.list != undefined && data.list.length > 0) {
              self.$data.addressCandidates = data.list;
              return;
            }
            var message = "Sorry no address found";
            if (data != null && data.message != undefined && data.message.length > 0) {
              message = data.message;
            }
            self.showPopup("", message);
          })
          .catch(function() {
            self.showPopup("", "Sorry no address found");
          });
      },
      selectCandidate: function(address) {
        this.$data.selectedCandidate = address;
        this.processAddress();
      },
      processAddress: function() {
        if(this.$data.selectedCandidate == null || this.$data.selectedCandidate === '' || this.$data.selectedCandidate.length === 0) {
          this.showPopup("", "No Address Selected");
          return;
        }
        this.$data.address = this.$data.selectedCandidate;
        this.closeDeliveryAddressPicker();
        this.onPostCodeEntered();
      },
      closeDeliveryAddressPicker: function() {
        if(this.$data.order != false) {
          this.$data.order.address = this.$data.address;
        }
        this.$data.showPostCodeInput = false;
        this.$data.postCodeSearchWord = '';
        this.$data.addressCandidates = [];
      },
      acceptEnteredDeliveryAddress: function() {
        this.closeDeliveryAddressPicker();
        this.$data.distanceOk = true;
        if(this.$data.order != false) {
          this.calculatePrice();
        }
      },
      getDeliveryDistanceOrigin: function() {
        if (this.$data.currentMerchantItem && this.$data.currentMerchantItem.address && String(this.$data.currentMerchantItem.address).trim().length > 0) {
          return String(this.$data.currentMerchantItem.address).trim();
        }
        var delivery = this.$data.currentMerchantItem && this.$data.currentMerchantItem.delivery;
        if (delivery && delivery.postCodeFrom != undefined && String(delivery.postCodeFrom).trim().length > 0) {
          return String(delivery.postCodeFrom).trim();
        }
        return '';
      },
      logDeliveryDistance: function() {
      },
      isDeliveryDistanceLimitEnabled: function(value) {
        return value === true || value === 1 || value === '1' || value === 'true';
      },
      getDeliveryMaxDistanceMetres: function(delivery) {
        var raw = delivery ? delivery.distanceLimit : null;
        var miles = parseFloat(raw);
        if (raw == null || raw === '' || !isFinite(miles) || miles < 0) {
          return NaN;
        }
        return miles * 1600;
      },
      extractFullPostcode: function(address) {
        if (!address || typeof address !== 'string') {
          return '';
        }
        var matches = String(address).toUpperCase().match(/[A-Z]{1,2}[0-9][A-Z0-9]?\s*[0-9][A-Z]{2}/g);
        if (matches && matches.length > 0) {
          return matches[matches.length - 1].replace(/\s+/g, '');
        }
        return '';
      },
      extractOutwardPostcode: function(address) {
        var full = this.extractFullPostcode(address);
        if (!full) {
          return '';
        }
        var match = full.match(/^([A-Z]{1,2}[0-9][A-Z0-9]?)[0-9][A-Z]{2}$/);
        return match ? match[1] : '';
      },
      normalizeDeliveryAddress: function(address) {
        if (!address || typeof address !== 'string') {
          return '';
        }
        return address.toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
      },
      isSameDeliveryLocation: function(from, to) {
        var fromNorm = this.normalizeDeliveryAddress(from);
        var toNorm = this.normalizeDeliveryAddress(to);
        if (!fromNorm || !toNorm) {
          return false;
        }
        if (fromNorm === toNorm) {
          return true;
        }
        var fromPc = this.extractFullPostcode(from);
        var toPc = this.extractFullPostcode(to);
        return !!(fromPc && fromPc === toPc);
      },
      readGoogleDistanceMetres: function(data) {
        this.$data.travelDurationSeconds = 0;
        try {
          if (data == null || data.success != true || !data.message) {
            this.logDeliveryDistance('google-parse', {
              success: data && data.success,
              hasMessage: !!(data && data.message),
              metres: null
            });
            return null;
          }
          var parsed = JSON.parse(data.message);
          var routes = parsed && parsed.routes;
          var legs = routes && routes.length > 0 ? routes[0].legs : null;
          var distance = legs && legs.length > 0 ? legs[0].distance : null;
          var duration = legs && legs.length > 0 ? legs[0].duration : null;
          var metres = null;
          if (distance != null && distance.value !== undefined && distance.value !== null) {
            metres = Number(distance.value);
            if (!isFinite(metres) || metres < 0) {
              metres = null;
            }
          }
          if (duration != null && duration.value !== undefined && duration.value !== null) {
            var seconds = Number(duration.value);
            if (isFinite(seconds) && seconds > 0) {
              this.$data.travelDurationSeconds = seconds;
            }
          }
          this.logDeliveryDistance('google-parse', {
            success: data.success,
            googleStatus: parsed && parsed.status,
            errorMessage: parsed && parsed.error_message,
            routeCount: routes ? routes.length : 0,
            distanceText: distance ? distance.text : null,
            distanceValue: distance ? distance.value : null,
            durationValue: duration ? duration.value : null,
            metres: metres
          });
          return metres;
        } catch (err) {
          this.logDeliveryDistance('google-parse-error', { error: err && err.message });
          return null;
        }
      },
      applyDeliveryDistanceResult: function(metres, useDistanceLimit, maxDistance, postCodeAllowed) {
        var limitMiles = isFinite(maxDistance) ? (maxDistance / 1600) : null;
        var resultMiles = metres !== null && isFinite(metres) ? (metres / 1600) : null;
        var overLimit = useDistanceLimit && postCodeAllowed == false && metres !== null && isFinite(metres) && isFinite(maxDistance) && maxDistance > 0 && metres > maxDistance;
        this.logDeliveryDistance('apply-result', {
          metres: metres,
          miles: resultMiles,
          maxDistanceMetres: maxDistance,
          limitMiles: limitMiles,
          useDistanceLimit: useDistanceLimit,
          postCodeAllowed: postCodeAllowed,
          overLimit: overLimit
        });
        if (metres !== null && isFinite(metres)) {
          this.$data.distance = metres;
          if (overLimit) {
            var message = "";
            if(this.$data.currentMerchantItem.delivery.beyondLimitMessage != undefined && this.$data.currentMerchantItem.delivery.beyondLimitMessage.length > 0) {
              message = this.$data.currentMerchantItem.delivery.beyondLimitMessage;
            }
            this.logDeliveryDistance('reject-too-far', {
              metres: metres,
              miles: resultMiles,
              limitMiles: limitMiles,
              message: message
            });
            this.rejectDeliveryDistance(message);
            return;
          }
          this.logDeliveryDistance('accept', { metres: metres, miles: resultMiles, reason: maxDistance > 0 ? 'within-limit' : 'limit-not-applied' });
          this.acceptEnteredDeliveryAddress();
          return;
        }
        if (this.isSameDeliveryLocation(this.getDeliveryDistanceOrigin(), this.$data.address)) {
          this.logDeliveryDistance('accept', { metres: 0, miles: 0, reason: 'same-location-fallback' });
          this.$data.distance = 0;
          this.$data.travelDurationSeconds = 0;
          this.acceptEnteredDeliveryAddress();
          return;
        }
        if(useDistanceLimit && postCodeAllowed == false) {
          this.logDeliveryDistance('reject-no-distance', { metres: metres, maxDistanceMetres: maxDistance });
          this.rejectDeliveryDistance("Sorry, we could not check delivery distance. Please try again.");
          return;
        }
        this.logDeliveryDistance('accept', { metres: metres, reason: 'distance-limit-disabled' });
        this.acceptEnteredDeliveryAddress();
      },
      rejectDeliveryDistance: function(message) {
        this.$data.distanceOk = false;
        var self = this;
        this.showPopup("", message || "Sorry, this address is too far for delivery", "", "", null, null, function(){
          let basePath = self.$route.path.split('/')[1];
          if(self.$route.query.hasOwnProperty("id")) {
            window.location.href = '/' +basePath + '/' + self.$route.query.id + '/takeaway';
            self.$route.query.type = 'takeaway';
          } else if(self.$route.params.hasOwnProperty("id")) {
            window.location.href = '/' +basePath + '/' + self.$route.params.id + '/takeaway';
            self.$route.params.type = 'takeaway';
          }
        });
      },
      onPostCodeEntered: function() {
        if(this.$data.address == false) {
          return;
        }
        if(this.$data.currentMerchantItem.delivery == undefined || this.$data.currentMerchantItem.delivery == null) {
          this.$data.currentMerchantItem.delivery = {};
        }
        this.$data.conditionalMinOrder = 0;
        if(this.$data.currentMerchantItem.delivery.minOrder != undefined) {
          this.$data.minOrder = this.$data.currentMerchantItem.delivery.minOrder*100;
        }
        let to = this.$data.address;
        if(this.$data.order != false) {
          this.$data.order.address = to;
        }
        this.$data.distanceOk = false;

        let postCodeAllowed = false;
        if(this.$data.limitType === 'postcode') {
          if(this.$data.currentMerchantItem.delivery.postCodeList != undefined
            && this.$data.currentMerchantItem.delivery.postCodeList !== ''
            && this.$data.currentMerchantItem.delivery.postCodeList.length > 0) {
            let firstCode = this.extractOutwardPostcode(to);
            let date = new Date();
            let dayOfWeek = date.getDay();
            if(firstCode.length > 0) {
              for(let p = 0 ; p < this.$data.currentMerchantItem.delivery.postCodeList.length ; p++) {
                if(this.$data.currentMerchantItem.delivery.postCodeList[p].postCode === firstCode) {
                  if(this.$data.currentMerchantItem.delivery.postCodeList[p].days === undefined || this.$data.currentMerchantItem.delivery.postCodeList[p].days[dayOfWeek] === 'true' || this.$data.currentMerchantItem.delivery.postCodeList[p].days[dayOfWeek] === true) {
                    postCodeAllowed = true;
                    if(this.$data.currentMerchantItem.delivery.postCodeList[p].minOrder !== undefined && parseFloat(this.$data.currentMerchantItem.delivery.postCodeList[p].minOrder) > 0) {
                      this.$data.conditionalMinOrder = parseFloat(this.$data.currentMerchantItem.delivery.postCodeList[p].minOrder);
                    }
                  }
                  break;
                }
              }
            }
          }
          if(postCodeAllowed == false) {
            let pcMessage = "";
            if(this.$data.currentMerchantItem.delivery.beyondLimitMessage != undefined && this.$data.currentMerchantItem.delivery.beyondLimitMessage.length > 0) {
              pcMessage = this.$data.currentMerchantItem.delivery.beyondLimitMessage;
            }
            this.logDeliveryDistance('reject-postcode', { outwardPostcode: this.extractOutwardPostcode(to) });
            this.rejectDeliveryDistance(pcMessage || "Sorry, we do not deliver to your post code");
            return;
          }
        }

        let from = this.getDeliveryDistanceOrigin();
        let delivery = this.$data.currentMerchantItem.delivery;
        let maxDistance = this.getDeliveryMaxDistanceMetres(delivery);
        // Distance limit only applies in 'distance' mode; 0 (or blank) means no limit.
        let useDistanceLimit = this.$data.limitType === 'distance' && isFinite(maxDistance) && maxDistance > 0;
        this.logDeliveryDistance('start', {
          from: from,
          to: to,
          merchantAddress: this.$data.currentMerchantItem.address,
          postCodeFrom: delivery.postCodeFrom,
          useDistanceLimitRaw: delivery.useDistanceLimit,
          useDistanceLimit: useDistanceLimit,
          distanceLimitRaw: delivery.distanceLimit,
          maxDistanceMetres: maxDistance,
          limitMiles: isFinite(maxDistance) ? maxDistance / 1600 : null,
          postCodeAllowed: postCodeAllowed,
          outwardPostcode: this.extractOutwardPostcode(to),
          fullPostcode: this.extractFullPostcode(to),
          sameLocation: this.isSameDeliveryLocation(from, to)
        });

        if(!from) {
          this.logDeliveryDistance('no-origin', { useDistanceLimit: useDistanceLimit, postCodeAllowed: postCodeAllowed });
          if(useDistanceLimit && postCodeAllowed == false) {
            this.rejectDeliveryDistance("Delivery distance cannot be checked. Please call the restaurant.");
            return;
          }
          this.acceptEnteredDeliveryAddress();
          return;
        }

        if (this.isSameDeliveryLocation(from, to)) {
          this.logDeliveryDistance('accept', { metres: 0, miles: 0, reason: 'same-location' });
          this.$data.distance = 0;
          this.$data.travelDurationSeconds = 0;
          this.acceptEnteredDeliveryAddress();
          return;
        }

        let self = this;
        this.setLoadingView(true, "Getting Distance...");
        getDistance(from, to)
          .then(function(data){
            self.setLoadingView(false);
            self.logDeliveryDistance('google-http', {
              success: data && data.success,
              messageLength: data && data.message ? String(data.message).length : 0
            });
            self.applyDeliveryDistanceResult(self.readGoogleDistanceMetres(data), useDistanceLimit, maxDistance, postCodeAllowed);
          })
          .catch(function(err) {
            self.setLoadingView(false);
            self.logDeliveryDistance('google-http-error', { error: err && (err.message || String(err)) });
            self.applyDeliveryDistanceResult(null, useDistanceLimit, maxDistance, postCodeAllowed);
          });
      },
      onTypeClicked: function(newType) {
          if(this.$data.type === newType) {
            return;
          }
          if(newType === 'takeaway' && this.$data.enableTakeaway == false) {
            this.showPopup("", "Takeaway is not available");
            return;
          }
          if(newType == 'delivery' && this.$data.enableDelivery == false) {
            this.showPopup("", "Delivery is not available");
            return;
          }
          // if(this.$data.enableTakeaway == false || this.$data.enableDelivery == false) {
          //   return;
          // }
          let message = 'Do you want to change to ';
          let newtype = '';
          if(this.$data.type == 'takeaway') {
            message += 'Delivery order';
            newtype = 'delivery';
          } else if(this.$data.type === 'delivery') {
            message += 'Takeaway order';
            newtype = 'takeaway';
          } else {
            return;
          }

          message += '?';
          let self = this;
          this.showPopup("",message, "Change", "No",
                function(){
                  self.$data.popup.show = false;
                  let basePath = self.$route.path.split('/')[1];

                  // basePath = 'order';
                  if(self.$route.query.hasOwnProperty("id")) {
                    // console.log("move to " + '/' +basePath + '/' + self.$route.query.id + '/'+newtype);
                    window.location.href = '/' +basePath + '/' + self.$route.query.id + '/' + newtype;
                    // Router.push('/' +basePath + '/' + self.$route.query.id + '/' + newtype);
                    self.$route.query.type = newtype;
                  } else if(self.$route.params.hasOwnProperty("id")) {
                    // console.log("move to " + '/' +basePath + '/' + self.$route.params.id + '/'+newtype);
                    window.location.href = '/' +basePath + '/' + self.$route.params.id + '/' + newtype;
                    // Router.push('/' +basePath + '/' + self.$route.params.id + '/' + newtype);
                    self.$route.params.type = newtype;
                  }
                  // self.$data.type = newtype;
                  // self.updatePage();                  // if(self.$route.params.hasOwnProperty('id')) {
                  //   // console.log("Params " + this.$route.params.id);
                  //   Router.push('/restaurant?id='+self.$route.params.id + '&type=' + newtype);
                  //   console.log("Push to " + '/restaurant?id='+self.$route.params.id + '&type=' + newtype);
                  // } else if(self.$route.query.hasOwnProperty('id')) {
                  //   // console.log("Query " + this.$route.query.id);
                  //   Router.push('/restaurant?id='+self.$route.query.id + '&type=' + newtype);
                  //   console.log("Push to " + '/restaurant?id='+self.$route.query.id + '&type=' + newtype);
                  // }

                },
                function(){
                  self.$data.popup.show = false;
                })
      },
      getMenus: function(merchantId) {
        let self = this;
        // let check1 = new Date().getTime();
        EventBus.$emit("showLoading", true, "Getting menu list");
        let type = 'dineIn';
        if(this.$data.type === 'takeaway' || this.$data.type === 'room') {
          type = 'takeaway';
        }else if(this.$data.type === 'delivery') {
          type = 'delivery';
        } else if(this.$data.type === 'collection') {
          type = 'collection';
        }

        // console.log("getMenus for " + merchantId);
        getMerchantMenus(merchantId, type)
          .then(function(data) {
            // console.log(data);
            EventBus.$emit("showLoading", false);
            // let check2 = new Date().getTime();
            // console.log("Get menu time " + (check2-check1));
            if(data.success == true) {
              if(data.list != undefined) {
                // console.log("Menus");
                // console.log(data.list)
                // let menusString = '{"list":' + data.list + '}';
                // menus = JSON.parse(menusString);
                // console.log()
                self.populateMenus(data.list);
              }
            } else {
              // console.log("Failed to get menu list " + data.message);
            }
          })
          .catch(function(err) {
            EventBus.$emit("showLoading", false);
            console.error('Request failed', err && err.response ? err.response.status : '');
          })
      },
      populateMenus: function(list) {
        if(this.$data.sessionAuthorised === false) {
          return;
        }


        this.$data.currentMerchantItem.categories = [];
        this.$data.currentMerchantItem.options = [];
        this.$data.currentMerchantItem.priceSchedules = [];
        this.$data.currentMerchantItem.discounts = [];
        this.$data.currentMerchantItem.priceOptions = [];

        this.$data.currentMerchantItem.lastSelections = [];

        let today = millisToDate(new Date().getTime());

        let recommendedCat = {
          id:-2,
          name: 'Recommended',
          public_name: '',
          description:'',
          list:[],
          horizontal: true,
        }
        let popularCat = {
          id:-1,
          name: 'Popular',
          public_name:'',
          description:'',
          list:[],
          horizontal: false,
        }
        for(let i = 0 ; i < list.length ; i++) {
          // console.log(list[i].name + " Type " + list[i].type + " id " + list[i].id);

          list[i].horizontal = false;
          if( (list[i].public_name === null || list[i].public_name.length === 0) && list[i].name.endsWith(' TA')) {
            list[i].public_name = list[i].name.replace(' TA', '');
          }
          if(list[i].content != null && list[i].content.length > 0) {
            // list[i].content = list[i].content.replaceAll('\n', '');
            // console.log(list[i].content);

            list[i].content = JSON.parse(list[i].content);
          }
          // console.log("Passed");
          if(list[i].type === 'public_category' || list[i].type === 'category') {
            if((list[i].isPublic == 0 || list[i].dineIn == 0) && this.$data.type === 'table') {
              continue;
            }
            if((this.$data.type === 'takeaway' || this.$data.type === 'room' || this.$data.type === 'delivery') && list[i].takeaway == 0) {
              continue;
            }

            if(list[i].list != null && list[i].list.length > 0) {
              for (let j = 0; j < list[i].list.length; j++) {

                if(list[i].list[j].type === 'change_line') {
                  continue;
                }
                // console.log(JSON.stringify(list[i].list[j]));
                // console.log(list[i].list[j].name);
                list[i].list[j].delay = parseInt(list[i].list[j].delay);
                // console.log(list[i].list[j]);
                if( (list[i].list[j].public_name === null || list[i].list[j].public_name.length === 0) && list[i].list[j].name.endsWith(' TA')) {
                  list[i].list[j].public_name = list[i].list[j].name.replace(' TA', '');
                }
                if(list[i].list[j].icons != null && list[i].list[j].icons.length > 0) {
                  // console.log("ICON ");
                  // console.log(JSON.stringify(list[i].list[j].icons));
                  list[i].list[j].icons = JSON.parse(list[i].list[j].icons);
                } else {
                  list[i].list[j].icons = [];
                }
                list[i].list[j].alcohol = false;
                if(list[i].list[j].content != null && list[i].list[j].content.length > 0) {
                  // console.log(list[i].list[j].content);
                  list[i].list[j].content = JSON.parse(list[i].list[j].content);
                  if(list[i].list[j].content.alcohol != undefined) {
                    list[i].list[j].alcohol = list[i].list[j].content.alcohol;
                  }


                }
                list[i].list[j].imgs = [];
                if(list[i].list[j].image_url != null && list[i].list[j].image_url.length > 0) {
                  if(list[i].list[j].image_url.includes('https://borium-rest-menus.s3.eu-west-2.amazonaws.com/boriumPos')) {
                    list[i].list[j].image_url = list[i].list[j].image_url.replace(
                      new RegExp('https://borium-rest-menus.s3.eu-west-2.amazonaws.com/boriumPos', 'g'), 'https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus/aws');
                  }
                  list[i].list[j].imgs = list[i].list[j].image_url.split(',');

                }
                list[i].list[j].tableAvailable = true;
                list[i].list[j].tableMessage = "";
                // console.log("end of " + list[i].list[j].name);
              }
              for (let j = list[i].list.length-1; j >= 0 ; j--) {

                // console.log(list[i].list[j].name + " type " + list[i].list[j].type);
                if((list[i].list[j].type !== 'product' && list[i].list[j].type !== 'set_product') || list[i].list[j].isPublic === 0) {
                  list[i].list.splice(j,1);

                  continue;
                }
                if( (this.$data.type === 'takeaway' || this.$data.type === 'room' || this.$data.type === 'delivery') && list[i].list[j].takeaway == 0) {
                  list[i].list.splice(j,1);
                  continue;
                }
                if(this.$data.type === 'table' && list[i].list[j].dineIn == 0) {
                  list[i].list.splice(j,1);
                  continue;
                }


                if(this.$data.type === 'collection' && list[i].list[j].collection == 0) {

                  list[i].list.splice(j,1);
                  continue;
                }
                if(this.$data.type === 'collection') {
                  let remove = true;

                  if(this.$data.collectionTag === null || this.$data.collectionTag.length === 0) {
                    if(list[i].list[j].tableTags.length > 0) {
                      remove = true;
                    } else {
                      remove = false;
                    }
                  } else if(this.$data.collectionTag.length > 0) {
                    if(list[i].list[j].tableTags.length > 0) {
                      let tags = list[i].list[j].tableTags.split(',');
                      if(tags !== null && tags.length > 0) {
                        for(let t = 0 ; t < tags.length; t++) {
                          if(tags[t] === this.$data.collectionTag) {
                            remove = false;
                            break;
                          }
                        }
                      }
                    }

                  }
                  if(remove === true) {
                    list[i].list.splice(j,1);

                  }
                  continue;
                }



                if(list[i].list[j].tableTags.length > 0) {
                  let tags = list[i].list[j].tableTags.split(',');

                  if(this.$data.tableTags.length == 0) {
                    // list[i].list.splice(j,1);
                    list[i].list[j].tableAvailable = false;
                    list[i].list[j].tableMessage = "Only Available on " + list[i].list[j].tableTags + " Table";
                    continue;
                  }

                  let tableMatching = false;

                  for(let ti = 0 ; ti < tags.length ; ti++) {
                    for(let tti = 0 ; tti < this.$data.tableTags.length ; tti++) {
                      if(tags[ti] === this.$data.tableTags[tti]) {
                        tableMatching = true;
                        break;
                      }
                    }
                    if(tableMatching == true) {
                      break;
                    }
                  }

                  if(tableMatching == false) {
                    // list[i].list.splice(j,1);
                    list[i].list[j].tableAvailable = false;
                    list[i].list[j].tableMessage = "Only Available on " + list[i].list[j].tableTags + " Table";
                    continue;
                  }
                }

              }
              // console.log("END of category");
            }
            this.$data.currentMerchantItem.categories.push(list[i]);
          } else if(list[i].type === 'option') {
            if( (this.$data.type == 'takeaway' || this.$data.type == 'room' || this.$data.type == 'delivery') && list[i].takeaway == 0) {
              continue;
            }
            list[i].priceFrom = false;


            if(list[i].content.list != null && list[i].content.list.length > 0) {
              let lowestPrice = -1;
              let highestPrice = 0;
              for (let j = 0; j < list[i].content.list.length; j++) {
                // console.log(list[i].content.list[j]);
                if(list[i].content.list[j].content != null && list[i].content.list[j].content.length > 0) {
                  // console.log("option list content");
                  list[i].content.list[j].content = JSON.parse(list[i].content.list[j].content);

                }
                // console.log("choice " + parseInt(list[i].content.choice) + " " + parseFloat(list[i].content.list[j].field_price));
                if(list[i].content.required === true && list[i].content.choice !== undefined && parseInt(list[i].content.choice) === 1
                  // && parseFloat(list[i].content.list[j].field_price) > 0
                ) {
                  // console.log("priceFrom set");
                  if(parseFloat(list[i].content.list[j].field_price) <  lowestPrice || lowestPrice === -1) {
                    lowestPrice = parseFloat(list[i].content.list[j].field_price);

                  }
                  if(parseFloat(list[i].content.list[j].field_price) >  highestPrice || highestPrice === -1) {
                    highestPrice = parseFloat(list[i].content.list[j].field_price);
                  }
                  // list[i].priceFrom = true;
                }

                // if(list[i].priceFrom === true) {
                //   list[i].lowestPrice = lowestPrice;
                //
                // }
              }
              if(lowestPrice >= 0 && highestPrice > 0 && highestPrice >  lowestPrice) {
                list[i].priceFrom = true;
                list[i].lowestPrice = lowestPrice;
                list[i].highestPrice = highestPrice;
              }
            }
            this.$data.currentMerchantItem.options.push(list[i]);
            // console.log("option " + list[i].name);
            // console.log(list[i]);

          } else if(list[i].type === 'price_schedule') {
            // console.log("add price schedule " + list[i].name +  '[' + list[i].id +  '] (' + list[i].subscription_id + ')')
            // console.log("add price schedule ");
            // console.log(list[i]);
            // if(parseInt(list[i].id) === 34693) {
            //   list[i].content.to = '23:59';
            //   console.log("time changed for ")
            // }
            this.$data.currentMerchantItem.priceSchedules.push(list[i]);
          } else if(list[i].type === 'discount') {
            this.$data.currentMerchantItem.discounts.push(list[i]);
          } else if(list[i].type === 'price_option') {
            this.$data.currentMerchantItem.priceOptions.push(list[i]);
          }
        }

        if(this.$data.currentMerchantItem.categories.length > 0 && this.$data.currentMerchantItem.priceSchedules.length > 0) {
          for(let i = this.$data.currentMerchantItem.categories.length - 1 ; i >= 0  ; i--) {
            let content = this.$data.currentMerchantItem.categories[i].content;
            if(content == null || content.price_schedule === undefined || content.price_schedule.length == 0) {
              continue;
            }



            let priceSchedule = [];


            for(let s = 0 ; s < content.price_schedule.length ; s++) {
              for(let psi = 0 ; psi < this.$data.currentMerchantItem.priceSchedules.length ; psi++) {
                if(parseInt(content.price_schedule[s].id) === parseInt(this.$data.currentMerchantItem.priceSchedules[psi].id)) {

                  priceSchedule.push(content.price_schedule[s]);
                  break;
                }
              }
            }
            let toShow = false;


            for(let s = 0 ; s < priceSchedule.length ; s++) {

              if(this.isMeetPriceSchedule(priceSchedule[s].id, true) === true) {
                toShow = true;
                break;
              }
            }

            if(toShow == false) {
              this.$data.currentMerchantItem.categories.splice(i, 1);
            }
          }
        }

        if(this.$data.currentMerchantItem.categories.length > 0 && this.$data.currentMerchantItem.priceSchedules.length > 0) {
          for (let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
            // console.log("CATEGORY " + this.$data.currentMerchantItem.categories[i].name);
            if(this.$data.currentMerchantItem.categories[i].list !== undefined && this.$data.currentMerchantItem.categories[i].list.length > 0) {
              for(let j = this.$data.currentMerchantItem.categories[i].list.length - 1 ; j >= 0 ; j--) {

                // console.log("Check Menu "+ this.$data.currentMerchantItem.categories[i].list[j].name)
                let content = this.$data.currentMerchantItem.categories[i].list[j].content;
                // console.log(content);

                if(content !== null && content.message !== undefined && content.message === true) {
                  this.$data.currentMerchantItem.categories[i].list.splice(j, 1);
                  continue;
                }
                // console.log("check validity " +this.$data.currentMerchantItem.categories[i].list[j].name );
                // console.log(content);
                if(content !== null && content.valid !== undefined && content.valid.enabled === true) {
                  // console.log("check validity " +this.$data.currentMerchantItem.categories[i].list[j].name );
                  // console.log(content);
                  if(content.valid.dateFrom > today || content.valid.dateTo < today) {
                    this.$data.currentMerchantItem.categories[i].list.splice(j, 1);
                    continue;
                  }
                }
                if(content === null || content.price_schedule === undefined || content.price_schedule.length == 0) {

                  continue;
                }


                // console.log("Check price schedule " + this.$data.currentMerchantItem.categories[i].list[j].name);
                let priceSchedule = content.price_schedule;
                for(let s = 0 ; s < priceSchedule.length ; s++) {
                  // console.log("price schedule check " + priceSchedule[s].id)
                  if(this.isMeetPriceScheduleToShow(priceSchedule[s].id) === false) {
                    this.$data.currentMerchantItem.categories[i].list.splice(j, 1);
                    break;
                  }
                  if(this.isMeetPriceSchedule(priceSchedule[s].id) === true) {
                    if(priceSchedule[s].price !== undefined && priceSchedule[s].price !== null && isNaN(priceSchedule[s].price) === false) {
                      this.$data.currentMerchantItem.categories[i].list[j].originalPrice = this.$data.currentMerchantItem.categories[i].list[j].price;
                      if(parseFloat(priceSchedule[s].price) === 0) {
                        for(let si = 0 ; si < this.$data.currentMerchantItem.priceSchedules.length ; si++) {
                          if(this.$data.currentMerchantItem.priceSchedules[si].id === priceSchedule[s].id) {
                            if(this.$data.currentMerchantItem.priceSchedules[si].content.use_percent !== undefined && this.$data.currentMerchantItem.priceSchedules[si].content.use_percent === true && this.$data.currentMerchantItem.priceSchedules[si].content.percent > 0) {
                              this.$data.currentMerchantItem.categories[i].list[j].price = Math.round(this.$data.currentMerchantItem.categories[i].list[j].price*100 * this.$data.currentMerchantItem.priceSchedules[si].content.percent/100) / 100.0;

                            }
                            break;
                          }
                        }
                      } else {
                        this.$data.currentMerchantItem.categories[i].list[j].price = priceSchedule[s].price;
                      }

                      this.$data.currentMerchantItem.categories[i].list[j].promotion = priceSchedule[s].name;

                      // console.log(this.$data.currentMerchantItem.categories[i].list[j].name + " ps " + this.$data.currentMerchantItem.categories[i].list[j].price + " orig " + this.$data.currentMerchantItem.categories[i].list[j].originalPrice );
                    }
                    break;
                  }
                }
              }
            }

          }
        }

        if(this.$data.currentMerchantItem.categories.length > 0) {
          for (let i = 0; i < this.$data.currentMerchantItem.categories.length; i++) {
            // console.log("CATEGORY " + this.$data.currentMerchantItem.categories[i].name);
            if (this.$data.currentMerchantItem.categories[i].list != undefined && this.$data.currentMerchantItem.categories[i].list.length > 0) {
              for (let j = 0; j < this.$data.currentMerchantItem.categories[i].list.length; j++) {
                if (this.$data.currentMerchantItem.categories[i].list[j].recommended == 1) {
                  recommendedCat.list.push(JSON.parse(JSON.stringify(this.$data.currentMerchantItem.categories[i].list[j])));
                }

                if (this.$data.currentMerchantItem.categories[i].list[j].popular == 1) {
                  popularCat.list.push(JSON.parse(JSON.stringify(this.$data.currentMerchantItem.categories[i].list[j])));
                }

                if(this.$data.currentMerchantItem.categories[i].list[j].lastSelection == 1) {
                  let lastItem = JSON.parse(JSON.stringify(this.$data.currentMerchantItem.categories[i].list[j]));
                  lastItem.selected = false;
                  // console.log(lastItem.name + " added to final selection");
                  this.$data.currentMerchantItem.lastSelections.push(lastItem);
                }
              }
            }
          }
        }

        if(popularCat.list.length > 0) {
          this.$data.currentMerchantItem.categories.unshift(popularCat)
        }
        if(recommendedCat.list.length > 0) {
          this.$data.currentMerchantItem.categories.unshift(recommendedCat)
        }

        for(let i = 0 ; this.$data.currentMerchantItem.categories.length > i ; i++) {
          if(this.$data.currentMerchantItem.categories[i].list !== undefined && this.$data.currentMerchantItem.categories[i].list.length > 0) {
            for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
              this.$data.currentMerchantItem.categories[i].list[j].priceFrom = false;
              this.$data.currentMerchantItem.categories[i].list[j].lowestgPrice = 0;
              if(this.$data.currentMerchantItem.categories[i].list[j].content !== undefined && this.$data.currentMerchantItem.categories[i].list[j].content !== null &&
                this.$data.currentMerchantItem.categories[i].list[j].content.options !== undefined &&
                this.$data.currentMerchantItem.categories[i].list[j].content.options !== null &&
                this.$data.currentMerchantItem.categories[i].list[j].content.options.length > 0) {

                for(let k = 0 ; k < this.$data.currentMerchantItem.categories[i].list[j].content.options.length ; k++) {
                  for(let l = 0 ; l < this.$data.currentMerchantItem.options.length ; l++) {
                    if(parseInt(this.$data.currentMerchantItem.categories[i].list[j].content.options[k].id) === parseInt(this.$data.currentMerchantItem.options[l].id)) {
                      if(this.$data.currentMerchantItem.options[l].priceFrom === true) {
                        this.$data.currentMerchantItem.categories[i].list[j].priceFrom = true;
                        if(this.$data.currentMerchantItem.options[l].lowestPrice !== undefined) {
                          this.$data.currentMerchantItem.categories[i].list[j].lowestPrice = this.$data.currentMerchantItem.options[l].lowestPrice;
                        }
                      }
                      // console.log("found option");
                      // console.log(this.$data.currentMerchantItem.options[l]);
                    }
                  }
                }
                this.$data.currentMerchantItem.categories[i].list[j].selected = true;
              }
            }
          }
        }

        if(this.$data.sessionAuthorised === false) {
          this.$data.currentMerchantItem.categories = [];
          return;
        }
        // console.log("Categories");
        // console.log(this.$data.currentMerchantItem.categories);

        // console.log(this.$data.currentMerchantItem);

        this.getUserPoint();
      },

      toggleLastSelection: function(index, id) {
        // console.log("toggle " + item.name);
        for(let i = 0 ; i < this.$data.currentMerchantItem.lastSelections.length ; i++) {
          if(this.$data.currentMerchantItem.lastSelections[i].id == id) {
            this.$data.currentMerchantItem.lastSelections[i].selected = !this.$data.currentMerchantItem.lastSelections[i].selected;
            // console.log(this.$data.currentMerchantItem.lastSelections[i].name + "  is now " + this.$data.currentMerchantItem.lastSelections[i].selected);
            // return;
          }
        }
      },
      isMeetPriceScheduleToShow: function(pid) {
        // console.log("isMeetPriceSchedule " + pid);
        if(this.$data.currentMerchantItem.priceSchedules.length == 0) {
          // console.log("no price schedules");
          return true;
        }
        let today = new Date();
        let day = today.getDay();
        day = day-1;
        if(day < 0) {
          day = 6;
        }
        if(today.getHours() < 6) {
          day--;
          if(day < 0) {
            day = 6;
          }
        }
        let tableType = 'dinein';
        if(this.$data.type == 'takeaway' || this.$data.type == 'room') {
          tableType = 'takeaway';
        } else if(this.$data.type == 'delivery') {
          tableType = 'delivery';
        }

        let HM = millisToHM(today.getTime());
        for(let i = 0 ; i < this.$data.currentMerchantItem.priceSchedules.length ; i++) {

          if(this.$data.currentMerchantItem.priceSchedules[i].content.show_time !== undefined && this.$data.currentMerchantItem.priceSchedules[i].content.show_time === true && this.$data.currentMerchantItem.priceSchedules[i].id == pid) {
            if(this.$data.currentMerchantItem.priceSchedules[i].content.type[tableType] == undefined  || this.$data.currentMerchantItem.priceSchedules[i].content.type[tableType] == false) {
              // console.log(this.$data.currentMerchantItem.priceSchedules[i].content.type);
              // console.log("Canot find tableType " + tableType);
              return false;
            }
            let days = this.$data.currentMerchantItem.priceSchedules[i].content.dayOfWeek;
            // console.log("days " + day);
            // console.log(days);
            if(days[day].apply == true) {
              // console.log("compare time " + HM + "  range " + this.$data.currentMerchantItem.priceSchedules[i].content.from + " - " + this.$data.currentMerchantItem.priceSchedules[i].content.to);

              if(this.$data.currentMerchantItem.priceSchedules[i].content.from > this.$data.currentMerchantItem.priceSchedules[i].content.to) {
                if(HM > this.$data.currentMerchantItem.priceSchedules[i].content.from || HM <= this.$data.currentMerchantItem.priceSchedules[i].content.to) {
                  // console.log("day time is in range " + HM + " " + days[day].from + " - " + days[day].to);
                  return true;
                }
              } else {
                if (HM >= this.$data.currentMerchantItem.priceSchedules[i].content.from && HM < this.$data.currentMerchantItem.priceSchedules[i].content.to) {
                  // console.log("day time is in range " + HM + " " + days[day].from + " - " + days[day].to);
                  return true;
                }
              }

            }
            // console.log("nothing matches");
            return false;

          }
        }
        // console.log("no price schedules");
        return true;
      },
      isMeetPriceSchedule: function(pid, isCategory = false) {
        if(this.$data.currentMerchantItem.priceSchedules.length === 0) {
          // console.log("no price schedules");
          return true;
        }
        let today = new Date();
        let day = today.getDay();
        day = day-1;
        if(day < 0) {
          day = 6;
        }
        if(today.getHours() < 6) {
          day--;
          if(day < 0) {
            day = 6;
          }
        }
        let tableType = 'dinein';
        if(this.$data.type == 'takeaway' || this.$data.type == 'room') {
          tableType = 'takeaway';
        } else if(this.$data.type == 'delivery') {
          tableType = 'delivery';
        }

        let HM = millisToHM(today.getTime());

        for(let i = 0 ; i < this.$data.currentMerchantItem.priceSchedules.length ; i++) {

          if(parseInt(this.$data.currentMerchantItem.priceSchedules[i].id) === parseInt(pid)) {
            if(isCategory === false && this.$data.currentMerchantItem.priceSchedules[i].content.show_time !== undefined && this.$data.currentMerchantItem.priceSchedules[i].content.show_time === true) {
              // console.log("show time so return false");
              return false;
            }
            if(this.$data.currentMerchantItem.priceSchedules[i].content.type[tableType] === undefined  || this.$data.currentMerchantItem.priceSchedules[i].content.type[tableType] === false) {
              // console.log(this.$data.currentMerchantItem.priceSchedules[i].content.type);
              // console.log("Cannot find tableType " + tableType);
              return false;
            }
            let days = this.$data.currentMerchantItem.priceSchedules[i].content.dayOfWeek;
            if(days[day].apply === true) {
              // console.log("compare time " + HM + "  range " + this.$data.currentMerchantItem.priceSchedules[i].content.from + " - " + this.$data.currentMerchantItem.priceSchedules[i].content.to);

              if(this.$data.currentMerchantItem.priceSchedules[i].content.from > this.$data.currentMerchantItem.priceSchedules[i].content.to) {
                if(HM > this.$data.currentMerchantItem.priceSchedules[i].content.from || HM <= this.$data.currentMerchantItem.priceSchedules[i].content.to) {
                  // console.log("day time is in range " + HM + " " + this.$data.currentMerchantItem.priceSchedules[i].content.from + " - " + this.$data.currentMerchantItem.priceSchedules[i].content.to);
                  return true;
                }
              } else {
                if (HM >= this.$data.currentMerchantItem.priceSchedules[i].content.from && HM < this.$data.currentMerchantItem.priceSchedules[i].content.to) {
                  // console.log("day time is in range " + HM + " " + this.$data.currentMerchantItem.priceSchedules[i].content.from + " - " + this.$data.currentMerchantItem.priceSchedules[i].content.to);
                  return true;
                }
              }

            }
            // console.log("nothing matches return false");
            return false;

          }
        }

        // console.log("no price schedules");
        return true;
      },
      searchWordIncluded: function(menu) {


        if( menu.public_name.toLowerCase().includes(this.$data.searchWord.toLowerCase().trim()) || menu.name.toLowerCase().includes(this.$data.searchWord.toLowerCase().trim())) {

          return true;
        }
        // console.log(this.$data.searchWord + "  not found in " + menu.public_name + " " + menu.name);
        return false;
      },
      selectMenuAnim: function(item) {
          if(item.soldOut == 1) {
            return;
          }
          if(item.tableAvailable == false) {
            return;
          }
          setTimeout(this.selectMenu, this.$data.animDuration, item);
      },
      getMinimumOrderDescription: function(id) {
        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          if(this.$data.currentMerchantItem.categories[i].list != null && this.$data.currentMerchantItem.categories[i].list.length > 0) {
            for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
              if(this.$data.currentMerchantItem.categories[i].list[j].id == id) {
                if(this.$data.currentMerchantItem.categories[i].list[j].min_order > 1) {
                  let text = 'Minimum order ' + this.$data.currentMerchantItem.categories[i].list[j].min_order;
                  if(this.$data.currentMerchantItem.categories[i].list[j].groupTags != null && this.$data.currentMerchantItem.categories[i].list[j].groupTags.length > 0) {
                    text += " " + this.$data.currentMerchantItem.categories[i].list[j].groupTags;
                  }
                  return text;
                } else {
                  return '';
                }

              }
            }
          }
        }
        return '';
      },
      changeChoiceItem: function(index, diff) {
        if(diff > 0 && this.$data.optionSelectItem.itemOption.maxChoice > 0) {
          let count = 0;
          for(let i = 0 ; i < this.$data.optionSelectItem.itemOption.selectedItems.length ; i++) {
            count += this.$data.optionSelectItem.itemOption.selectedItems[i].amount;
          }
          // console.log(count + " items selected vs " + this.$data.optionSelectItem.itemOption.maxChoice);
          if(count >= this.$data.optionSelectItem.itemOption.maxChoice) {
            this.showPopup("Maximum " + this.$data.optionSelectItem.itemOption.maxChoice + " items", "You already selected " + count + " items");
            return;
          }

        }
        if(diff < 0 && this.$data.optionSelectItem.itemOption.selectedItems[index].amount === 0) {
          return;
        }
        this.$data.optionSelectItem.itemOption.selectedItems[index].amount += diff;

        let numberOfItems = 0;
        let selectedPriceCount = 0;
        for(let i = 0 ; i < this.$data.optionSelectItem.itemOption.selectedItems.length ; i++) {
          numberOfItems += this.$data.optionSelectItem.itemOption.selectedItems[i].amount;
        }
        // Now check price
        let price = 0;
        // console.log(this.$data.optionSelectItem.itemOption.priceList);
        if(this.$data.optionSelectItem.itemOption.priceList !== undefined && this.$data.optionSelectItem.itemOption.priceList !== null && this.$data.optionSelectItem.itemOption.priceList.length > 0) {
          for(let i = this.$data.optionSelectItem.itemOption.priceList.length - 1 ; i >= 0 ; i--) {
            // console.log("price item " + i  + " for " + this.$data.optionSelectItem.itemOption.priceList[i].numberOfItems + " check " + numberOfItems);
            if(this.$data.optionSelectItem.itemOption.priceList[i].numberOfItems >= numberOfItems) {
              price = Math.round(parseFloat(this.$data.optionSelectItem.itemOption.priceList[i].price)*100);
              selectedPriceCount = this.$data.optionSelectItem.itemOption.priceList[i].numberOfItems;
              // console.log("matching " + price + " " + selectedPriceCount);
            }
          }
        }

        if(price > 0) {

          this.$data.optionSelectItem.price = price;
          // console.log("price now is " + this.$data.optionSelectItem.price)
          if(this.$data.optionSelectItem.menuName.includes(" (")) {
            this.$data.optionSelectItem.menuName = this.$data.optionSelectItem.menuName.split(" (")[0];
          }
          this.$data.optionSelectItem.menuName += " ( " + selectedPriceCount + " Items )";

          if(this.$data.optionSelectItem.publicMenuName.includes(" (")) {
            this.$data.optionSelectItem.publicMenuName = this.$data.optionSelectItem.publicMenuName.split(" (")[0];
          }
          this.$data.optionSelectItem.publicMenuName += " ( " + selectedPriceCount + " Items )";
        }

        this.optionSelectionItemPrice();


      },
      selectMenu: function(item) {

        if(item.soldOut === '1' || item.soldOut === 1) {
          return;
        }
        if(item.tableAvailable === false) {
          return;
        }
        let adder = '?';
        if(this.$data.type === 'table') {
          adder = "&";
        }
        let path = this.$data.basePath + adder + 'item='+item.id;
        if(this.$data.currentPath !== path) {
          this.$router.push(path);
        }

        // console.log("select Menu");
        // console.log(item);
        let orderItem = {
          id:0,
          parentId:0,
          recordType:0,
          itemType: 0,
          menuName: item.name,
          publicMenuName: item.name,
          menuId: item.id,
          amount:1,
          price: Math.round(item.price*100),
          originalPrice: Math.round(item.price*100),
          totalPrice: Math.round(item.price*100),
          taxRate: Math.round(item.tax_rate*100),
          taxAmount:0,
          discountAmount:0,
          discountTitle:'',
          discountRate:0,
          optionSelection:[],
          orderedAmount:0,
          orderedTime:0,
          customerIndex:0,
          subscriptionId: this.$data.currentMerchantItem.merchantId,
          description: JSON.parse(JSON.stringify(item.content)),
          notifyKitchen: item.notify_kitchen===1?true:false,
          notifyBar: item.notify_bar===1?true:false,
          notifyKitchen2: item.notify_kitchen2===1?true:false,
          notifyBar2: item.notify_bar2===1?true:false,
          asMain: false,
          optionPrice:0,
          options:[],
          status:0,
          state:0,
          memo:'',
          itemOption:false,
          pointsUsed:0,
          pricePoints:item.pricePoints,
          imgs:item.imgs,
          tags:this.$data.UUID,
          excludeFromPromotion: item.excludeFromPromotion,
          alcohol: false,
          youtube: item.youtube,
          icons: JSON.parse(JSON.stringify(item.icons)),
          minOrder:item.min_order,
          groupTags:'',
          delay: item.delay,
          note: item.note,
        }
        if(item.groupTags != null && item.groupTags.length > 0) {
          orderItem.groupTags = item.groupTags;
        }
        if(item.alcohol != undefined) {
          orderItem.alcohol = item.alcohol;
        }
        if(item.public_name != undefined && item.public_name != null && item.public_name.length > 0) {
          orderItem.publicMenuName = item.public_name;
        }
        // Math.round is required when converting pounds to pence: floating point
        // multiplication (e.g. 8.94 * 100) can yield values like 893.9999999999999.
        if(this.$data.type === 'takeaway' || this.$data.type === 'room') {
          if(item.price_ta > 0) {
            orderItem.price = Math.round(item.price_ta * 100);
            orderItem.originalPrice = Math.round(item.price * 100);
          }
          orderItem.taxRate = Math.round(item.tax_rate_ta * 100);
        } else if(this.$data.type === 'delivery') {
          if(item.price_delivery > 0) {
            orderItem.price = Math.round(item.price_delivery * 100);
            orderItem.originalPrice = Math.round(item.price * 100);
          } else if(item.price_ta > 0) {
            orderItem.price = Math.round(item.price_ta * 100);
            orderItem.originalPrice = Math.round(item.price * 100);
          }
        }
        // if(orderItem.excludeFromPromotion == 0) {
        //   orderItem.price = this.getPrice(orderItem.price);
        // }
        // console.log("Price " + orderItem.price);
        orderItem.totalPrice = orderItem.price;
        // if(this.$data.order == false || this.$data.order.list.length == 0) {
        //   orderItem.id = 1;
        // } else {
        //   orderItem.id = this.$data.order.list.length;
        // }
        // console.log("item content")
        // console.log(item.content)
        if(item.content != null) {
          // let content = JSON.parse(item.content);

          if(item.content.itemOption !== undefined && item.content.itemOption !== false) {
            if(item.content.itemOption.type !== undefined && item.content.itemOption.type === 'change_choice') {
              item.content.itemOption.defaultItems = [];
              item.content.itemOption.alternativeItems = [];
              orderItem.itemOption = JSON.parse(JSON.stringify(item.content.itemOption));


              // orderItem.itemOption.defaultItems = [];
              for(let d = 0 ; d < orderItem.itemOption.list.length ; d++) {
                orderItem.itemOption.defaultItems.push({
                  title: orderItem.itemOption.list[d],
                  selected: orderItem.itemOption.defaultSelected,
                  amount:1,
                });
              }

              // orderItem.itemOption.alternativeItems = [];
              for(let d = 0 ; d < orderItem.itemOption.alternativeList.length ; d++) {
                orderItem.itemOption.alternativeItems.push({
                  title: orderItem.itemOption.alternativeList[d],
                  selected: false,
                  amount:1,
                });
              }
            } else if(item.content.itemOption.type !== undefined && item.content.itemOption.type === 'variable_price') {
              item.content.itemOption.selectedItems = [];
              item.content.itemOption.maxChoice = 0;
              if(item.content.itemOption.priceList !== undefined && item.content.itemOption.priceList !== null && item.content.itemOption.priceList.length > 0) {
                item.content.itemOption.priceList.sort(function(a, b) {
                  if(a.numberOfItems > b.numberOfItems) {
                    return 1;
                  } else if(a.numberOfItems < b.numberOfItems) {
                    return -1;
                  }
                  return 0;
                })
                for(let pi = 0 ; pi < item.content.itemOption.priceList.length ; pi++) {
                  if(item.content.itemOption.priceList[pi].numberOfItems > item.content.itemOption.maxChoice) {
                    item.content.itemOption.maxChoice = item.content.itemOption.priceList[pi].numberOfItems;
                  }
                }
              }
              orderItem.itemOption = JSON.parse(JSON.stringify(item.content.itemOption));
              for(let d = 0 ; d < orderItem.itemOption.choiceList.length ; d++) {
                orderItem.itemOption.selectedItems.push({
                  item:orderItem.itemOption.choiceList[d],
                  amount:0,
                })
              }
            }


            // console.log("item option");
            // console.log(orderItem.itemOption);
          }
          if(item.content.section_list !== undefined) {
            if(this.shouldShowSetSelectionView(orderItem) === true) {
              return;
            }
          }
          // console.log(item.content);
          if(item.content.options !== undefined) {
            //Check if option needs to be selected
            if(this.shouldShowOptionSelectionView(orderItem) === true) {
              //Show Option View
              // console.log("should show option view");
              return;
            }
          }
        }

        // if(item.public_name != null && item.public_name.length > 0) {
        //   orderItem.menuName = item.public_name;
        // }

        this.$data.optionSelectItem = orderItem;

        // console.log("select item " + this.$data.optionSelectItem.pricePoints);

        // console.log("select item");
        // console.log(this.$data.optionSelectItem);
//        return true;
        // this.addOrderItem(orderItem);


      },
      changeItemAmount: function(index, diff) {
        this.$data.order.list[index].amount += diff;
        this.$data.order.list[index].totalPrice = this.$data.order.list[index].price*this.$data.order.list[index].amount;
        this.calculatePrice();
      },
      /**
       * Human-readable summary of the minimum order amount and the delivery
       * charge rule, for the landing "Important Notice" popup. Returns ''
       * when there is nothing worth telling the customer.
       */
      getDeliveryNoticeMessage: function() {
        let pounds = function(pence) {
          let n = pence / 100;
          return '£' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
        };
        let lines = [];
        let minOrder = Number(this.$data.minOrder);
        if(isFinite(minOrder) && minOrder > 0) {
          lines.push("Minimum order amount: " + pounds(minOrder));
        }
        let type = Number(this.$data.deliveryChargeType);
        let amount = Number(this.$data.deliveryChargeAmount);
        let freeOver = Number(this.$data.freeDeliveryOver);
        let base = Number(this.$data.deliveryBaseCharge);
        let perMile = Number(this.$data.deliveryChargePerMilePrice);
        if(type === 1 && amount > 0) {
          lines.push("Delivery charge: " + pounds(amount));
        } else if(type === 2 && amount > 0 && freeOver > 0) {
          lines.push("Delivery charge: " + pounds(amount) + " (free for orders of " + pounds(freeOver) + " or more)");
        } else if(type === 3 && (base > 0 || perMile > 0)) {
          let text = "Delivery charge: ";
          if(base > 0 && perMile > 0) {
            text += pounds(base) + " + " + pounds(perMile) + " per mile";
          } else if(perMile > 0) {
            text += pounds(perMile) + " per mile";
          } else {
            text += pounds(base);
          }
          lines.push(text);
        }
        return lines.join("<br/>");
      },
      /**
       * Delivery charge in pence based on the merchant's delivery charge type.
       * Type 0: no charge. Type 1: fixed charge always. Type 2: fixed charge
       * when the items subtotal is below freeDeliveryOver. Type 3: base charge
       * + ceiling(distance in miles) * charge per mile.
       */
      getDeliveryCharge: function() {
        let type = Number(this.$data.deliveryChargeType);
        if(type === 1) {
          return this.$data.deliveryChargeAmount;
        }
        if(type === 2) {
          let itemsTotal = (this.$data.order != false && this.$data.order.totalPrice != undefined) ? Number(this.$data.order.totalPrice) : 0;
          if(itemsTotal >= this.$data.freeDeliveryOver) {
            return 0;
          }
          return this.$data.deliveryChargeAmount;
        }
        if(type === 3) {
          let metres = Number(this.$data.distance);
          let miles = (isFinite(metres) && metres > 0) ? Math.ceil(metres / 1600) : 0;
          return this.$data.deliveryBaseCharge + miles * this.$data.deliveryChargePerMilePrice;
        }
        return 0;
      },
      myTotal: function() {
        if(this.$data.order == false) {
          return '0.00';
        }

        if(this.$data.order.list.length == 0) {
          return '0.00';
        }

        let myTotal = 0;
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].tags != null && this.$data.order.list[i].tags === this.$data.UUID) {
            myTotal += this.$data.order.list[i].totalPrice;
          }
        }
        return Number(myTotal/100).toFixed(2);
      },

      addOrderItemTable: function(item) {

        if(this.$data.order === false) {
          this.$data.order = {
            list:[],
            id:0,
            recordType:0,
            merchantName:this.$data.currentMerchantItem.title,
            menuName:this.$data.tableItem.name,
            tableId:this.$data.tableItem.id,
            price: 0,
            originalPrice: 0,
            orderedAmount: 0,
            totalPrice: 0,
            taxAmount:0,
            taxRate:0,
            serviceChargeRate:0,
            serviceChargeAmount:0,
            totalDue:0,
            optionPrice:0,
            subscriptionId: this.$data.currentMerchantItem.merchantId,
            state:0,
            phoneNumber:'',
            name:'',
            email:'',
            pickupTime:'',
            pickupTimeMilli:0,
            memo:'',
            useSms: this.$data.currentMerchantItem.useSms===1?true:false,
            useEmail: this.$data.currentMerchantItem.useEmail===1?true:false,
            postCode: '',
            address:'',
            points:0,
            pointsUsed:0,
            paymentMethod:'',
            title:'',
            deliveryCharge:0,
            tip:0,
            riderFee:0,
            totalFee:0,
            headCount:0,
            cutleryCount:1,
            deliveryOption:'Leave at door',
            deliveryInstruction:'',
          }


          if(this.$data.type === 'delivery' && this.$data.address != false) {
            this.$data.order.address = this.$data.address;
            // console.log("address is set " + this.$data.order.address);
          }
          let title = {
            merchantAddress:this.$data.currentMerchantItem.address,
            contact: this.$data.currentMerchantItem.contact,
          }
          this.$data.order.title = JSON.stringify(title);
          if(this.$data.tableItem.table_type === 'Take Away') {
            this.$data.order.recordType = 1;
            this.$data.order.menuName += ' (Web)';
          } else if(this.$data.tableItem.table_type === 'Delivery') {
            this.$data.order.recordType = 2;
            this.$data.order.menuName += ' (Web)';
          } else if(this.$data.type === 'table') {
            this.$data.order.serviceChargeRate = this.$data.currentMerchantItem.serviceChargeRate*100;
          }
          // if(item.pointsUsed > 0) {
          //   this.$data.order.pointsUsed = item.pointsUsed;
          // }
          // console.log("Used Points " + this.$data.order.pointsUsed);
          // if(this.$data.type == 'delivery') {
          //   this.$data.order.deliveryCharge = this.getDeliveryCharge();
          // }

        }
        // if(this.checkIfSame(item) == false) {

        // console.log(item);

        for(let i = 0 ; i < this.$data.order.list.length ; i++) {
          if(Number(this.$data.order.list[i].menuId) === Number(item.menuId)) {
            // console.log(this.$data.order.list[i].optionSelection);
            // console.log("::" + JSON.stringify(this.buildOptionSelection(item)));

            if (Number(this.$data.order.list[i].menuId) === Number(item.menuId) &&
              this.$data.order.list[i].state === 0 && this.$data.order.list[i].tags === this.$data.UUID &&
              this.$data.order.list[i].optionSelection === JSON.stringify(this.buildOptionSelection(item))
              && (this.$data.order.list[i].memo === item.memo || ((this.$data.order.list[i].memo === null || this.$data.order.list[i].memo === "") && (item.memo === null || item.memo === "")))) {
              this.itemAmountChanged(item.amount, i);
              return;

            }

          }
        }
          this.$data.order.list.push(item);
        // }
        let orderItem = JSON.parse(JSON.stringify(this.$data.order));

        if(orderItem.memo.length > 0) {
          if(orderItem.memo.includes("'")) {
            orderItem.memo = orderItem.memo.replace("'", "");
          }
          if(orderItem.memo.includes('"')) {
            orderItem.memo = orderItem.memo.replace('"', "");
          }
          // orderItem.memo = orderItem.memo.replace(/[^a-zA-Z ]/g, "");
        }
        for(let i = 0 ; i < orderItem.list.length ; i++) {
          if(orderItem.list[i].id > 0) {
            continue;
          }
          orderItem.list[i].optionSelection = JSON.stringify(this.buildOptionSelection(orderItem.list[i]));
          // console.log(orderItem.list[i])
          orderItem.list[i].options = JSON.stringify(orderItem.list[i].options);
          if(orderItem.list[i].memo.length > 0) {
            if(orderItem.list[i].memo.includes("'")) {
              orderItem.list[i].memo = orderItem.list[i].memo.replace("'", "");
            }
            if(orderItem.list[i].memo.includes('"')) {
              orderItem.list[i].memo = orderItem.list[i].memo.replace('"', "");
            }
            // orderItem.list[i].memo = orderItem.list[i].memo.replace(/[^a-zA-Z ]/g, "");
          }
          // console.log(orderItem.list[i])
        }
        let self = this;
        if(this.$data.preorder === true) {

          // item.parentId = this.$data.order.id;
          updatePreOrder(orderItem)
            .then(function(data) {
              if(data.success == true) {
                // console.log("Added item");
                // console.log(data.item);
                // if(data.item.list != undefined && data.item.list != null && data.item.list.length > 0) {
                //   for(let i = 0 ; i < data.item.list.length ; i++) {
                //     if(data.item.list[i].options != null && data.item.list[i].options.length > 0) {
                //       data.item.list[i].options = JSON.parse(data.item.list[i].options);
                //     }
                //     if(data.item.list[i].optionSelection != null && data.item.list[i].optionSelection.length > 0) {
                //       data.item.list[i].optionSelection = JSON.parse(data.item.list[i].optionSelection);
                //     }
                //   }
                // }
                self.$data.order = data.item;
                self.reorderItem();
                // self.notifyTableFriends();
                // self.subscribeTableOrder();

              }
            })
            .catch(function(err) {

              // console.log("Error adding item to table " + err);
              // if(err.response != undefined) {
              //   console.log(err.response);
              // }
            })
          return;
        }
        // console.log(orderItem);
        // console.log("add item to table order");
        addItemsToTable(orderItem)
        .then(function(data) {
          if(data.success == true) {
            // console.log("Added item");
            // console.log(data.item);
            self.$data.order = data.item;
            self.reorderItem();
            self.notifyTableFriends();
            self.subscribeTableOrder();

          }
          // else {
          //   console.log(data.message);
          // }
        })
        .catch(function(err) {

          self.showPopup("ERROR", "Sorry error occurred. Please check mobil network signal and try again");
          // console.log("Error adding item to table " + err);
          // if(err.response != undefined) {
          //   console.log(err.response);
          // }
        })

      },
      notifyTableFriends: function() {
        // console.log("notify friends");
        if(this.$data.order == false || this.$data.order.id == 0) {
          // console.log("notify friends do nothing");
          return;
        }

        let channel = 'posPublic/' + this.$data.order.id.toString();

        let obj = {
          id:this.$data.order.id,
          totalDue: this.$data.order.totalDue,
          UUID: this.$data.UUID,
        }
        this.sendMessage(channel, JSON.stringify(obj));
      },
      addOrderItem: function(item) {
        if(this.$data.order == false) {
          this.$data.order = {
            list:[],
            id:0,
            recordType:0,
            merchantName:this.$data.currentMerchantItem.title,
            menuName:this.$data.tableItem.name,
            tableId:this.$data.tableItem.id,
            price: 0,
            originalPrice: 0,
            orderedAmount: 0,
            totalPrice: 0,
            taxAmount:0,
            taxRate:0,
            serviceChargeRate:0,
            serviceChargeAmount:0,
            totalDue:0,
            optionPrice:0,
            subscriptionId: this.$data.currentMerchantItem.merchantId,
            state:0,
            countryCode:'+44',
            phoneNumber:'',
            name:'',
            email:'',
            pickupTime:'',
            pickupTimeMilli:0,
            pickupDate:'',
            memo:'',
            useSms: this.$data.currentMerchantItem.useSms==1?true:false,
            useEmail: this.$data.currentMerchantItem.useEmail==1?true:false,
            postCode: '',
            address:'',
            points:0,
            pointsUsed:0,
            paymentMethod:'',
            title:'',
            deliveryCharge:0,
            boriumDelivery: false,
            deliveryOption: 'Leave at door',
            headCount:0,
            cutleryCount:0,





          }
          if(this.$data.type === 'delivery' && this.$data.address != false) {
            this.$data.order.address = this.$data.address;
            // console.log("address is set " + this.$data.order.address);
          }

          let title = {
            merchantAddress:this.$data.currentMerchantItem.address,
            contact: this.$data.currentMerchantItem.contact,
          }
          this.$data.order.title = JSON.stringify(title);
          if(this.$data.tableItem.table_type === 'Take Away') {
            this.$data.order.recordType = 1;
            this.$data.order.menuName += ' (Web)';
          } else if(this.$data.tableItem.table_type === 'Delivery') {
            this.$data.order.recordType = 2;
            this.$data.order.menuName += ' (Web)';
          }
          if(item.pointsUsed > 0) {
            this.$data.order.pointsUsed = item.pointsUsed;
          }
          // console.log("Used Points " + this.$data.order.pointsUsed);
          if(this.$data.type == 'delivery') {
            this.$data.order.deliveryCharge = this.getDeliveryCharge();
          }

        }



        if(this.checkIfSame(item) == false) {
          this.$data.order.list.push(item);
        }
        this.calculatePrice();

      },
      checkIfSame: function(item) {
        // console.log("checkIfSame");
        if(this.$data.order == false) {
          // console.log("no order")
          return false;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          // console.log("no order list");
          return false;
        }
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {

          if(this.$data.order.list[i].menu_id == item.menu_id) {


            // console.log("item");
            // console.log(item);
            // console.log("from list");
            // console.log(this.$data.order.list[i]);
            if(this.$data.order.list[i].ordered_amount > 0) {
              // console.log("ordered amount")
              continue;
            }
            if(this.$data.order.list[i].menuName !== item.menuName) {
              // console.log("menu name")
              continue;
            }
            if(this.$data.order.list[i].publicMenuName !== item.publicMenuName) {
              // console.log("public_menu_name")
              continue;
            }
            if(this.$data.order.list[i].price != item.price) {
              // console.log("price")
              continue;
            }
            if(this.$data.order.list[i].optionPrice != item.optionPrice) {
              // console.log("optionPrice")
              continue;
            }

            if(this.$data.order.list[i].options.length != item.options.length ) {
              // console.log("options")
              continue;
            }

            if(JSON.stringify(this.$data.order.list[i].options) !== JSON.stringify(item.options)) {
              continue;
            }

            /**
             * the same menu
             */
            this.itemAmountChanged(item.amount, i);
            return true;

          }


        }
        return false;
      },

      getDistanceString: function(distance) {
        return (distance/1600).toFixed(1) + 'miles';
      },
      getProductYoutube: function(id) {
        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          // console.log(this.$data.currentMerchantItem.categories[i]);
          if(this.$data.currentMerchantItem.categories[i].list.length > 0) {
            for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
              if(this.$data.currentMerchantItem.categories[i].list[j].id == id) {
                // console.log("Found menu type " + this.$data.currentMerchantItem.categories[i].list[j]);
                return this.$data.currentMerchantItem.categories[i].list[j].youtube;
              }
            }
          }
        }
        return null;
      },
      /**
       * Get Product Type for discount
       * @param id
       */
      getMenuType: function(id) {
        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          // console.log(this.$data.currentMerchantItem.categories[i]);
          if(this.$data.currentMerchantItem.categories[i].list != undefined && this.$data.currentMerchantItem.categories[i].list.length > 0) {
            for(let j = 0 ; j < this.$data.currentMerchantItem.categories[i].list.length ; j++) {
              if(this.$data.currentMerchantItem.categories[i].list[j].id == id) {
                // console.log("Found menu type " + this.$data.currentMerchantItem.categories[i].list[j]);
                return this.$data.currentMerchantItem.categories[i].list[j].productType;
              }
            }
          }
        }
        return null;
      },
      calculatePrice: function() {
        let totalPrice = 0;
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {
          totalPrice += Number(this.$data.order.list[i].totalPrice);
        }
        // console.log(totalPrice);

        this.$data.order.totalPrice = totalPrice;
        // console.log("service charge rate " + this.$data.order.serviceChargeRate);
        if(this.$data.order.serviceChargeRate > 0) {
          // Prices are in pence; keep whole pence so the amount matches what the
          // backend (int fields) and Stripe will use.
          this.$data.order.serviceChargeAmount = Math.round(totalPrice*this.$data.order.serviceChargeRate/100);
        } else {
          this.$data.order.serviceChargeAmount = 0;
        }
        // console.log(this.$data.order.totalPrice);
        this.$data.order.discountAmount = 0;
        if(this.$data.promotion != false) {
          let today = millisToDate();

          if (today >= this.$data.promotion.from && today <= this.$data.promotion.to) {

            let amount = this.$data.promotion.amount;
            if (this.$data.promotion.type == 0) {

              //Percent
              if(this.$data.promotion.minimum != undefined && this.$data.promotion.minimum > 0) {

                if(parseInt(this.$data.promotion.minimum*100) <= this.$data.order.totalPrice) {

                  if(this.$data.promotion.food !== undefined && this.$data.promotion.drink !== undefined && this.$data.promotion.alcohol !== undefined) {
                    for(let d = 0 ; d < this.$data.order.list.length ; d++) {
                      let productType = this.getMenuType(this.$data.order.list[d].menuId);
                      if(productType != null &&
                        ( (productType == 'Food' && this.$data.promotion.food == true)
                          || (productType == 'Drink' && this.$data.promotion.drink == true)
                          || (productType == 'Alcohol' && this.$data.promotion.alcohol == true)
                        )) {
                        this.$data.order.discountAmount += this.$data.order.list[d].totalPrice * amount / 100;
                      }
                    }
                  } else {
                    this.$data.order.discountAmount = totalPrice * amount / 100;
                  }


                  this.$data.order.discountTitle = this.$data.promotion.title;
                  this.$data.order.discountRate = this.$data.promotion.amount;
                }
                // else {
                //   console.log("No minimum to apply discount");
                // }
              } else {
                if(this.$data.promotion.food !== undefined && this.$data.promotion.drink !== undefined && this.$data.promotion.alcohol !== undefined) {
                  for(let d = 0 ; d < this.$data.order.list.length ; d++) {
                    let productType = this.getMenuType(this.$data.order.list[d].menuId);
                    if(productType != null &&
                      ( (productType == 'Food' && this.$data.promotion.food == true)
                        || (productType == 'Drink' && this.$data.promotion.drink == true)
                        || (productType == 'Alcohol' && this.$data.promotion.alcohol == true)
                      )) {
                      this.$data.order.discountAmount += this.$data.order.list[d].totalPrice * amount / 100;
                    }
                  }
                } else {
                  this.$data.order.discountAmount = totalPrice * amount / 100;
                }
                // console.log("DC " + this.$data.order.discountAmount);
                this.$data.order.discountTitle = this.$data.promotion.title;
                this.$data.order.discountRate = this.$data.promotion.amount;
              }
            } else {
              //Amount

            }
          }
        } else {
          // console.log("no promotion");
        }
        // Round the discount to whole pence once, after all items are accumulated.
        // A fractional pence discount (e.g. 6519 * 10% = 651.9) would be displayed
        // as 6.52 but truncated to 651 by the backend's int fields, making the
        // order add up to a different total than what is shown and charged.
        this.$data.order.discountAmount = Math.round(Number(this.$data.order.discountAmount));

        // console.log("calculate total due " + Number(this.$data.order.totalPrice) + " " + Number(this.$data.order.serviceChargeAmount) + " " + Number(this.$data.order.discountAmount) + " " + Number(this.$data.order.deliveryCharge));

        if(this.$data.type == 'delivery') {
          if(this.$data.currentMerchantItem.boriumDelivery == 1) {

            // console.log("Distance " + this.$data.distance);
            //let additionalDeliveryCharge = 0;

            // if (Number(this.$data.order.totalPrice) / 5 < 600) {
            //   this.$data.order.deliveryCharge = 600 - (Number(this.$data.order.totalPrice) / 5);
            //   this.$data.order.riderFee = 400;
            //   this.$data.order.totalFee = 600;
            // } else {
            //   this.$data.order.deliveryCharge = 0;
            //   this.$data.order.riderFee = 400;
            //   this.$data.order.totalFee = Number(this.$data.order.totalPrice) / 5;
            // }
            //
            // if(this.$data.distance > 3200) {
            //   let additionalDistance = this.$data.distance - 3200;
            //   let additionalDeliveryCharge = (Math.floor(additionalDistance/1600) + 1)*200;
            //   // console.log("additional distance " + additionalDistance + " charge " + additionalDeliveryCharge);
            //   this.$data.order.riderFee += additionalDeliveryCharge;
            //   this.$data.order.deliveryCharge += additionalDeliveryCharge;
            //   this.$data.order.totalFee += additionalDeliveryCharge;
            // }
            this.$data.order.totalFee = 50;
            this.$data.order.distance = this.$data.distance;
          } else {
            this.$data.order.deliveryCharge = this.getDeliveryCharge();
          }
        }
        this.$data.order.totalDue = Math.round(Number(this.$data.order.totalPrice) + Number(this.$data.order.serviceChargeAmount) - Number(this.$data.order.discountAmount) + Number(this.$data.order.deliveryCharge));

        // console.log("total Due " + this.$data.order.totalDue);

        if(this.$data.points != false && this.$data.points.enabled && this.$data.order.pointsUsed == 0) {
          if(this.$data.points.pointAwardPrice > 0 && this.$data.order.totalDue > this.$data.points.pointAwardPrice) {
            let points = this.$data.order.totalDue%this.$data.points.pointAwardPrice;

            if(this.$data.points.pointsPerTransaction == 1) {
              if(points > 1) {
                points = 1;
              }
            }
            this.$data.order.points = points;
          } else {
            this.$data.order.points = 0;
          }

        } else {
          this.$data.order.points = 0;
        }

      },
      isOptionToShow: function(id) {
        // console.log("isOptionToShow " + id);
        // console.log(this.$data.currentMerchantItem.options)
        if(this.$data.currentMerchantItem.options == null || this.$data.currentMerchantItem.options == undefined || this.$data.currentMerchantItem.options.length == 0) {
          return false;
        }
        for(let i = 0 ; i < this.$data.currentMerchantItem.options.length ; i++) {
          if(this.$data.currentMerchantItem.options[i].id == id){
            // console.log(this.$data.currentMerchantItem.options[i]);
            if(this.$data.currentMerchantItem.options[i].content.required != undefined && this.$data.currentMerchantItem.options[i].content.required == true) {
              return true;
            }
            if(this.$data.currentMerchantItem.options[i].content.always_show != undefined && this.$data.currentMerchantItem.options[i].content.always_show == true) {
              return true;
            }
          }
        }
        return false;
      },
      shouldShowSetSelectionView: function(item) {
        // console.log("shouldShowSetSelectionView")
        if(item.description == null || item.description == undefined) {
          return false;
        }

        // let list = JSON.parse(content);

        if(item.description.section_list == undefined) {
          return false;
        }

        item.sections = [];

        let optionAvailable = false;
        for(let i = 0 ; i < item.description.section_list.length ; i++) {
          let sectionAvailable = false;
          let pids = item.description.section_list[i].list;
          let section = JSON.parse(JSON.stringify(item.description.section_list[i]));
          section.products = [];
          for(let j = 0 ; j < pids.length ; j++) {
            let productItem = this.getSetSelectionItem(pids[j]);
            if(productItem != null) {
              productItem.selected = false;
              section.products.push(productItem);
              sectionAvailable = true;
            }
          }

          if(section.products.length === 1) {
            section.products[0].selected = true;
          }
          if(sectionAvailable) {
            item.sections.push(section);
          }
        }
        if(item.sections.length > 0) {
          this.$data.setSelectItem = item;
          // console.log("options");
          // console.log(this.$data.optionSelectItem);
          // this.registerBackHandler();
          return true;
        }
        return false;
        // for(let i = 0 ; i < item.description.section.length ; i++) {
      },
      shouldShowOptionSelectionView: function(item) {
        // console.log("shouldShowOptionSelectionView")
        if(item.description === null || item.description === undefined) {
          return false;
        }

        // let list = JSON.parse(content);

        if(item.description.options === undefined) {
          return false;
        }

        // console.log(item.description.options);

        item.options = [];
        let optionAvailable = false;
        for(let i = 0 ; i < item.description.options.length ; i++) {
          let optionId = item.description.options[i].id;
          let optionItem = this.getOptionSelectionItem(optionId, item.excludeFromPromotion);
          if(optionItem != null) {


            item.options.push(optionItem)
            optionAvailable = true;
          }
        }
        if(optionAvailable === true) {
          this.$data.optionSelectItem = item;
          this.optionSelectionItemPrice();
          // console.log("options");
          // console.log(this.$data.optionSelectItem);
          // this.registerBackHandler();
          return true;
        }
        return false;

      },
      getSetSelectionItem: function(pid) {
          if(this.currentMerchantItem.categories === 0) {
            return null;
          }

          for(let i = 0 ; i < this.currentMerchantItem.categories.length ; i++) {
            if(this.currentMerchantItem.categories[i].list === undefined || this.currentMerchantItem.categories[i].list === null || this.currentMerchantItem.categories[i].list.length === 0) {
              continue;
            }

            for(let j = 0 ; j < this.currentMerchantItem.categories[i].list.length ; j++) {
              // console.log(this.currentMerchantItem.categories[i].list[j]);
              // console.log("Find set " + pid + " vs " + this.currentMerchantItem.categories[i].list[j].id);
              if(parseInt(this.currentMerchantItem.categories[i].list[j].id) === parseInt(pid)) {
                let item = JSON.parse(JSON.stringify(this.currentMerchantItem.categories[i].list[j]));

                item.options = [];
                if(item.content !== undefined && item.content !== null) {
                  if(item.content.options !== undefined) {

                    for(let k = 0 ; k < item.content.options.length ; k++) {
                      let optionItem = this.getOptionSelectionItem(item.content.options[k].id);
                      if(optionItem != null) {
                        item.options.push(optionItem);
                      }
                    }
                  }
                }
                return item;
              }
            }
          }

          return null;
      },
      getOptionSelectionItem: function(optionId, excludeFromPromotion = 0) {
        // console.log("getOptionSelectionItem")
        // console.log(this.$data.currentMerchantItem.options);
        if(this.$data.currentMerchantItem.options === null || this.$data.currentMerchantItem.options === undefined || this.$data.currentMerchantItem.options.length === 0) {
          return null;
        }

        for(let i = 0 ; i < this.$data.currentMerchantItem.options.length ; i++) {
          if (this.$data.currentMerchantItem.options[i].id == optionId) {
            let item = JSON.parse(JSON.stringify(this.$data.currentMerchantItem.options[i].content));
            // console.log(item);
            item.id = this.$data.currentMerchantItem.options[i].id;
            item.name = this.$data.currentMerchantItem.options[i].name;
            item.public_name = this.$data.currentMerchantItem.options[i].public_name;
            item.min_order = this.$data.currentMerchantItem.options[i].min_order;
            // item.multiple = false;
            // if(this.$data.currentMerchantItem.options[i].multiple !== undefined) {
            //   item.multiple = this.$data.currentMerchantItem.options[i].multiple;
            // }
            if(item.list != undefined && item.list.length > 0) {
              for(let j = 0 ; j < item.list.length ; j++) {
                item.list[j].selected = false;
                if(item.multiple !== undefined && item.multiple === true) {
                  item.list[j].amount = 0;
                  item.list[j].totla_price = 0;
                }
                if(this.$data.type == 'delivery' && item.list[j].field_price_delivery != undefined && Math.round(item.list[j].field_price_delivery) > 0) {
                  item.list[j].field_price = item.list[j].field_price_delivery;
                }
                item.list[j].originalPrice = item.list[j].field_price;
                // if(excludeFromPromotion == 0) {
                //   item.list[j].field_price = this.getPrice(item.list[j].field_price);
                // }
                if(item.list[j].soldOut == undefined) {
                  item.list[j].soldOut = false;
                }
                // console.log(item.list[j]);
              }

              // Check if option has tag
              if(this.$data.type === 'table') {
                for (let j = item.list.length - 1; j >= 0; j--) {
                  if (item.list[j].tableTags !== undefined && item.list[j].tableTags !== null && item.list[j].tableTags.length > 0) {
                    if(this.$data.tableItem.tags === null ||  this.$data.tableItem.tags.length === 0 ||  this.$data.tableItem.tags !== item.list[j].tableTags) {
                      item.list.splice(j, 1);
                    }
                  }
                }

              }

              if(item.required === true && item.list.length === 1) {
                item.list[0].selected = true;
              }





            }


            // console.log("Option");
            // console.log(item);
            return item;
          }
        }
        return null;
      },
      checkIfOptionToShow: function(optionId, item) {
        // console.log(this.$data.currentMerchantItem.options);
        for(let i = 0 ; i < item.description.options.length ; i++) {
          if(item.description.options[i].id == optionId) {
            return true;
          }
        }
        return false;
      },
      isOptionSelected: function(item) {
        // console.log("isOptionSelected " + optionName);
        // console.log(optionItem);
        if(item.list != null) {
          for(let i = 0 ; i < item.list.length ; i++) {
            if(item.list[i].selected == true) {
              return true;
            }
          }
        }
        return false;
      },
      selectOption: function(item, optionItem, option) {
        let optionSelect =  {
          option: option.name,
          field: optionItem.field_name,
          price: optionItem.field_price,

        };
        item.optionSelection.push(optionSelect);
        // console.log("Select Option")
        // console.log(item.option_selection)
      },
      toggleSetSection: function(sectionIndex, productIndex) {
        if(this.$data.setSelectItem.sections[sectionIndex].products[productIndex].soldOut === '1') {
          return;
        }
        for(let i = 0 ; i < this.$data.setSelectItem.sections[sectionIndex].products.length ; i++) {
          this.$data.setSelectItem.sections[sectionIndex].products[i].selected = i==productIndex;
        }
        // this.$data.setSelectItem.sections[sectionIndex].products[productIndex].selected = !this.$data.setSelectItem.sections[sectionIndex].products[productIndex].selected;
        // console.log("toggleSetSection")
        // console.log(this.$data.setSelectItem.sections[sectionIndex].products[productIndex]);
      },
      toggleSetSectionProductOption: function(sectionIndex, pi, optionIndex, oi) {
        // console.log("toggleSetSectionProductOption");
        if (this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].choice == 0) {
          this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[oi].selected = !this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[oi].selected;
        }
        // Only single Choice
        else {
          if (this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].required != undefined && this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].required == true) {
            for (let i = 0; i < this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list.length; i++) {
              this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[i].selected = oi == i ? true : false;
            }
          } else {
            for (let i = 0; i < this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list.length; i++) {
              if (oi == i) {
                this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[i].selected = !this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[i].selected;
              } else {
                this.setSelectItem.sections[sectionIndex].products[pi].options[optionIndex].list[i].selected = false;
              }
            }
          }
        }
        // console.log(this.setSelectItem.sections[sectionIndex].products[pi]);
        this.setSelectionItemPrice();
      },
      showAlternativeOption: function() {
        for(let i = 0 ; i < this.optionSelectItem.itemOption.defaultItems.length ; i++ ) {
          if(this.optionSelectItem.itemOption.defaultItems[i].selected === false) {
            return true;
          }
        }
        return false;
      },
      toggleItemOptionDefault: function(index) {
        // item.selected = !item.selected;

        // if(item.selected === true) {
        //   item.selected = false;
        // } else {
        //   item.selected = true;
        // }
        if(this.optionSelectItem.itemOption.defaultItems[index].title.startsWith("*")) {
          this.showPopup("Not possible!", this.optionSelectItem.itemOption.defaultItems[index].title + " is not changeable item");
          return;
        }
        this.optionSelectItem.itemOption.defaultItems[index].selected = !this.optionSelectItem.itemOption.defaultItems[index].selected;

        // console.log(this.optionSelectItem.itemOption.defaultItems);
        this.optionSelectionItemPrice();
        if(this.showAlternativeOption() === false) {
          for(let i = 0 ; i < this.optionSelectItem.itemOption.alternativeItems.length ; i++ ) {
            this.optionSelectItem.itemOption.alternativeItems[i].selected = false;
          }
        }
      },
      toggleItemOptionAlternative: function(index) {
        let selectedCount = 0;
        for(let i = 0 ; i < this.optionSelectItem.itemOption.alternativeItems.length ; i++ ) {
          if(this.optionSelectItem.itemOption.alternativeItems[i].selected) {
            selectedCount++;
          }
        }

        if(selectedCount >= this.optionSelectItem.itemOption.maxAlternatives && this.optionSelectItem.itemOption.alternativeItems[index].selected === false) {
          this.showPopup("", "You can choose maximum " + this.optionSelectItem.itemOption.maxAlternatives);
          return;
        }
        this.optionSelectItem.itemOption.alternativeItems[index].selected = !this.optionSelectItem.itemOption.alternativeItems[index].selected;
      },
      toggleMultiSelectionOption: function(index, oi, diff) {
        if(diff < 0 && this.optionSelectItem.options[index].list[oi].amount <= 0) {
          return;
        }

        const listItem = this.optionSelectItem.options[index].list[oi];
        if(diff > 0 && listItem.soldOut !== undefined && listItem.soldOut === true) {
          return;
        }

        if(diff > 0 && this.optionSelectItem.options[index].min_order > 2) {
          let totalSelectedCount = 0;
          for(let i = 0 ; i < this.optionSelectItem.options[index].list.length ; i++) {
            totalSelectedCount += this.optionSelectItem.options[index].list[i].amount;
          }
          if(totalSelectedCount >= this.optionSelectItem.options[index].min_order) {
            this.showPopup("Maximum Selection", "You can select max " + this.optionSelectItem.options[index].min_order + " items");
            return;
          }
        }
        this.optionSelectItem.options[index].list[oi].amount += diff;
        this.optionSelectItem.options[index].list[oi].total_price = this.optionSelectItem.options[index].list[oi].field_price * this.optionSelectItem.options[index].list[oi].amount;

        this.optionSelectionItemPrice();
      },
      toggleOption: function(index, oi, ci = -1, viewId = null) {

        // Multiple choice is possible


        // console.log("toggleOption " + index + " " + oi + " " + ci);
        if(ci > -1) {
          if(this.optionSelectItem.options[index].children[oi].list[ci].soldOut !== undefined && this.optionSelectItem.options[index].children[oi].list[ci].soldOut === true) {
            // console.log("Sold out");
            return;
          }
          // console.log("toggleOption");
          // console.log(this.optionSelectItem.options[index]);
          if (this.optionSelectItem.options[index].children[oi].choice === 0) {
            this.optionSelectItem.options[index].children[oi].list[ci].selected = !this.optionSelectItem.options[index].children[oi].list[ci].selected;
            // console.log(this.optionSelectItem.options[index].children[oi].list[ci].field_name + " select " + this.optionSelectItem.options[index].children[oi].list[ci].selected);
          }
          // Only single Choice
          else {

            if(this.optionSelectItem.options[index].children[oi].required !== undefined && this.optionSelectItem.options[index].children[oi].required === true) {
              for (let i = 0; i < this.optionSelectItem.options[index].children[oi].list.length; i++) {
                this.optionSelectItem.options[index].children[oi].list[i].selected = ci === i ? true : false;
                // console.log(this.optionSelectItem.options[index].children[oi].list[i].field_name + " select " + this.optionSelectItem.options[index].children[oi].list[i].selected);
              }
            } else {

              for (let i = 0; i < this.optionSelectItem.options[index].children[oi].list.length; i++) {
                if(ci == i) {
                  this.optionSelectItem.options[index].children[oi].list[i].selected = !this.optionSelectItem.options[index].children[oi].list[i].selected;
                } else {
                  this.optionSelectItem.options[index].children[oi].list[i].selected = false;
                }
                // console.log(this.optionSelectItem.options[index].children[oi].list[i].field_name + " select " + this.optionSelectItem.options[index].children[oi].list[i].selected);
              }
            }
          }
          // console.log(this.optionSelectItem.options[index].children[oi]);
        } else {
          if(this.optionSelectItem.options[index].list[oi].soldOut !== undefined && this.optionSelectItem.options[index].list[oi].soldOut === true) {
            // console.log("Sold out");
            return;
          }
          if (this.optionSelectItem.options[index].choice === 0) {
            this.optionSelectItem.options[index].list[oi].selected = !this.optionSelectItem.options[index].list[oi].selected;

            // console.log("Option item");
            // console.log(this.optionSelectItem.options[index]);
            // check if it exceedes
            if(this.optionSelectItem.options[index].min_order > 1) {
              let selectedCount = 0;
              for(let k = 0 ; k < this.optionSelectItem.options[index].list.length ; k++) {
                if(this.optionSelectItem.options[index].list[k].selected === true) {
                  selectedCount += 1;
                  if(selectedCount > this.optionSelectItem.options[index].min_order) {
                    this.optionSelectItem.options[index].list[k].selected = false;
                    selectedCount -= 1;
                  }
                }
              }

            }
          }
          // Only single Choice
          else {
            if (this.optionSelectItem.options[index].required != undefined && this.optionSelectItem.options[index].required == true) {
              for (let i = 0; i < this.optionSelectItem.options[index].list.length; i++) {
                this.optionSelectItem.options[index].list[i].selected = oi == i ? true : false;
              }
            } else {
              for (let i = 0; i < this.optionSelectItem.options[index].list.length; i++) {
                if (oi == i) {
                  this.optionSelectItem.options[index].list[i].selected = !this.optionSelectItem.options[index].list[i].selected;
                } else {
                  this.optionSelectItem.options[index].list[i].selected = false;
                }
              }
            }
          }
          let childrenToRemove = [];
          let childrenToAdd = [];
          this.optionSelectItem.options[index].children = [];
          for (let i = 0; i < this.optionSelectItem.options[index].list.length; i++) {
            // console.log(this.optionSelectItem.options[index].list[i].field_name + " check " + this.optionSelectItem.options[index].list[i].selected);
            if(this.optionSelectItem.options[index].list[i].selected == true && this.optionSelectItem.options[index].list[i].field_child != undefined && this.optionSelectItem.options[index].list[i].field_child > 0) {
              // console.log("to add " + this.optionSelectItem.options[index].list[i].field_child );
              childrenToAdd.push(this.optionSelectItem.options[index].list[i].field_child);
            } else if(this.optionSelectItem.options[index].list[i].selected == false && this.optionSelectItem.options[index].list[i].field_child != undefined && this.optionSelectItem.options[index].list[i].field_child > 0) {
              // console.log("to remove " + this.optionSelectItem.options[index].list[i].field_child );
              childrenToRemove.push(this.optionSelectItem.options[index].list[i].field_child);
            }
          }
          // console.log(this.optionSelectItem.options);
          for(let i = 0 ; i < childrenToRemove.length ; i++) {
            let toRemove = childrenToRemove[i];
            if(this.optionSelectItem.options.length > 0) {
              for (let j = this.optionSelectItem.options.length - 1; j >= 0; j--) {
                // console.log("To Remove check " + this.optionSelectItem.options[j].id + " " + toRemove);
                if (this.optionSelectItem.options[j].id == toRemove) {
                  this.optionSelectItem.options.splice(j, 1);
                  // break;
                }
              }
            }
          }

          for(let i = 0 ; i < childrenToAdd.length ; i++) {
            let toAdd = childrenToAdd[i];
            let found = false;
            for(let j = 0 ; j < this.optionSelectItem.options.length ; j++) {
              if(this.optionSelectItem.options[j].id == toAdd ) {
                // this.optionSelectItem.children.splice(j, 1);
                found = true;
                break;
              }
            }
            if(found == false) {
              let itemToAdd = this.getOptionSelectionItem(toAdd, this.optionSelectItem.excludeFromPromotion);
              this.optionSelectItem.options.push(itemToAdd);
            }
          }


          // if(this.optionSelectItem.options[index].children != undefined && this.optionSelectItem.options[index].children.length > 0) {
          //   let selected = false;
          //   for (let i = 0; i < this.optionSelectItem.options[index].list.length; i++) {
          //     if(this.optionSelectItem.options[index].list.selected == true) {
          //       selected = true;
          //       break;
          //     }
          //   }
          //   if(selected == false) {
          //     for(let i = 0 ; i < this.optionSelectItem.options[index].children.length ; i++) {
          //       if(this.optionSelectItem.options[index].children[i].list != undefined &&
          //         this.optionSelectItem.options[index].children[i].list != null &&
          //         this.optionSelectItem.options[index].children[i].list.length > 0) {
          //         for(let j = 0 ; j < this.optionSelectItem.options[index].children[i].list.length ; j++) {
          //           this.optionSelectItem.options[index].children[i].list[j].selected = false;
          //         }
          //       }
          //     }
          //   }
          // }
        }

        this.optionSelectionItemPrice();
      },
      updateChildOptionItemList: function() {

      },

      setSelectionChangeAmount: function(diff) {

        this.setSelectItem.amount += diff;
        if(this.setSelectItem.amount <= 0) {
          this.setSelectItem.amount = 1;
        }
        // console.log("Used Points " + this.optionSelectItem.pointsUsed);
        if(this.setSelectItem.pointsUsed > 0) {
          this.setSelectItem.amount = 1;
        }
        this.setSelectionItemPrice();
        // this.setelectionItemPrice();
      },
      setelectionItemPrice: function() {
        // console.log("setelectionItemPrice");
        // console.log(this.optionSelectItem)
        this.optionSelectItem.optionPrice = 0;
        for(let i = 0 ; i < this.optionSelectItem.options.length ; i++) {
          if(this.optionSelectItem.options[i].list == undefined || this.optionSelectItem.options[i].list.length == 0) {
            continue;
          }

          for(let j = 0 ; j < this.optionSelectItem.options[i].list.length ; j++) {
            if(this.optionSelectItem.options[i].list[j].selected == true) {
              if(this.optionSelectItem.options[i].list[j].field_price != undefined) {
                this.optionSelectItem.optionPrice += Math.round(this.optionSelectItem.options[i].list[j].field_price*100);
              }
              // if(this.$data.type == 'delivery' && this.optionSelectItem.options[i].list[j].field_price_delivery && Number(this.optionSelectItem.options[i].list[j].field_price_delivery) > 0) {
              //   this.optionSelectItem.optionPrice += Number(this.optionSelectItem.options[i].list[j].field_price*100);
              // }

            }
          }
          if(this.optionSelectItem.options[i].children != undefined && this.optionSelectItem.options[i].children.length > 0) {
            for (let j = 0; j < this.optionSelectItem.options[i].children.length; j++) {
              if (this.optionSelectItem.options[i].children[j].list != undefined &&
                this.optionSelectItem.options[i].children[j].list != null &&
                this.optionSelectItem.options[i].children[j].list.length > 0) {
                for (let k = 0; k < this.optionSelectItem.options[i].children[j].list.length; k++) {
                  if (this.optionSelectItem.options[i].children[j].list[k].selected == true) {
                    this.optionSelectItem.optionPrice += Math.round(this.optionSelectItem.options[i].children[j].list[k].field_price * 100);
                  }
                }
              }
            }
          }
        }

        this.optionSelectItem.totalPrice = (this.optionSelectItem.price + this.optionSelectItem.optionPrice) * this.optionSelectItem.amount;
        // console.log("Total PRice " + this.optionSelectItem.totalPrice);
      },
      optionSelectionChangeAmount: function(diff) {

        this.optionSelectItem.amount += diff;
        if(this.optionSelectItem.amount <= 0) {
          this.optionSelectItem.amount = 1;
        }
        // console.log("Used Points " + this.optionSelectItem.pointsUsed);
        if(this.optionSelectItem.pointsUsed > 0) {
          this.optionSelectItem.amount = 1;
        }
        this.optionSelectionItemPrice();
      },
      setSelectionItemPrice: function() {
        this.setSelectItem.optionPrice = 0;

        for(let i = 0 ; i < this.setSelectItem.sections.length ; i++) {

          if(this.setSelectItem.sections[i].products.length > 0) {
            for(let j = 0 ; j < this.setSelectItem.sections[i].products.length ; j++) {
              if(this.setSelectItem.sections[i].products[j].selected && this.setSelectItem.sections[i].products[j].options != undefined && this.setSelectItem.sections[i].products[j].options.length > 0) {
                for(let k = 0 ; k < this.setSelectItem.sections[i].products[j].options.length ; k++) {

                  if(this.setSelectItem.sections[i].products[j].options[k].list == undefined || this.setSelectItem.sections[i].products[j].options[k].list.length == 0) {
                    continue;
                  }
                  for(let l = 0 ; l < this.setSelectItem.sections[i].products[j].options[k].list.length ; l++) {
                    if(this.setSelectItem.sections[i].products[j].options[k].list[l].selected == true && this.setSelectItem.sections[i].products[j].options[k].list[l].field_price != undefined) {
                      this.setSelectItem.optionPrice += Math.round(this.setSelectItem.sections[i].products[j].options[k].list[l].field_price*100);
                    }
                  }
                }
              }
            }
          }


        }

        this.setSelectItem.totalPrice = (this.setSelectItem.price + this.setSelectItem.optionPrice) * this.setSelectItem.amount;
        // console.log("Total PRice " + this.optionSelectItem.totalPrice);
      },
      optionSelectionItemPrice: function() {
        this.optionSelectItem.optionPrice = 0;
        for(let i = 0 ; i < this.optionSelectItem.options.length ; i++) {
          if(this.optionSelectItem.options[i].list === undefined || this.optionSelectItem.options[i].list.length === 0) {
            continue;
          }


          for(let j = 0 ; j < this.optionSelectItem.options[i].list.length ; j++) {

            if(this.optionSelectItem.options[i].multiple !== undefined && this.optionSelectItem.options[i].multiple === true) {
              if(this.optionSelectItem.options[i].list[j].amount !== undefined && this.optionSelectItem.options[i].list[j].amount > 0) {
                const multiSoldOut = this.optionSelectItem.options[i].list[j].soldOut !== undefined && this.optionSelectItem.options[i].list[j].soldOut === true;
                if(multiSoldOut) {
                  this.optionSelectItem.options[i].list[j].total_price = 0;
                } else if (this.optionSelectItem.options[i].list[j].field_price !== undefined) {
                  this.optionSelectItem.optionPrice += Math.round(this.optionSelectItem.options[i].list[j].field_price * 100) * this.optionSelectItem.options[i].list[j].amount;
                  this.optionSelectItem.options[i].list[j].total_price = this.optionSelectItem.options[i].list[j].field_price * this.optionSelectItem.options[i].list[j].amount;
                }
              }
            } else {
              if (this.optionSelectItem.options[i].list[j].selected === true) {
                if (this.optionSelectItem.options[i].list[j].field_price !== undefined) {
                  this.optionSelectItem.optionPrice += Math.round(this.optionSelectItem.options[i].list[j].field_price * 100);
                }
                // if(this.$data.type == 'delivery' && this.optionSelectItem.options[i].list[j].field_price_delivery && Number(this.optionSelectItem.options[i].list[j].field_price_delivery) > 0) {
                //   this.optionSelectItem.optionPrice += Number(this.optionSelectItem.options[i].list[j].field_price*100);
                // }

              }
            }
          }
          if(this.optionSelectItem.options[i].children !== undefined && this.optionSelectItem.options[i].children.length > 0) {
            for (let j = 0; j < this.optionSelectItem.options[i].children.length; j++) {
              if (this.optionSelectItem.options[i].children[j].list !== undefined &&
                this.optionSelectItem.options[i].children[j].list != null &&
                this.optionSelectItem.options[i].children[j].list.length > 0) {
                for (let k = 0; k < this.optionSelectItem.options[i].children[j].list.length; k++) {
                  if (this.optionSelectItem.options[i].children[j].list[k].selected === true) {
                    this.optionSelectItem.optionPrice += Math.round(this.optionSelectItem.options[i].children[j].list[k].field_price * 100);
                  }
                }
              }
            }
          }
        }

        this.optionSelectItem.totalPrice = (this.optionSelectItem.price + this.optionSelectItem.optionPrice) * this.optionSelectItem.amount;
        // console.log("Total PRice " + this.optionSelectItem.totalPrice);
      },
      redeemPoint: function() {
        // console.log("redeempoint" + this.$data.optionSelectItem.pricePoints);
        this.$data.optionSelectItem.price = 0;
        this.$data.optionSelectItem.amount = 1;
        this.$data.optionSelectItem.totalPrice = (this.$data.optionSelectItem.price + this.$data.optionSelectItem.optionPrice);
        this.$data.optionSelectItem.pointsUsed = this.$data.optionSelectItem.pricePoints;
        // console.log("redeempoint used " + this.$data.optionSelectItem.pointsUsed);
      },
      addSetToOrder: function() {
        if(this.$data.setSelectItem.sections != undefined && this.$data.setSelectItem.sections != null && this.$data.setSelectItem.sections.length > 0) {
          for(let i = 0 ; i < this.$data.setSelectItem.sections.length ; i++) {
            if(this.$data.setSelectItem.sections[i].products.length > 0) {

              // Check if at least one product is selected
              let sectionSelected = false;
              for(let j = 0 ; j < this.$data.setSelectItem.sections[i].products.length ; j++) {
                if(this.$data.setSelectItem.sections[i].products[j].selected) {
                  sectionSelected = true;

                  if(this.$data.setSelectItem.sections[i].products[j].options != undefined && this.$data.setSelectItem.sections[i].products[j].options != null && this.$data.setSelectItem.sections[i].products[j].options.length > 0) {
                    for(let k = 0 ; k < this.$data.setSelectItem.sections[i].products[j].options.length ; k++) {
                      if(this.$data.setSelectItem.sections[i].products[j].options[k].required != undefined && this.$data.setSelectItem.sections[i].products[j].options[k].required == true) {
                        if(this.$data.setSelectItem.sections[i].products[j].options[k].list != undefined && this.$data.setSelectItem.sections[i].products[j].options[k].list != null && this.$data.setSelectItem.sections[i].products[j].options[k].list.length > 0 ) {
                          let optionSelected = false;
                          for(let l = 0 ; l < this.$data.setSelectItem.sections[i].products[j].options[k].list.length ; l++) {
                            if(this.$data.setSelectItem.sections[i].products[j].options[k].list[l].selected == true) {
                              optionSelected = true;
                            }
                          }

                          if(optionSelected == false) {
                            let productName = this.$data.setSelectItem.sections[i].products[j].public_name != null && this.$data.setSelectItem.sections[i].products[j].public_name.length > 0?this.$data.setSelectItem.sections[i].products[j].public_name:this.$data.setSelectItem.sections[i].products[j].name;
                            this.showPopup("", "Please select option for " + productName + " in section " + this.$data.setSelectItem.sections[i].section_title);
                            return;
                          }
                        }
                      }
                    }
                  }
                }
              }

              if(sectionSelected == false) {
                this.showPopup("", "Please select one item from " + this.$data.setSelectItem.sections[i].section_title);
                return;
              }


            }
          }
        }
        if(this.$data.optionSelectItem.options != undefined && this.$data.optionSelectItem.options != null && this.$data.optionSelectItem.options.length > 0) {
          for(let i = 0 ; i < this.$data.optionSelectItem.options.length ; i++) {
            if(this.$data.optionSelectItem.options[i].required != undefined && this.$data.optionSelectItem.options[i].required == true) {
              //Now check if at least one is selected

              if(this.$data.optionSelectItem.options[i].list != undefined && this.$data.optionSelectItem.options[i].list != null && this.$data.optionSelectItem.options[i].list.length > 0) {


                let selected = false;
                for(let j = 0 ; j < this.$data.optionSelectItem.options[i].list.length ; j++) {
                  if(this.$data.optionSelectItem.options[i].list[j].selected == true) {
                    selected = true;
                    break;
                  }
                }

                if(selected == false) {
                  this.showPopup("", "Please select " + this.$data.optionSelectItem.options[i].name);
                  return;
                }


              }
            }

          }
        }
        if(this.$data.type == 'table') {
          this.addOrderItemTable(JSON.parse(JSON.stringify(this.setSelectItem)));
        } else {
          this.addOrderItem(JSON.parse(JSON.stringify(this.setSelectItem)));
        }
        this.setSelectItem = false;
        this.closeTop();
      },
      addToOrder: function() {
        if(this.checkBeforeLastOrder() === false) {
          this.showPopup("", "Kitchen is closed now. " + this.$data.lastTableOrderMessage);
          return;
        }
        if(this.$data.optionSelectItem.options !== undefined && this.$data.optionSelectItem.options !== null && this.$data.optionSelectItem.options.length > 0) {
            for(let i = 0 ; i < this.$data.optionSelectItem.options.length ; i++) {
                if(this.$data.optionSelectItem.options[i].list !== undefined && this.$data.optionSelectItem.options[i].list !== null) {
                    for(let j = 0 ; j < this.$data.optionSelectItem.options[i].list.length ; j++) {
                        if(this.$data.optionSelectItem.options[i].list[j].amount > 0 &&
                            this.$data.optionSelectItem.options[i].list[j].soldOut !== undefined &&
                            this.$data.optionSelectItem.options[i].list[j].soldOut === true) {
                            this.showPopup("", "One or more options are sold out. Please reduce quantity before adding to cart.");
                            return;
                        }
                    }
                }
                if(this.$data.optionSelectItem.options[i].required !== undefined && this.$data.optionSelectItem.options[i].required === true) {
                    //Now check if at least one is selected

                    if(this.$data.optionSelectItem.options[i].list !== undefined && this.$data.optionSelectItem.options[i].list !== null && this.$data.optionSelectItem.options[i].list.length > 0) {
                        let selected = false;
                        // console.log(this.$data.optionSelectItem.options[i]);
                        for(let j = 0 ; j < this.$data.optionSelectItem.options[i].list.length ; j++) {
                            if(this.$data.optionSelectItem.options[i].list[j].selected === true || this.$data.optionSelectItem.options[i].list[j].amount > 0) {
                              selected = true;
                              break;
                            }
                        }

                        if(selected === false) {
                            this.showPopup("", "Please select " + this.$data.optionSelectItem.options[i].name);
                            return;
                        }


                        if(this.$data.optionSelectItem.options[i].min_order > 1) {
                            let count = 0;
                            for(let j = 0 ; j < this.$data.optionSelectItem.options[i].list.length ; j++) {
                              if(this.$data.optionSelectItem.options[i].list[j].amount > 0) {
                                count += this.$data.optionSelectItem.options[i].list[j].amount;
                              } else if (this.$data.optionSelectItem.options[i].list[j].selected === true) {
                                count += 1;
                              }
                            }

                            if(parseInt(this.$data.optionSelectItem.options[i].min_order) !== count) {
                                this.showPopup("", "Only " + count + " items selected. Please select " + parseInt(this.$data.optionSelectItem.options[i].min_order) + " choices for " + this.$data.optionSelectItem.options[i].name);
                                return;
                            }
                        }
                    }
                }
                let parentSelected = false;
                if(this.$data.optionSelectItem.options[i].list !== undefined && this.$data.optionSelectItem.options[i].list != null && this.$data.optionSelectItem.options[i].list.length > 0) {
                  for(let j = 0 ; j < this.$data.optionSelectItem.options[i].list.length ; j++) {
                    if(this.$data.optionSelectItem.options[i].list[j].selected === true) {
                      parentSelected = true;
                      break;
                    }
                  }
                }
                if(parentSelected === true && this.optionSelectItem.options[i].children !== undefined && this.optionSelectItem.options[i].children.length > 0) {
                    for (let j = 0; j < this.optionSelectItem.options[i].children.length; j++) {
                        if(this.optionSelectItem.options[i].children[j].required !== undefined && this.optionSelectItem.options[i].children[j].required === true) {
                            if (this.optionSelectItem.options[i].children[j].list !== undefined &&
                                this.optionSelectItem.options[i].children[j].list !== null &&
                                this.optionSelectItem.options[i].children[j].list.length > 0) {
                                let selected = false;
                                for (let k = 0; k < this.optionSelectItem.options[i].children[j].list.length; k++) {
                                    if (this.optionSelectItem.options[i].children[j].list[k].selected === true) {
                                        selected = true;
                                    }
                                }
                                if(selected === false) {
                                    this.showPopup("", "Please select " + this.$data.optionSelectItem.options[i].children[j].name);
                                    return;
                                }
                            }
                        }
                    }
                }
            }
        }


        let itemToAdd = JSON.parse(JSON.stringify(this.optionSelectItem));

        this.optionSelectItem = false;
        if(this.$data.type === 'table' || this.$data.preorder === true) {
          this.addOrderItemTable(itemToAdd);
        } else {
          this.addOrderItem(itemToAdd);
        }
        this.optionSelectItem = false;
        this.closeTop();
      },
      changeHeadCount: function(diff) {
        if(this.$data.order === false || this.$data.order === undefined) {
          return;
        }
        let current = parseInt(this.$data.order.headCount, 10);
        if(isNaN(current) || current < 0) {
          current = 0;
        }
        let next = current + diff;
        if(next < 0) {
          next = 0;
        }
        if(next > 20) {
          next = 20;
        }
        this.$data.order.headCount = next;
      },
      itemAmountChanged: function(diff, index) {
        if(this.$data.order == false) {
          return;
        }

        if(this.$data.order.list == undefined || this.$data.order.list.length == 0 || this.$data.order.list.length <= index) {
          return;
        }
        // console.log("itemAmountchanged " + diff + "  index " + index );
        // console.log(this.$data.order.list);
        if(this.$data.order.list[index].amount + diff <= 0) {
          this.confirmDeleteItem(index);
          return;
        }

        this.$data.order.list[index].amount += diff;
        this.$data.order.list[index].totalPrice = (this.$data.order.list[index].price + this.$data.order.list[index].optionPrice) * this.$data.order.list[index].amount;
        this.calculatePrice();
        if(this.$data.order.id > 0 && this.$data.order.list[index].id > 0) {
          let itemToUpdate = this.$data.order.list[index];
          let self = this;
          updateTableItem(itemToUpdate)
          .then(function(data) {
            if(data.success == true) {
              self.$data.order = data.item;
              self.notifyTableFriends();
            } else {
              self.showPopup("Sorry", data.message);
            }
          })
          .catch(function(err) {
            self.showPopup("Sorry", "Error happened. Please refresh page and try again");
          })
        }

      },
      getThumbnamil: function(url) {
        if(url.startsWith('https://borium-rest-menus.s3.eu-west-2.amazonaws.com/boriumPos')) {
          url = url.replace('https://borium-rest-menus.s3.eu-west-2.amazonaws.com/boriumPos', 'https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus/aws');
        }
        if(url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus/")) {
          let words = url.split('.');
          words[words.length-2] += '_300x300';
          return words.join('.');
        }
        return url;
      },
      getMainLargeImage: function(url) {

        if(url === null || url.length === 0) {
          return '';
        }
        if (this.isVideoUrl(url)) {
          return url;
        }
        if(url.startsWith('https://borium-rest-menus.s3.eu-west-2.amazonaws.com/boriumPos')) {
          url = url.replace('https://borium-rest-menus.s3.eu-west-2.amazonaws.com/boriumPos', 'https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus/aws');
        }
        if(url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/webs/")) {
          let words = url.split('.');
          words[words.length-2] += '_512x512';
          return words.join('.');
        }
        return url;
      },
      isVideoUrl: function(url) {
        if (typeof url !== 'string') {
          return false;
        }
        const clean = url.split('?')[0].toLowerCase();
        return ['.mp4', '.webm', '.ogg', '.ogv', '.mov', '.m4v'].some(function(ext) { return clean.endsWith(ext); });
      },
      getRestaurantSliderVideo: function(index) {
        const refVal = this.$refs['restaurantSliderVideo' + index];
        return Array.isArray(refVal) ? refVal[0] : refVal;
      },
      startRestaurantSlider: function() {
        if (this.images.length === 0) {
          return;
        }
        this.restaurantSliderIndex = 0;
        this.scheduleRestaurantSlider();
      },
      /**
       * Advances the header slider: images use the usual timeout,
       * videos play through and move on when they end.
       */
      scheduleRestaurantSlider: function() {
        const self = this;
        if (this.restaurantSliderTimer !== null) {
          clearTimeout(this.restaurantSliderTimer);
          this.restaurantSliderTimer = null;
        }
        if (this.images.length === 0) {
          return;
        }
        this.pauseRestaurantSliderVideos(this.restaurantSliderIndex);
        if (this.isVideoUrl(this.images[this.restaurantSliderIndex])) {
          const video = this.getRestaurantSliderVideo(this.restaurantSliderIndex);
          if (video) {
            video.currentTime = 0;
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function() {
                self.restaurantSliderTimer = setTimeout(function() { self.nextRestaurantSlide(); }, self.restaurantSliderImageTimeout);
              });
            }
            return;
          }
        }
        this.restaurantSliderTimer = setTimeout(function() { self.nextRestaurantSlide(); }, this.restaurantSliderImageTimeout);
      },
      pauseRestaurantSliderVideos: function(exceptIndex) {
        for (let i = 0; i < this.images.length; i++) {
          if (i === exceptIndex || !this.isVideoUrl(this.images[i])) {
            continue;
          }
          const video = this.getRestaurantSliderVideo(i);
          if (video && !video.paused) {
            video.pause();
          }
        }
      },
      nextRestaurantSlide: function() {
        if (this.images.length === 0) {
          return;
        }
        if (this.images.length === 1) {
          this.scheduleRestaurantSlider();
          return;
        }
        this.restaurantSliderIndex = (this.restaurantSliderIndex + 1) % this.images.length;
        this.scheduleRestaurantSlider();
      },
      onRestaurantSliderChanged: function(index) {
        this.restaurantSliderIndex = index;
        this.scheduleRestaurantSlider();
      },
      onRestaurantSliderVideoEnded: function(index) {
        if (index === this.restaurantSliderIndex) {
          this.nextRestaurantSlide();
        }
      },
      getLargeImage: function(url) {

        if(url.startsWith('https://borium-rest-menus.s3.eu-west-2.amazonaws.com/boriumPos')) {
          url = url.replace('https://borium-rest-menus.s3.eu-west-2.amazonaws.com/boriumPos', 'https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus/aws');
        }
        if(url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus/")) {
          let words = url.split('.');
          words[words.length-2] += '_512x512';
          return words.join('.');
        }
        return url;
      },
      getMenuAmount: function(menu) {
        // console.log(menu.name + "getMenuAmount");
        if(this.$data.order == false) {
          // console.log(menu.name + "getMenuAmount no order");
          return '';
        }

        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          // console.log(menu.name + "getMenuAmount no child order");
          return '';
        }
        let amount = 0;
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].menuId == menu.id) {
            amount+=this.$data.order.list[i].amount;
          }
        }

        if(amount == 0) {
          // console.log(menu.name + "getMenuAmount 0");
          return '';
        }
        // console.log(menu.name + " amount " + amount);
        return 'x ' + amount;
      },
      confirmDeleteItem: function(index) {
        // console.log("confirmDeleteItem");
        let self = this;
        this.showPopup("", "Remove " + this.$data.order.list[index].menuName + "?",
          "Remove", "No",
          function(){

            if(self.$data.order.id > 0 && self.$data.order.list[index].id > 0) {
              self.deleteTableOrderItem(index);
              return;
            }
            if(self.$data.order.list[index].pointsUsed > 0) {
              self.$data.order.pointsUsed = 0;
            }
            self.$data.order.list.splice(index, 1);
            self.calculatePrice();
          }, null, null, 'https://storage.googleapis.com/menus-275719.appspot.com/icons/order-status/kh_bin-orange_ic.png')
      },
      deleteTableOrderItem: function(index) {
        let id = this.$data.order.list[index].id;
        if(id == 0) {
          this.$data.order.list.splice(index, 1);
        } else {
          let self = this;
          this.setLoadingView(true, "Removing")
          if(this.$data.preorder == true) {
            deletePreOrderItem(id)
              .then(function (data) {
                self.setLoadingView(false);
                if (data.success == true) {
                  // if(data.item.list != undefined && data.item.list != null && data.item.list.length > 0) {
                  //   for(let i = 0 ; i < data.item.list.length ; i++) {
                  //     if(data.item.list[i].options != null && data.item.list[i].options.length > 0) {
                  //       data.item.list[i].options = JSON.parse(data.item.list[i].options);
                  //     }
                  //     if(data.item.list[i].optionSelection != null && data.item.list[i].optionSelection.length > 0) {
                  //       data.item.list[i].optionSelection = JSON.parse(data.item.list[i].optionSelection);
                  //     }
                  //   }
                  // }
                  self.$data.order = data.item;
                  // self.notifyTableFriends();
                } else {
                  self.showPopup("Sorry", data.message);
                }
              })
              .catch(function (err) {
                self.setLoadingView(false);
                self.showPopup("Sorry", "Error happened. please refresh page and try again")
              })
          } else {
            deleteTableItem(id)
              .then(function (data) {
                self.setLoadingView(false);
                if (data.success == true) {
                  self.$data.order = data.item;
                  self.notifyTableFriends();
                } else {
                  self.showPopup("Sorry", data.message);
                }
              })
              .catch(function (err) {
                self.setLoadingView(false);
                self.showPopup("Sorry", "Error happened. please refresh page and try again")
              })
          }
        }
      },
      getTotalCount: function() {
        let count = 0;
        if(this.$data.order != false && this.$data.order.list != undefined) {
          for(let i = 0 ; i < this.$data.order.list.length ; i++) {
            count += this.$data.order.list[i].amount;
          }
        }

        if(this.$data.lastCount != count) {
          // console.log("total count previous " + this.$data.lastCount);
          this.$data.lastCount = count;
          // console.log("total count changed " + count);
          let target = document.getElementById("basket-box");
          if(target != null) {
            target.classList.add("blink-box");
            setTimeout(this.removeBasketAnim, 2000);
          }
        }

        // this.$data.count = count;

        return count;
      },
      removeBasketAnim: function() {
        let target = document.getElementById("basket-box");
        if(target != null) {
          target.classList.remove("blink-box");
        }
      },
      getHistoryOrderItemName: function(item) {
        let title = item.menuName;
        let optionSelection = item.optionSelection;
        let optionList = [];
        if (optionSelection != null && optionSelection.length > 0) {
          let options = JSON.parse(optionSelection);
          for (let j = 0; j < options.length; j++) {
            if (options[j].field != undefined) {
              optionList.push(options[j].field);
            }
          }
        }


        if(optionList.length > 0) {
          title += ' (' + optionList.join(', ') + ')';
        }



        return title;
      },
      getOrderItemName: function(index) {
        if(this.$data.order === false) {
          return '';
        }


        if(this.$data.order.list === undefined || this.$data.order.list.length === 0) {
          return '';
        }
        let name = '';
        if(this.$data.order.list[index].publicMenuName !== undefined && this.$data.order.list[index].publicMenuName != null && this.$data.order.list[index].publicMenuName !== '') {
          name = this.$data.order.list[index].publicMenuName;
        } else {
          name = this.$data.order.list[index].menuName;
        }
        let selectedOptions = [];
        if(this.$data.order.list[index].id > 0) {
          if(this.$data.order.list[index].optionSelection !== null && this.$data.order.list[index].optionSelection.length > 0) {
            let optionSelection =  JSON.parse(this.$data.order.list[index].optionSelection);

            for(let i = 0 ; i < optionSelection.length ; i++) {
              if(optionSelection[i].section !== undefined) {
                let name = optionSelection[i].section + ": " + optionSelection[i].menu;

                let optionsNames = [];
                if(optionSelection[i].options !== undefined && optionSelection[i].options !== null && optionSelection[i].options.length > 0) {
                  for(let j = 0 ; j < optionSelection[i].options.length ; j++) {

                    optionsNames.push(optionSelection[i].options[j].field);
                  }

                }
                if(optionsNames.length > 0) {
                  name += "(" + optionsNames.join(',') + ')';
                }
                selectedOptions.push(name);
              } else {
                if(optionSelection[i].option !== undefined && (optionSelection[i].option === 'defaultList' || optionSelection[i].option === 'alternativeList' )) {
                  if (optionSelection[i].list !== undefined && optionSelection[i].list.length > 0) {
                    selectedOptions.push(optionSelection[i].list.join(', '));
                  }
                } else if(optionSelection[i].option !== undefined && optionSelection[i].option === 'choiceList') {
                  if (optionSelection[i].list !== undefined && optionSelection[i].list.length > 0) {
                    let selectedList = [];
                    for(let si = 0 ; si < optionSelection[i].list.length ; si++) {
                      let selectedItemText = optionSelection[i].list[si].item;
                      if(optionSelection[i].list[si].amount > 1) {
                        selectedItemText += " x " + optionSelection[i].list[si].amount;
                      }
                      selectedList.push(selectedItemText);
                    }
                    if(selectedList.length > 0) {
                      selectedOptions.push(selectedList.join(', '));
                    }
                  }
                } else {
                  let selectedItem = optionSelection[i].field;
                  if(optionSelection[i].amount !== undefined && optionSelection[i].amount > 1) {
                    selectedItem += " x " + optionSelection[i].amount;
                  }
                  selectedOptions.push(selectedItem);
                }
              }

            }
          } else {
            // console.log("no option selection");
          }
          if(selectedOptions.length > 0) {
            name += '<div style="padding-left:10px; font-size: 0.9rem;">' + selectedOptions.join(', ') + '</div>';
          }
          return name;
        }

        // console.log(this.$data.order.list[index].options);
        if(this.$data.order.list[index].options !== undefined && this.$data.order.list[index].options.length > 0) {
          for(let i = 0 ; i < this.$data.order.list[index].options.length ; i++) {


            let selected = false;

            if(this.$data.order.list[index].options[i].list !== undefined) {
              for(let j = 0 ; j < this.$data.order.list[index].options[i].list.length ; j++) {
                // console.log(this.$data.order.list[index].options[i]);
                if(this.$data.order.list[index].options[i].option !== undefined && (this.$data.order.list[index].options[i].option === 'defaultList' || this.$data.order.list[index].options[i].option === 'alternativeList')) {
                  if(this.$data.order.list[index].options[i].list !== undefined && this.$data.order.list[index].options[i].list.length > 0) {
                    selectedOptions.push(this.$data.order.list[index].options[i].list.join(', '));
                  }
                } else if(this.$data.order.list[index].options[i].list[j].selected === true) {
                  selectedOptions.push(this.$data.order.list[index].options[i].list[j].field_name);
                  selected = true;
                }
              }
            }

            if(selected == true) {
                if(this.$data.order.list[index].options[i].children != undefined &&
                  this.$data.order.list[index].options[i].children != null &&
                  this.$data.order.list[index].options[i].children.length > 0) {
                  for(let k = 0 ; k < this.$data.order.list[index].options[i].children.length ; k++) {
                    if(this.$data.order.list[index].options[i].children[k].list != undefined &&
                      this.$data.order.list[index].options[i].children[k].list != null &&
                      this.$data.order.list[index].options[i].children[k].list.length > 0) {
                      for(let l = 0 ; l < this.$data.order.list[index].options[i].children[k].list.length ; l++) {
                        if(this.$data.order.list[index].options[i].children[k].list[l].selected == true) {
                          selectedOptions.push(this.$data.order.list[index].options[i].children[k].list[l].field_name);
                        }
                      }
                    }
                  }
                }
            }
          }
        }
        if(this.$data.order.list[index].sections != undefined && this.$data.order.list[index].sections.length > 0) {
          for(let i = 0 ; i < this.$data.order.list[index].sections.length ; i ++) {
            if(this.$data.order.list[index].sections[i].products != undefined && this.$data.order.list[index].sections[i].products != null && this.$data.order.list[index].sections[i].products.length > 0) {
              for(let j = 0 ; j < this.$data.order.list[index].sections[i].products.length ; j++) {
                if(this.$data.order.list[index].sections[i].products[j].selected == true) {
                  let selectedSection = this.$data.order.list[index].sections[i].section_title + ": " +this.$data.order.list[index].sections[i].products[j].public_name != null && this.$data.order.list[index].sections[i].products[j].public_name.length > 0 ? this.$data.order.list[index].sections[i].products[j].public_name:this.$data.order.list[index].sections[i].products[j].name;

                  if(this.$data.order.list[index].sections[i].products[j].options != undefined && this.$data.order.list[index].sections[i].products[j].options != null && this.$data.order.list[index].sections[i].products[j].options.length > 0) {
                    for(let k = 0 ; k < this.$data.order.list[index].sections[i].products[j].options.length ; k++) {
                      if(this.$data.order.list[index].sections[i].products[j].options[k].list != undefined && this.$data.order.list[index].sections[i].products[j].options[k].list != null && this.$data.order.list[index].sections[i].products[j].options[k].list.length > 0) {
                        let selectedSectionOptions = [];
                        for(let l = 0 ; l < this.$data.order.list[index].sections[i].products[j].options[k].list.length ; l++) {
                          if(this.$data.order.list[index].sections[i].products[j].options[k].list[l].selected == true) {
                            selectedSectionOptions.push(this.$data.order.list[index].sections[i].products[j].options[k].list[l].field_name);
                          }
                        }
                        if(selectedSectionOptions.length > 0) {
                          selectedSection += '(' + selectedSectionOptions.join(',') + ')';
                        }
                      }
                    }
                  }
                  selectedOptions.push(selectedSection);


                }
              }
            }
          }
        }
        if(selectedOptions.length > 0) {
          name += '<div style="padding-left: 10px;">' + selectedOptions.join('<br>') + '</div>';
        }
        return name;
      },
      buildOptionSelection: function(item) {
        let list = [];
        if(item.sections !== undefined && item.sections.length > 0) {
          for(let i = 0 ; i < item.sections.length ; i++) {
            if(item.sections[i].products !== undefined && item.sections[i].products != null && item.sections[i].products.length > 0) {
              for(let j = 0 ; j < item.sections[i].products.length ; j++) {
                if(item.sections[i].products[j].selected === true) {
                  let section = {
                    section:item.sections[i].section_title,
                    menu_id: item.sections[i].products[j].id,
                    menu: item.sections[i].products[j].public_name !== undefined && item.sections[i].products[j].public_name.length > 0 ? item.sections[i].products[j].public_name : item.sections[i].products[j].name,
                    options:[],
                  }
                  if(item.sections[i].products[j].options !== undefined && item.sections[i].products[j].options != null && item.sections[i].products[j].options.length > 0) {
                    for (let k = 0; k < item.sections[i].products[j].options.length; k++) {
                      if (item.sections[i].products[j].options[k].list !== undefined && item.sections[i].products[j].options[k].list != null && item.sections[i].products[j].options[k].list.length > 0) {
                        for (let l = 0; l < item.sections[i].products[j].options[k].list.length; l++){
                          if(item.sections[i].products[j].options[k].list[l].selected !== undefined && item.sections[i].products[j].options[k].list[l].selected === true) {

                            let option = {
                              option: item.sections[i].products[j].options[k].name,
                              field: item.sections[i].products[j].options[k].list[l].field_name,
                              price: item.sections[i].products[j].options[k].list[l].field_price,
                            }
                            if(item.sections[i].products[j].options[k].choice !== undefined && item.sections[i].products[j].options[k].choice === 1) {
                              option.type = "single";
                            }

                            section.options.push(option);
                          }
                        }
                      }
                    }
                  }
                  list.push(section);
                }
              }
            }
          }
          if(item.memo != null && item.memo.length > 0) {
            let mo = {
              option: "memo",
              field: item.memo,
            }
            list.push(mo);
          }
          return list;
        }




        // let list = [];
        // console.log(item.options);
        if(item.itemOption !== undefined && item.itemOption !== false) {
          if(item.itemOption.selectedItems !== undefined && item.itemOption.selectedItems.length > 0) {
            let choiceList = [];
            for(let i = 0 ; i < item.itemOption.selectedItems.length ; i++) {
              if(item.itemOption.selectedItems[i].amount > 0) {
                choiceList.push({
                  item: item.itemOption.selectedItems[i].item,
                  amount: item.itemOption.selectedItems[i].amount
                });
              }
            }
            if(choiceList.length > 0) {
              if(item.options === undefined) {
                item.options = [];
              }

              list.push({
                option:'choiceList',
                list:choiceList
              });
            }

          }
          if(item.itemOption.defaultItems !== undefined && item.itemOption.defaultItems.length > 0) {
            let defaultList = [];
            let unselectedList = [];
            for(let i = 0 ; i < item.itemOption.defaultItems.length ; i++) {
              if(item.itemOption.defaultItems[i].selected === true) {
                defaultList.push(item.itemOption.defaultItems[i].title);
              } else {
                unselectedList.push(item.itemOption.defaultItems[i].title);
              }
            }
            if(defaultList.length > 0) {
              if(item.options === undefined) {
                item.options = [];
              }

              list.push({
                option:'defaultList',
                list:defaultList,
                unselectedList: unselectedList,
              });
            }

          }
          if(item.itemOption.alternativeItems !== undefined && item.itemOption.alternativeItems.length > 0) {
            let alternativeList = [];
            for(let i = 0 ; i < item.itemOption.alternativeItems.length ; i++) {
              if(item.itemOption.alternativeItems[i].selected === true) {
                alternativeList.push(item.itemOption.alternativeItems[i].title);
              }
            }
            if(alternativeList.length > 0) {
              if(item.options === undefined) {
                item.options = [];
              }

              list.push({
                option:'alternativeList',
                list:alternativeList
              });
            }

          }
        }


        for(let i = 0 ; i < item.options.length ; i++) {

          if(item.options[i].multiple !== undefined && item.options[i].multiple === true) {
            for(let j = 0 ; j < item.options[i].list.length ; j++) {
              if(item.options[i].list[j].amount !== undefined && item.options[i].list[j].amount > 0) {
                let option = {
                  option: item.options[i].name,
                  field: item.options[i].list[j].field_name,
                  price: item.options[i].list[j].field_price,
                  amount: item.options[i].list[j].amount,
                  total_price: item.options[i].list[j].total_price,
                }
                list.push(option);
              }
            }
          } else {
            let selected = false;
            // console.log(item.options[i]);

            for(let j = 0 ; j < item.options[i].list.length ; j++) {


              if(item.options[i].list[j].selected !== undefined && item.options[i].list[j].selected === true) {
                let option = {
                  option: item.options[i].name,
                  field: item.options[i].list[j].field_name,
                  price: item.options[i].list[j].field_price,
                }

                if(item.options[i].choice !== undefined && item.options[i].choice === 1) {
                  option.type = "single";
                }
                selected = true;
                list.push(option);
              }
            }
            if(selected === true) {
              if(item.options[i].children !== undefined &&
                item.options[i].children != null &&
                item.options[i].children.length > 0) {
                for(let k = 0 ; k < item.options[i].children.length ; k++) {
                  if(item.options[i].children[k].list !== undefined &&
                    item.options[i].children[k].list != null &&
                    item.options[i].children[k].list.length > 0) {
                    for(let l = 0 ; l < item.options[i].children[k].list.length ; l++) {
                      if(item.options[i].children[k].list[l].selected === true) {
                        let option = {
                          option: item.options[i].children[k].name,
                          field: item.options[i].children[k].list[l].field_name,
                          price: item.options[i].children[k].list[l].field_price,
                        }
                        if(item.options[i].children[k].choice !== undefined && item.options[i].children[k].choice === 1) {
                          option.type = "single";
                        }
                        list.push(option);
                      }
                    }
                  }
                }
              }
            }
          }

        }
        if(item.memo != null && item.memo.length > 0) {
          let mo = {
            option: "memo",
            field: item.memo,
          }
          list.push(mo);
        }

        if(list.length === 0) {
          return '';
        }
        return list;
      },
      setLoadingView: function(show, message = '') {
        this.$data.isLoading = show;
        this.$data.loadingMessage = message;
      },

      reorderItem: function() {
        if(this.$data.order == false) {
          return;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return;
        }
        this.$data.order.list.sort(function(a, b) {
          if(a.tags == null) {
            a.tags = '';
          }
          if(b.tags == null) {
            b.tags = '';
          }

          if(a.tags < b.tags) {
            return -1;
          } else if(a.tags > b.tags) {
            return 1;
          }
          return 0;
        })
        this.$data.order.list.sort(function(a,b) {
          if(a.menuName > b.menuName) {
            return 1;
          } else if(a.menuName < b.menuName) {
            return -1;
          }
          return 0;
        })
        this.$data.order.list.sort(function(a, b) {
          if(a.state < b.state) {
            return 1;
          } else if(a.state > b.state) {
            return -1;
          }
          return 0;
        })



        // console.log("reorder");
      },

      getPendingTable: function() {
        // console.log("Get pending table item if exists " + this.$data.tableItem.id);
        let self = this;
        let existed = this.$data.order != false?true:false;


        getTablePendingOrder(this.$data.tableItem.id)
        .then(function(data) {

          if(data.success == true) {
            if(self.$data.useSession === true && self.$data.sessionId !== data.item.id) {
              self.$data.sessionAuthorised = false;
              self.$data.currentMerchantItem.categories = [];
              self.showPopup("Wrong session", "Please ask staff for QR code");
              return;
            }
            self.$data.order = data.item;
            self.reorderItem();
            self.subscribeTableOrder();
            // console.log(self.$data.order);
          } else {
            self.$data.order = false;
            if(self.$data.useSession === true) {
              self.$data.sessionAuthorised = false;
              self.$data.currentMerchantItem.categories = [];
              self.showPopup("Wrong session", "Please ask staff for QR code");
              return;
            }
            // self.$router.push('error-view');
            if(existed) {
              if(self.$data.currentMerchantItem.googleReviewUrl !== undefined && self.$data.currentMerchantItem.googleReviewUrl != null && self.$data.currentMerchantItem.googleReviewUrl.length > 0) {
                window.location.href = self.$data.currentMerchantItem.googleReviewUrl;

              } else{
                window.location.href = "https://showmethemenu.net";

              }

            }
          }
        })
        .catch(function(err){
          console.error('Request failed');
          // console.log(err);
        })
      },
      containAlcohol: function() {
        if(this.$data.order == false) {
          return false;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return false;
        }

        for(let i = 0; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].alcohol != undefined  && this.$data.order.list[i].alcohol == true) {
            return true;

          }
        }
        return false;
      },

      tableOrderable: function() {
        if(this.$data.order == false) {
          return false;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return false;
        }
        let orderableFound = false;
        for(let i = 0; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].state < 1) {
            orderableFound = true;
            break;
          }
        }
        return orderableFound;
      },
      askTableOrderTable: function() {
        if(this.$data.order.headCount == 0 && this.$data.currentMerchantItem.headCountMandatory != undefined && this.$data.currentMerchantItem.headCountMandatory == 1) {
          this.showPopup("", "Please enter number of people for us to prepare the best");

          let headCountInputElement = document.getElementById('table-head-count-input');
          if(headCountInputElement !== null) {
            let pos = headCountInputElement.offsetTop;
            // console.log(pos);
            let container = document.getElementById('basket-scroll-container');
            if(container !== null) {
              container.scrollTop = pos;
            }
          }
          return;
        }
        this.$data.showTableOrderConfirm = true;
      },
      waitForTableOrder: function() {
        this.$data.showTableOrderConfirm = false;
      },
      placePreOrder: function() {
        // console.log(this.$data.order);
        if(this.$data.order == false) {

          return;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return;
        }
        this.$data.showTableOrderConfirm = false;
        let orderItem = JSON.parse(JSON.stringify(this.$data.order));
        let self = this;
        this.setLoadingView(true, "Adding to order basket");
        submitTableOrder(orderItem)
          .then(function(data) {
            self.setLoadingView(false);
            if(data.success == true) {
              self.$data.showBasket = false;
              self.$data.order = data.item;
              self.reorderItem();
              self.showPopup("Order Submitted", '<span style="font-size: 1.4rem; font-weight: bold; color: #E7344C;">If you have a food allergy or intolerance, please speak to our staff.</span><br>After meal, <span style="font-size: 1.4rem; font-weight: bold;">please ask staff for the bill to make payments.</span><br>You can order more food at any time.');
            } else {
              // console.log("Failed to place " + data.message);
            }
          })
          .catch(function(err) {
            // console.log("Error placing table order " + err);
            // if(err.response != undefined) {
            //   console.log(err.response);
            // }
            self.setLoadingView(false);
          })
      },
      placeTableOrder: function() {
        // console.log(this.$data.order);
        if(this.$data.order == false) {

          return;
        }
        if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return;
        }
        if(this.checkMinOrder() == false) {
          return;
        }
        if(this.checkBeforeLastOrder() == false) {
          this.showPopup("", "Kitchen is closed now. " + this.$data.lastTableOrderMessage);
          return;
        }
        this.$data.showTableOrderConfirm = false;
        let orderItem = JSON.parse(JSON.stringify(this.$data.order));
        let self = this;
        this.setLoadingView(true, "Adding to order basket");
        submitTableOrder(orderItem)
        .then(function(data) {
          self.setLoadingView(false);
          if(data.success == true) {
            self.$data.showBasket = false;
            self.$data.order = data.item;
            self.reorderItem();
            self.showPopup("Order Submitted", '<span style="font-weight: bold; color:#E7344C;">If you have a food allergy or intolerance, please speak to our staff.</span><hr/><span style="font-weight: bold; color: black;">After meal,</span><br/><span style="font-weight: bold; color: black;">please ask staff for the bill to make payments.</span><hr/>You can order more food at any time.');
          } else {
            // console.log("Failed to place " + data.message);
          }
        })
        .catch(function(err) {
          // console.log("Error placing table order " + err);
          // if(err.response != undefined) {
          //   console.log(err.response);
          // }
          self.setLoadingView(false);
        })
      },

      checkMinOrder: function() {
        if(this.$data.order == null || this.$data.order == false || this.$data.order.list == undefined || this.$data.order.list.length == 0) {
          return true;
        }

        let minList = [];
        for(let i = 0 ; i < this.$data.order.list.length ; i++) {
          if(this.$data.order.list[i].minOrder > 0) {
            if(this.$data.order.list[i].groupTags != null && this.$data.order.list[i].groupTags.length > 0) {
              let found = false;
              for(let j = 0 ; j < minList.length ; j++) {
                if(minList[j].name === this.$data.order.list[i].groupTags) {
                  if(minList[j].minOrder < this.$data.order.list[i].minOrder) {
                    minList[j].minOrder = this.$data.order.list[i].minOrder;
                  }
                  minList[j].amount += this.$data.order.list[i].amount;
                  found = true;
                  break;
                }
              }
              if(found == false) {
                let minItem = {
                  name: this.$data.order.list[i].groupTags,
                  minOrder: this.$data.order.list[i].minOrder,
                  amount: this.$data.order.list[i].amount,
                  menuId: -1,
                }
                minList.push(minItem);
              }

            } else {
              // Check the same menu
              let found = false;
              for(let j = 0 ; j < minList.length ; j++) {
                if(minList[j].menuId !== undefined && minList[j].menuId === this.$data.order.list[i].menuId) {
                  minList[j].amount += this.$data.order.list[i].amount;
                  found = true;
                  break;
                }
              }
              if(found === false) {
                let minItem = {
                  name: this.$data.order.list[i].menuName,
                  minOrder: this.$data.order.list[i].minOrder,
                  amount: this.$data.order.list[i].amount,
                  menuId: this.$data.order.list[i].menuId,
                }
                if(this.$data.order.list[i].publicMenuName !== null && this.$data.order.list[i].publicMenuName.length > 0) {
                  minItem.name = this.$data.order.list[i].publicMenuName;
                }
                minList.push(minItem);
              }
            }
          }
        }

        if(minList.length == 0) {
          return true;
        }
        for(let i = 0 ; i < minList.length ; i++) {
          if(minList[i].minOrder > minList[i].amount) {
            this.showPopup("Minimum Order Required", "At least " + minList[i].minOrder + " needs to be ordered for " + minList[i].name + " items");
            return false;
          }
        }
        return true;
      },
      placeOrder: function(paymentMethod = 'tillCash') {
        if(this.checkMinOrder() === false) {
          return;
        }
        if(this.$data.type !== 'collection' && this.$data.order.headCount == 0 && this.$data.currentMerchantItem.headCountMandatory != undefined && this.$data.currentMerchantItem.headCountMandatory == 1) {
          this.showPopup("", "Please enter number of people.");
          let headCountInputElement = document.getElementById('none-table-head-count-input');
          if(headCountInputElement !== null) {
            let container = document.getElementById('basket-body-scroll');
            if(container !== null) {
              container.scrollTop = headCountInputElement.offsetTop - 20;
            } else if (typeof headCountInputElement.scrollIntoView === 'function') {
              headCountInputElement.scrollIntoView({ block: 'center' });
            }
          }
          return;
        }
        let type = 'web';
        if(this.$data.type === 'table') {
          type = 'pos';
        }
        let self = this;
        if(this.$data.preorder === true) {
          this.placeOrderConfirmed(paymentMethod);
          return;
        }
        // console.log("Now get merchant info");
        getMerchant(this.$data.merchantId, type)
          .then(function(data) {
            // console.log(data);
            // let nowTime = new Date().getTime();
            // console.log("response took " + (nowTime - fromTime));
            // console.log("Merchant Info");
            // console.log(data);
            if (data.success === true) {
              if(parseInt(data.item.canTakeOrder) === 1 || data.item.canTakeOrder === true) {
                self.placeOrderConfirmed(paymentMethod);
              } else {
                self.showPopup("", "Sorry. We currently cannot take order as we are too busy");
              }
            }
          })
        .catch(function(err) {
          console.error('Request failed', err && err.response ? err.response.status : '');
          self.showPopup("", "Unknown Error happened. Please try later");

        })
      },

      placeOrderConfirmed: function(paymentMethod = 'tillCash') {
        if(this.$data.preorder === false && this.checkBeforeLastOrder() === false) {
          this.showPopup("Last Order", "Sorry last order time was " + this.getLastOrderTime());
          return;
        }
        // console.log(this.$data.currentMerchantItem);
        // if(this.$data.currentMerchantItem.canTakeOrder == false && this.$data.preorder == false) {
        //   this.showPopup("", "Sorry. We currently cannot take order as we are too busy");
        //   this.showBasket = false;
        //   return;
        // }
        if(this.$data.order === false) {
          // console.log("no order");
          return;
        }
        if(this.$data.order.list === undefined || this.$data.order.list.length === 0) {
          // console.log("no order list");
          return;
        }

        // this.$data.order.recordType = 0;
        // console.log(this.$data.order);
        if(this.$data.type !== 'collection' && this.$data.preorder === false) {
          if (this.$data.order.recordType === 1 || this.$data.order.recordType === 2) {
            if (this.$data.order.pickupTime === '') {
              this.showPopup("", "Please choose time you wish to pick up")
              return;
            }
            if (this.$data.order.name === '' || this.$data.order.name.length === 0) {
              this.showPopup("", "Please enter name")
              return;
            }
            if (this.$data.order.phoneNumber === '' || this.$data.order.phoneNumber.length < 9) {
              this.showPopup("", "Please enter phoneNumber")
              return;
            }
            //Now check time
            let targetTime = new Date();
            let times = this.$data.order.pickupTime.split(':');
            targetTime.setHours(times[0]);
            targetTime.setMinutes(times[1]);

            let timeNow = new Date().getTime();
            if (this.$data.type === 'delivery') {
              timeNow += this.getDeliveryCustomerDelayMinutes() * 60000;
              // console.log("time check for delivery" + this.$data.deliveryDelay);
            } else if (this.$data.type === 'takeaway' || this.$data.type === 'room') {
              timeNow += this.$data.taDelay * 60000;
              // console.log("time check takeaway " + this.$data.taDelay);
            if (this.$data.order != false && this.$data.order.totalDue > this.$data.additionalDelayPrice) {
              timeNow += this.$data.additionalDelay * 60000;
            }
            }
            // console.log("pickup : " + targetTime + " now + delay " + new Date(timeNow) );
            timeNow -= 300000
            if (targetTime.getTime() < timeNow) {
              let message = "Your ";
              if (this.$data.type === 'delivery') {
                message += "Delivery time is now rescalculated.";
              } else if (this.$data.type === 'takeaway') {
                message += "Pickup time is too early.";
                message += " Please select time again";
              } else if (this.$data.type === 'room') {
                // message += "Pickup time is too early.";
                message += " Please select time again";
              }


              this.setTimeSlots();
              this.$data.order.pickupTime = '';
              this.showPopup("", message);
              this.showBasketView();


              return;
            }

            // if(targetTime.getTime() < timeNow.getTime() + (60000*30)) {
            //     this.showPopup("", "Time is too early. At least 30mins required");
            //     return;
            // }

            if (this.$data.order.name === null || this.$data.order.name.length == 0) {
              this.showPopup("", "Please enter name so we can call you");
              return;
            }
            if (this.$data.order.phoneNumber === null || this.$data.order.phoneNumber.length < 8) {
              this.showPopup("", "Please enter your phone number");
              return;
            }
            localStorage.setItem('tel', this.$data.order.phoneNumber);
            this.subscribe(localStorage.getItem("tel"));
          }
        }



        // console.log("check");
        // console.log(this.$data.order.list);
        // return;

        let orderItem = JSON.parse(JSON.stringify(this.$data.order));

        // console.log(orderItem.list)
        if(orderItem.memo.length > 0) {
          if(orderItem.memo.includes("'")) {
            orderItem.memo = orderItem.memo.replace("'", "");
          }
          if(orderItem.memo.includes('"')) {
            orderItem.memo = orderItem.memo.replace('"', "");
          }
          // orderItem.memo = orderItem.memo.replace(/[^a-zA-Z ]/g, "");
        }
        if(orderItem.name.length > 0) {
          orderItem.name = orderItem.name.replace(/"/g, '').replace(/'/g, '');
        }

        if(this.$data.currentMerchantItem.lastSelections !== undefined && this.$data.currentMerchantItem.lastSelections.length > 0) {

          let lastSelections = [];
          for(let li = 0 ; li < this.$data.currentMerchantItem.lastSelections.length ; li++) {
            if(this.$data.currentMerchantItem.lastSelections[li].selected === true) {
              lastSelections.push(this.$data.currentMerchantItem.lastSelections[li].name);
            }
          }
          if(lastSelections.length > 0) {
            if(orderItem.memo == null) {
              orderItem.memo = "";
            }
            orderItem.memo += "\n\rExtra choice: " +lastSelections.join(",");
          }
        }
        for(let i = 0 ; i < orderItem.list.length ; i++) {
          if(orderItem.list[i].id == 0) {
            orderItem.list[i].optionSelection = JSON.stringify(this.buildOptionSelection(orderItem.list[i]));
            orderItem.list[i].options = JSON.stringify(orderItem.list[i].options);
          }
          if(orderItem.list[i].memo.length > 0) {
            if(orderItem.list[i].memo.includes("'")) {
              orderItem.list[i].memo = orderItem.list[i].memo.replace("'", "");
            }
            if(orderItem.list[i].memo.includes('"')) {
              orderItem.list[i].memo = orderItem.list[i].memo.replace('"', "");
            }

          }
        }
        orderItem.phoneNumber = orderItem.countryCode +  orderItem.phoneNumber;

        orderItem.paymentMethod = paymentMethod;
        if(this.$data.type === 'delivery') {
          orderItem.deliveryReadyTime = millisToHM(new Date().getTime() + this.getDeliveryKitchenPrepMinutes() * 60000);
        }
        if(paymentMethod === 'webCard' || paymentMethod === 'stripe' || paymentMethod === 'teya' || paymentMethod === 'dojo') {
          orderItem.state = -1;
        }
        // let description = {
        //   list:orderItem.list,
        // }
        // orderItem.description = JSON.stringify(description);
        // delete orderItem.list;
        let self = this;
        // console.log(orderItem);


        // console.log("submit order");
        // console.log(orderItem);
        //EventBus.$emit("showLoading", true, "Placing Order...");
        this.setLoadingView(true, "Placing Order ...");
        submitOrder(orderItem)
        .then(function(data) {

          // console.log("submit order return ");
          // console.log(data);
          if(data.success == true) {


            self.$data.order = false;
            // console.log("paymentMethod " + data.item.paymentMethod);
            if(data.item.paymentMethod === 'dojo') {
              self.setLoadingView(false);
              self.startDojoPayment(data.item);
            } else if(data.item.paymentMethod == 'stripe') {
              self.setLoadingView(false);
              self.startStripPayment(data.item);
            } else if(data.item.paymentMethod === 'teya') {
              self.setLoadingView(false);
              self.startTeyaPayment(data.item);
            } else if(data.item.paymentMethod === 'tillCash' || data.item.paymentMethod === 'tillCard') {
              self.$data.order = false;
              self.$router.push('/myorder?id=' + data.item.id);
              // self.closeTop()
              // if(self.$data.orderHistory.length > 0) {
              //   self.$data.orderHistory.unshift(data.item);
              // } else {
              //   self.$data.orderHistory.push(data.item);
              // }
              // self.$data.showHistory = true;
              // let path = self.$data.basePath + "?histor";
              // self.$router.push(path);
              // let mqttMsg = {newOrder:data.item.id}
              // let topic = "pos/" + data.item.subscriptionId;

              // self.sendMessage(topic, JSON.stringify(mqttMsg));
              // self.populateOrderItem(data.item);
              // setTimeout(function(){
              //   self.setLoadingView(false);
              //   // EventBus.$emit("showLoading", false);
              //   let elem = document.getElementById("history-container");
              //   if(elem != null) {
              //     let target = document.getElementById("history-item-" + data.item.id);
              //     elem.scrollTop = target.offsetTop;
              //   }
              //
              // }, 500);
              // self.getUserPoint();
            }
          }
        })
        .catch(function(err) {
          // console.log(err);
          // if(err.response != undefined) {
          //   console.log(err.response);
          // }
          EventBus.$emit("showLoading", false);
          self.setLoadingView(false);
          // console.log("Failed to place order "+ err);
          // if(err.response != undefined) {
          //   console.log(err.response);
          // }
        })
      },
      populateOrderItem: function(item) {
        // let list = JSON.parse(item.description);
        // if(list.list != undefined) {
        //   list = list.list;
        // }
        // item.list = list;
        this.$data.order = item;
      },



      showBasketView: function() {
        let self = this;
        if(this.checkBeforeLastOrder() == false) {
          let msg = "Sorry last order time was " + this.getLastOrderTime();
          if(this.$data.type === 'table') {
            msg += " " + this.$data.lastTableOrderMessage;
          }
          this.showPopup("Last Order", msg);
          return;
        }
        let type = 'web';
        if(this.$data.type === 'table') {
          type = 'pos';
        }


        // console.log("get merchant data " + )
        getMerchant(this.$data.merchantId, type)
          .then(function(data) {
            // let nowTime = new Date().getTime();
            // console.log("response took " + (nowTime - fromTime));
            if (data.success === true) {
              // self.$data.currentMerchantItem.deliveryZone = data.item.deliveryTimeZone;
              if(self.$data.type === 'collection') {
                self.setCollectionTime();
                return;
              }
              self.$data.currentMerchantItem.delayTime = Number(data.item.delayTime);


              // self.updateTimes();

              // self.$data.taDelay = data.item.delay

              self.$data.currentMerchantItem.canTakeOrder = parseInt(data.item.canTakeOrder) === 1;
              if(parseInt(data.item.canTakeOrder) === 1 || self.$data.type === 'table') {
                // self.$data.taDelay = data.item.
                self.showBasketViewConfirmed();
              } else {
                self.showPopup("", "Sorry. We currently cannot take order as we are too busy");

              }
            }
          })
          .catch(function(err) {
            // console.log(err);
            // if(err.response != undefined) {
            //   console.log(err.response);
            // }
            self.showPopup("", "Unknown Error happened. Please try later");

          })
      },
      setTaggedCollectionTime: function() {

      },
      setCollectionTime: function() {

        if(this.$data.collectionTag !== null && this.$data.collectionTag.length > 0) {

        }
        let self = this;
        let query = null;
        if(this.$data.collectionTag !== null && this.$data.collectionTag.length > 0) {
          query = 'tag=' + this.$data.collectionTag;
        }
        getCollectionTimeSlots(this.$data.merchantId, query)
          .then(function(data) {
            if(data.success === true) {
              self.$data.collectionTimeList = data.item;
              self.showCollectionBasketView();
            } else {
              self.showPopup("Not available", "Cannot retrieve collection time list");
            }
          })
          .catch(function(err) {
            console.error('Request failed', err && err.response ? err.response.status : '');
            self.showPopup("", "Unknown Error happened. Please try later");
          })

      },

      onCollectionDateChanged: function() {
        this.$data.order.pickupTime = '';
        for(let i = 0 ; i < this.$data.collectionTimeList.length ; i++) {
          if(this.$data.order.pickupDate === this.$data.collectionTimeList[i].date) {
            this.$data.collectionDateTimeList = this.$data.collectionTimeList[i].list;
            break;
          }
        }

      },
      showCollectionBasketView: function() {

        this.$data.order.pickupTime = '';
        this.$data.order.pickupDate = '';

        // console.log(JSON.stringify(this.$data.order));
        this.$data.showBasket = true;
        let path = this.$data.basePath + '?showBasket';
        if(path !== this.$data.currentPath) {
          this.$router.push(path);
        }
      },
      showBasketViewConfirmed: function() {
        if(this.$data.preorder == true) {
          let self = this;
          this.setLoadingView(true, "Getting list");

          // console.log("showBasketView");
          getPreOrder(this.$data.order.id)
            .then(function(data) {
              self.setLoadingView(false);
              if(data.success == true) {
                self.$data.order = data.item;
                self.reorderItem();
                // console.log(self.$data.order);
                self.$data.showBasket = true;
                // console.log("BasePath = " + self.$data.basePath);
                let path = self.$data.basePath + '?showBasket';
                if(path !== self.$data.currentPath) {
                  self.$router.push(path);
                }

              }
            })
            .catch(function(err) {
              self.setLoadingView(false);
              // console.log("Getting pending order error " + err);
              // if(err.response != undefined) {
              //   console.log(err.response);
              // }
            })
          return;
        }
        if(this.$data.type == 'table') {
          let self = this;
          this.setLoadingView(true, "Getting list");

          // console.log("getTablePending 2");
          getTablePendingOrder(this.$data.tableItem.id)
          .then(function(data) {
            self.setLoadingView(false);
            if(data.success == true) {
              self.$data.order = data.item;
              self.reorderItem();
              // console.log(self.$data.order);
              self.$data.showBasket = true;
              // console.log("BasePath = " + self.$data.basePath);
              let adder = '?';
              if(self.$data.type === 'table') {
                adder = "&";
              }
              let path = self.$data.basePath + adder + 'showBasket';
              if(path !== self.$data.currentPath) {
                self.$router.push(path);
              }

            } else {
              // console.log(data.message);
              let adder = '?';
              if(self.$data.type === 'table') {
                adder = "&";
              }
              let path = self.$data.basePath + adder + 'error-view';
              if(path !== self.$data.currentPath) {
                self.$router.push(path);
              }
              self.$router.push('error-view');

            }
          })
          .catch(function(err) {
            self.setLoadingView(false);
            // console.log("Getting pending order error " + err);
            // if(err.response != undefined) {
            //   console.log(err.response);
            // }
          })
          return;
        }

        if(this.$data.order !== false) {

          if(this.checkBeforeLastOrder() == false) {
            this.showPopup("Last Order", "Sorry last order time was " + this.getLastOrderTime());
            return;
          }

          this.setTimeSlots();

          if(this.$data.type === 'delivery') {
            if (this.$data.conditionalMinOrder > 0) {
              this.$data.minOrder = this.$data.conditionalMinOrder * 100;
            } else {
              this.$data.minOrder = this.$data.currentMerchantItem.delivery.minOrder * 100;
            }

            // console.log("min order should be " + this.$data.minOrder);
          }
          this.$data.order.pickupTime = '';
          if(this.$data.timeSlots.length > 0) {
            this.$data.order.pickupTime = this.$data.timeSlots[0];
          }
          // console.log(JSON.stringify(this.$data.order));
          this.$data.showBasket = true;
          let path = this.$data.basePath + '?showBasket';
          if(path !== this.$data.currentPath) {
            this.$router.push(path);
          }
          // console.log("basket");
          // console.log(this.$data.order);
        }
        // console.log("showBasket");
        // console.log(this.$data.order);
      },

      acceptChange: function(item) {
        item.state = 2;
        let self = this;
        updateMyOrder(item)
        .then(function(data) {
          if(data.success == true) {
            let mqttMsg = {
              customerAcceptedChange: item.id,
            }
            let topic = "pos/" + data.item.subscriptionId;
            self.sendMessage(topic, JSON.stringify(mqttMsg));
          }
        })
        .catch(function(err) {

        })
      },
      cancelChange: function(item) {
        item.state = 7;
        let self = this;
        updateMyOrder(function(data) {
          if(data.success == true) {
            let mqttMsg = {
              customerRejectedChange: item.id,
            }
            let topic = "pos/" + data.item.subscriptionId;
            self.sendMessage(topic, JSON.stringify(mqttMsg));
          }
        })
        .catch(function(err){

        })
      },
      handleScroll: function(event) {
        let restaurantPanelTop = event.srcElement.scrollTop;


        if(this.$data.preScrollPosition < 200 && restaurantPanelTop >= 200) {
          // console.log("To center Pre position " + this.$data.preScrollPosition + " new " + restaurantPanelTop);
          $("#place-title").addClass("horizontal-center");
          $("#back-btn").addClass("left-top-back-dark");
        } else if(this.$data.preScrollPosition >= 200 && restaurantPanelTop < 200) {
          $("#place-title").removeClass("horizontal-center");
          $("#back-btn").removeClass("left-top-back-dark");
          // console.log("To left Pre position " + this.$data.preScrollPosition + " new " + restaurantPanelTop);
        }
        this.$data.preScrollPosition = restaurantPanelTop;

        let activeCat = null;
        for(let i = 0 ; i < this.$data.currentMerchantItem.categories.length ; i++) {
          let catView = document.getElementById("cat-menu-container-" + this.$data.currentMerchantItem.categories[i].id);
          if(catView != null) {
            let catBtn = document.getElementById("cat-" + this.$data.currentMerchantItem.categories[i].id);
            if (this.isScrolledIntoView(catView)) {
              if($("#cat-" + this.$data.currentMerchantItem.categories[i].id).hasClass("active") == false) {
                catBtn.classList.add("active");
                if (activeCat == null) {
                  activeCat = catBtn;
                }
              }

            } else {
              if($("#cat-" + this.$data.currentMerchantItem.categories[i].id).hasClass("active")) {
                catBtn.classList.remove("active");
              }
            }
          }
        }

        if(activeCat != null) {
          $("#cat-container").animate({scrollLeft: activeCat.offsetLeft - 15}, 100);
        }
      },
      isScrolledIntoView: function(el) {
        var rect = el.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;

        if(elemTop <= 0 && elemBottom > window.innerHeight * 0.6) {
          return true;
        } else if(elemTop > 0 && elemTop <= window.innerHeight*0.6) {
          return true;
        } else if(elemTop >= 0 && elemBottom <= window.innerHeight) {
          return true;
        }
        return false;
      },

      getOrderStateString: function(state, type, merchantName) {
        if(state == 0) {
          return '<strong><span style="color:red">Waiting for acceptance</span></strong>';
        } else if(state == 1) {
          return 'Change Request!. Please Confirm change';
        } else if(state == 2) {
          return 'Change Accepted';
        } else if(state == 3) {
          return 'Your order is accepted.'
        } else if(state == 4) {
          return 'Your order is in kitchen';
        } else if(state == 5) {
          if(type == 1) {
            return 'Your order is ready for collection';
          } else if(type ==2) {
            return 'Your order is on the way to you';
          }
        } else if(state == 6) {
          return 'Done';
        } else if(state == 7) {
          return 'Cancelled';
        }
        return 'Unknown(' + state + ')';
      },


      startDojoPayment: function(order) {
        let self = this;
        this.setLoadingView(true, "Starting card payment ...");
        if (order.redirectUrl == null || order.redirectUrl === '') {
          order.redirectUrl = window.location.origin;
        }
        axios.post(process.env.SHOWMEMENU_API + 'dojo/session',
          JSON.stringify(order),
          {
            headers: {
              appId:'boriumweb',
              appKey: 'iasofjsovsdlvsdvlsnflsfhuawefawefnwaeflnjnv-=sf',
              "Content-Type": "application/json",
            }
          }
        )
          .then(function(data) {
            self.setLoadingView(false);
            if (data.data.success === true && data.data.item && data.data.item.dojoPaymentLink) {
              window.location.replace(data.data.item.dojoPaymentLink);
              return;
            }
            self.showPopup("Card payment", (data.data && data.data.message) ? data.data.message : "Card payment is not available");
          })
          .catch(function() {
            self.setLoadingView(false);
            self.showPopup("Card payment", "Could not start card payment. Please try later");
          });
      },

      updatePaidItem: function() {
        let self = this;
        // console.log("update paid item");
        // console.log(this.$data.cardPayItem);
        updatePaymentItem(this.$data.cardPayItem)
        .then(function(data) {
          if(data.success == true) {

            self.$router.push('/myorder?id=' + data.item.id);
            self.$data.cardPayItem = false;
            self.$data.order = false;
            if(self.$data.orderHistory.length > 0) {
              self.$data.orderHistory.unshift(data.item);
            } else {
              self.$data.orderHistory.push(data.item);
            }
            self.$data.showHistory = true;
            let mqttMsg = {newOrder:data.item.id}
            let topic = "pos/" + data.item.subscriptionId;

            // self.sendMessage(topic, JSON.stringify(mqttMsg));
            // self.populateOrderItem(data.item);
            setTimeout(function(){
              let elem = document.getElementById("history-container");
              if(elem != null) {
                let target = document.getElementById("history-item-" + data.item.id);
                elem.scrollTop = target.offsetTop;
              }

            }, 100);
            self.getUserPoint();
          } else {

          }
        })
        .catch(function(err){
          self.$data.cardPayItem = false;
        })
      },
      setLastOrderTime: function() {
        let lastOrderDiff = this.$data.lastOrder;
        if(this.$data.type == 'delivery') {
          lastOrderDiff = this.$data.lastDeliveryOrder;
        }

      },
      getLastOrderTime: function() {
        let lastOrderTime = this.$data.slots[this.$data.slots.length-1].to;
        let lastOrderDiff = this.$data.lastOrder;
        if(this.$data.type == 'delivery') {
          lastOrderDiff = this.$data.lastDeliveryOrder;
        } else if(this.$data.type === 'table') {
          lastOrderDiff = this.$data.lastTableOrder;
        }
        lastOrderTime -= lastOrderDiff*60000;
        return millisToHM(lastOrderTime);
      },
      checkBeforeLastOrder: function() {
        // console.log("check before last order");
        // console.log(this.$data.slots);
        if(this.$data.slots.length == 0) {
          return false;
        }
        let lastOrderTime = this.$data.slots[this.$data.slots.length-1].to;
        let lastOrderDiff = this.$data.lastOrder;
        let tolerance = 60000;
        if(this.$data.type == 'delivery') {
          lastOrderDiff = this.$data.lastDeliveryOrder;
        } else if(this.$data.type === 'table') {
          lastOrderDiff = this.$data.lastTableOrder;
          tolerance = 0;
        }
        // console.log("Last order " + this.$data.lastTableOrder);
        lastOrderTime -= lastOrderDiff*60000;
        let currentTime = new Date().getTime();

        if(currentTime > lastOrderTime + tolerance) {
          return false;
        }
        return true;
      },
      applyOrderTimingDefaults: function() {
        var ta = Number(this.$data.taDelay);
        var delivery = Number(this.$data.deliveryDelay);
        var interval = Number(this.$data.interval);
        var perMile = Number(this.$data.deliveryTimePerMile);
        this.$data.taDelay = (!isFinite(ta) || ta <= 0) ? 15 : ta;
        this.$data.deliveryDelay = (!isFinite(delivery) || delivery <= 0) ? 30 : delivery;
        this.$data.interval = (!isFinite(interval) || interval < 5) ? 5 : interval;
        this.$data.deliveryTimePerMile = (!isFinite(perMile) || perMile < 0) ? 5 : Math.floor(perMile);
      },
      getDeliveryDistanceDelayMinutes: function() {
        var perMile = Number(this.$data.deliveryTimePerMile);
        var metres = Number(this.$data.distance);
        if (!isFinite(perMile) || perMile <= 0 || !isFinite(metres) || metres <= 0) {
          return 0;
        }
        return Math.ceil(metres / 1600) * perMile;
      },
      getDeliveryExtraDelayMinutes: function() {
        var extra = 0;
        if (this.$data.order != false && this.$data.order.totalDue > this.$data.additionalDelayPrice) {
          extra += Number(this.$data.additionalDelay) || 0;
        }
        var kitchen = 0;
        if (this.$data.currentMerchantItem != null && this.$data.currentMerchantItem.delayTime != undefined) {
          kitchen = Number(this.$data.currentMerchantItem.delayTime) || 0;
        }
        if (this.$data.order != false && this.$data.order.list != null) {
          for (var i = 0; i < this.$data.order.list.length; i++) {
            var itemDelay = Number(this.$data.order.list[i].delay);
            if (isFinite(itemDelay) && itemDelay > kitchen) {
              kitchen = itemDelay;
            }
          }
        }
        extra += kitchen;
        return extra;
      },
      getDeliveryCustomerDelayMinutes: function() {
        return Number(this.$data.taDelay) + this.getDeliveryExtraDelayMinutes() + this.getDeliveryDistanceDelayMinutes();
      },
      getDeliveryKitchenPrepMinutes: function() {
        return Number(this.$data.taDelay) + this.getDeliveryExtraDelayMinutes();
      },
      setTimeSlots: function() {

          this.applyOrderTimingDefaults();
          let delay = this.$data.taDelay;
          if(this.$data.type === 'delivery') {
            delay = this.getDeliveryCustomerDelayMinutes();
          } else {
          if(this.$data.order != false && this.$data.order.totalDue > this.$data.additionalDelayPrice) {
            delay += this.$data.additionalDelay;
          }
          if(this.$data.currentMerchantItem.delayTime != undefined) {

            let extraDelay = Number(this.$data.currentMerchantItem.delayTime);
            if (this.$data.order != false && this.$data.order.list != null) {
            for(let i = 0 ; i < this.$data.order.list.length ; i++) {
              if(this.$data.order.list[i].delay > extraDelay) {
                extraDelay = this.$data.order.list[i].delay;
                // console.log("extra delay for " + this.$data.order.list[i].name + " is " + extraDelay);
              }

            }
            }
            delay += extraDelay;
            // delay += Number(this.$data.currentMerchantItem.delayTime);
          }
          }
          let currentTime = millisToHM(new Date().getTime()+(60000*delay));
          var x = Number(this.$data.interval); //minutes interval
          if (!(x >= 5)) {
            x = 5;
          }
          var times = []; // time array
          var tt = 0; // start time

          // console.log("interval " + x + " delay " + delay);
          let slotTime = new Date().getTime() + (60000*delay);

          // console.log("first slot " + millisToReadable(slotTime) + " from " + new Date() + " delay " + delay);
          // console.log("last order " + this.$data.lastOrder);
          let last = new Date();
          last.setHours(23);
          last.setMinutes(59);
          last.setSeconds(59);
          last.setMilliseconds(999);

          last = last.getTime();

          while(slotTime < this.$data.slots[this.$data.slots.length - 1].to) {

            let inSlot = false;
            // console.log(millisToHM(slotTime));
            for(let j = 0 ; j < this.$data.slots.length ; j++) {
              // console.log("check " + millisToHM(this.$data.slots[j].from) + " to " + millisToHM(this.$data.slots[j].to))
              if(slotTime >= this.$data.slots[j].from && slotTime <= this.$data.slots[j].to) {
                // if(slotTime < this.$data.slots[j].to - this.$data.lastOrder*60000)
                // console.log(millisToHM(slotTime) + " is possible");
                inSlot = true;
                break;
              }
            }
            if(inSlot) {

              let newSlot = millisToHM(slotTime);
              times.push(newSlot);
              // console.log(millisToHM(slotTime) + " is added");
              // console.log("Add to new")
            } else {
              // console.log("Exclude");
            }
            slotTime += (60000 * x);
          }

          let lastSlot = millisToHM(this.$data.slots[this.$data.slots.length -1].to);

          if(times.length == 0) {
            times.push(millisToHM(this.$data.slots[this.$data.slots.length-1].to));
          } else {
            if( (this.$data.type === 'takeaway' || this.$data.type === 'room') && lastSlot !== times[times.length - 1]) {
              times.push(lastSlot);
            }
          }
          this.$data.timeSlots = times;

      },
      getFieldIcon: function(fieldIcon) {
        let icons = fieldIcon.split(',');
        let html = "";
        for(let i = 0 ; i < icons.length ; i++) {
          if(icons[i]==='chilli') {
            html += '<i class="fas fa-pepper-hot" style="color:red;"></i>';
          } else if(icons[i] === 'vegan') {
            html += '<i class="fas fa-leaf" style="color:#2C9021;"></i>';
          }
        }

        return html;
      },
      sendMessage: function (topic, string) {
        if(this.$data.mqtt != null && this.$data.mqtt.isConnected()) {
          let message = new Paho.Message(string);
          message.destinationName = topic;
          // console.log("Sending message to  " + topic);
          // console.log(message);
          this.$data.mqtt.send(message);
        } else {
          // console.log("Not connected")
        }
      },
      onMqttFailure: function (message) {
        // console.log("MQTT failed " + message);
        // console.log(message);
      },
      subscribeTableOrder: function() {
        if(this.$data.order != false && this.$data.order.id > 0) {
          this.subscribe(this.$data.order.id.toString());
        }

      },
      onMessageArrived: function (msg) {
        // console.log("message arrived");
        let msgStr = msg.payloadString;
        // console.log(msg);
        if (msgStr.startsWith("test")) {
          // console.log("return doing nothing")
          return;
        }
        let self = this;
        // console.log("Here")
        let item = JSON.parse(msgStr);

        if(item.UUID !== undefined && item.UUID !== null && item.UUID === this.$data.UUID) {
          // console.log("This is from myself so ignore");
          return;
        }
        // console.log("Received " + msgStr);
        let viewId = 0;

        let tableChannel = false;
        if(this.$data.order != false && this.$data.order.id > 0) {
          tableChannel = 'posPublic/' + this.$data.order.id.toString();
        }
        // console.log(msg);
        // console.log("Received mqtt " + msg.destinationName + " " + tableChannel );
        if(tableChannel != false && msg.destinationName === tableChannel) {
          this.getPendingTable();
          return;
        } else {
          // console.log("Received mqtt not matching " + msg.destinationName + " " + tableChannel );
        }
        if(item.changeRequest !== undefined) {
          // console.log("changeRequest arrived")
          if (item.state != undefined && item.state == 1) {
            // console.log("now show popup");
            this.showPopup("Order Change",)
          }
          viewId = item.changeRequest;
          if (localStorage.getItem("tel") != null && localStorage.getItem("tel").length == 11) {
            let self = this;
            getMyOrder(localStorage.getItem("tel"), this.$data.currentMerchantItem.merchantId)
              .then(function (data) {
                // console.log("my order list ");
                // console.log(data);
                if (data.success == true) {
                  self.$data.orderHistory = data.item;
                  self.$data.showHistory = true;
                  let path = self.$data.basePath + '?status';
                  self.$router.push(path);
                  setTimeout(function () {
                    let elem = document.getElementById("history-container");
                    if (elem != null) {
                      let target = document.getElementById("history-item-" + viewId);
                      elem.scrollTop = target.offsetTop;
                    }

                  }, 100);
                  self.getUserPoint();
                }
              })
              .catch(function (err) {
                // console.log(err);
                // if(err.response != undefined) {
                //   console.log(err.response);
                // }
              })
            this.subscribe(localStorage.getItem("tel"));
          } else {
            // console.log("getHistory no tel");
          }
        } else if(item.content !== undefined) {
          for(let i = 0 ; i < this.$data.currentMerchantItem.options.length ; i++) {
            if(parseInt(this.$data.currentMerchantItem.options[i].id === parseInt(item.id))) {
              this.$data.currentMerchantItem.options[i].content = JSON.parse(item.content);
              return;
            }
          }
        } else if(item.soldOut !== undefined) {

          let menuId = parseInt(item.id);

          item.soldOut = parseInt(item.soldOut);
          // console.log("item sold out change " + menuId + " " + item.soldOut);
          let found = false;
          if(this.$data.currentMerchantItem != false && this.$data.currentMerchantItem.categories != undefined && this.$data.currentMerchantItem.categories.length > 0) {
            for(let c = 0 ; c < this.$data.currentMerchantItem.categories.length ; c++) {
              if(this.$data.currentMerchantItem.categories[c].list != undefined && this.$data.currentMerchantItem.categories[c].list.length > 0) {
                for(let p = 0 ; p < this.$data.currentMerchantItem.categories[c].list.length ; p++) {
                  // console.log("compare menu " + this.$data.currentMerchantItem.categories[c].list[p].id + " vs " + menuId);
                  if(parseInt(this.$data.currentMerchantItem.categories[c].list[p].id) === menuId) {
                    // console.log("found");
                    this.$data.currentMerchantItem.categories[c].list[p].soldOut = item.soldOut;
                    // console.log(this.$data.currentMerchantItem.categories[c].list[p]['name'] + " sold out changed to " +this.$data.currentMerchantItem.categories[c].list[p].soldOut);
                    found = true;
                    break;
                  }
                }
                // if(found == true) {
                //   break;
                // }
              }
            }

            if(item.soldOut == 1 && this.$data.order != false && this.$data.order.list != undefined && this.$data.order.list.length > 0) {
              let listToRemove = [];

              for(let o  = this.$data.order.list.length -1  ; o >= 0 ; o--) {
                if(this.$data.order.list[o].menuId == menuId) {
                  listToRemove.push(this.$data.order.list[o].publicMenuName);
                  this.$data.order.list.splice(o, 1);

                }
              }
              if(listToRemove.length > 0) {
                this.showPopup(listToRemove.join(", ") + " now sold out");

              }
            }
          }


        } else if(item.inStock !== undefined) {
          let menuId = item.id;
        } else {
          // console.log(item);
          if(item.canTakeOrder !== undefined) {
            if(this.$data.currentMerchantItem !== false && this.$data.currentMerchantItem.canTakeOrder !== undefined) {
              // console.log(item);
              // console.log(this.$data.currentMerchantItem);
              if(parseInt(this.$data.currentMerchantItem.canTakeOrder) === 1 && parseInt(item.canTakeOrder) === 0) {
                if(this.$data.type !== 'table') {
                  this.showPopup("", "Sorry. We currently cannot take order as we are too busy");
                  this.showBasket = false;
                }

              } else if(parseInt(this.$data.currentMerchantItem.canTakeOrder) === 1 && parseInt(item.canTakeOrder) === 1) {
                if(this.$data.type !== 'table') {
                  this.showPopup("", "Hi, We can now accept order");
                }
              }
              this.$data.currentMerchantItem.canTakeOrder = parseInt(item.canTakeOrder) === 1?1:0;
            }
          }
        }
      },
      subscribe: function(channel) {
        if(this.$data.mqtt == null || this.$data.mqtt.isConnected() == false) {
          // console.log("MQTT is not connected");
          return;
        }
        for(let i = 0 ; i < this.$data.topics.length ; i++) {
          // console.log("Already subscribed " + this.$data.topics[i]);
          if(this.$data.topics[i] === channel) {
            // console.log("Already " + channel);
            return;
          }
        }
        // console.log("Subscribe now " + channel);
        this.$data.mqtt.subscribe("posPublic/" + channel);
        this.$data.topics.push(channel);
        //this.sendMessage("Hello I am customer");
      },
      onConnectionLost: function(resObj) {
        // console.log("connection lost");
        // this.$data.mqttConnected = false;
        this.$data.mqtt = null;
        // console.log("Lost connection to " + resObj.uri + "\nError code: " + resObj.errorCode + "\nError text: " + resObj.errorMessage);
        if(this.$data.mqttDisconnect == false) {
          this.connect();
        }
      },
      disconnect: function() {
        this.$data.mqttDisconnect = true;
        if(this.$data.mqtt != null && this.$data.mqtt.isConnected()) {
          this.$data.mqtt.disconnect();
        }
      },
      onConnect: function () {
        // console.log("Connected ");

        if(this.$data.mqtt == null || this.$data.mqtt.isConnected() == false) {
          // console.log("onConnect but " + this.$data.mqtt);
          return;
        }
        if(localStorage.getItem("tel") != null && localStorage.getItem("tel").length == 11) {
          this.subscribe(localStorage.getItem("tel"));
        }
        if(this.$data.currentMerchantItem != false) {
          this.subscribe("merchant/" + this.$data.currentMerchantItem.merchantId)
        }

        this.subscribeTableOrder();

      },
      connect: function () {
        this.$data.topics = [];
        this.$data.mqtt = new Paho.Client("mqtt.boriumstudio.com", Number(9001), "clientjsasdasd" + new Date().getTime());
        this.$data.mqtt.onConnectionLost = this.onConnectionLost;
        let options = {
          timeout: 3,
          useSSL: true,
          userName: "borium",
          password: "borium1234",
          onSuccess: this.onConnect,
          onFailure: this.onMqttFailure,
          reconnect : false,
        };
        this.$data.mqtt.onMessageArrived = this.onMessageArrived;
        // console.log("### Connect to MQTT ");
        this.$data.mqtt.connect(options); //connect
      },


      startTeyaPayment: function(order) {
        let self = this;
        this.setLoadingView(true, "Starting card payment ...");
        if (order.redirectUrl == null || order.redirectUrl === '') {
          order.redirectUrl = window.location.origin;
        }
        axios.post(process.env.SHOWMEMENU_API + 'teya/session',
          JSON.stringify(order),
          {
            headers: {
              appId:'boriumweb',
              appKey: 'iasofjsovsdlvsdvlsnflsfhuawefawefnwaeflnjnv-=sf',
              "Content-Type": "application/json",
            }
          }
        )
          .then(function(data) {
            self.setLoadingView(false);
            if (data.data.success === true && data.data.item && data.data.item.teyaSessionUrl) {
              window.location.href = data.data.item.teyaSessionUrl;
              return;
            }
            self.showPopup("ERROR", (data.data && data.data.message) ? data.data.message : "Could not start payment");
          })
          .catch(function() {
            self.setLoadingView(false);
            self.showPopup("ERROR", "Could not start payment. Please try later");
          });
      },

      startStripPayment: function(order) {
        // this.$data.stripe = Stripe('pk_test_51HKwg5FVWak6exTyYpcPbHzjlLTXgLzPJBU1hx7FPgImJOB6psptYrcyP53K75Hy6OXvoeTahf91fUzWqzQxlzt7000Vvir4GN');
        // if(this.$data.currentMerchantItem.merchantId == 1) {
        //   this.$data.stripe = Stripe("pk_test_51HKwg5FVWak6exTyYpcPbHzjlLTXgLzPJBU1hx7FPgImJOB6psptYrcyP53K75Hy6OXvoeTahf91fUzWqzQxlzt7000Vvir4GN", {
        //     stripeAccount:this.$data.currentMerchantItem.stripeId
        //   });
        // } else {
        //   this.$data.stripe = Stripe('pk_live_51HKwg5FVWak6exTyclUWJpjsxbB8FTQKlF8oJp7QKEUk85qdeiJsSvLhOlVpYuCmJPQBGekUbO0DzY8pbwEgiZyD00evV7J3KP', {
        //     stripeAccount:this.$data.currentMerchantItem.stripeId
        //   });
        // }

        let purchase = [];
        for(let i = 0 ; i < order.list.length ; i++) {

          let purchaseItem = {
            id: order.list[i].name + ' x' + order.list[i].amount,
          };
          purchase.push(purchaseItem);

        }
        if(order.deliveryCharge > 0) {
          purchase.push({id:'Delivery Charge'});
        }
        let self = this;
        axios.post(process.env.SHOWMEMENU_API + 'stripe/session',
          JSON.stringify(order),
          {
            headers: {
              appId:'boriumweb',
              appKey: 'iasofjsovsdlvsdvlsnflsfhuawefawefnwaeflnjnv-=sf',
              "Content-Type": "application/json",
            }
          }
        )
        // .then(function(data) {
        //   console.log(data);
        //   self.$data.stripeCardPayment = {
        //     cardNumber:'',
        //       expMonth:'',
        //       expYear:'',
        //       cvc:'',
        //   }
        // })

          .then(function(data) {
            if(data.data.success === true) {
              if (data.data.item.stripePublicKey !== undefined && data.data.item.stripePublicKey !== null && data.data.item.stripePublicKey.length > 0) {

                if (data.data.item.stripeClientId !== undefined && data.data.item.stripeClientId !== null && data.data.item.stripeClientId.length > 0) {
                  self.$data.stripe = Stripe(data.data.item.stripePublicKey, {
                    stripeAccount: data.data.item.stripeClientId
                  });

                } else {
                  self.$data.stripe = Stripe(data.data.item.stripePublicKey);
                }
                return self.$data.stripe.redirectToCheckout({sessionId: data.data.item.pgToken});

              } else {

                // console.log("Failed");
                // console.log(data);
              }
            }else {
              self.showPopup("ERROR", data.data.message);
            }

          })
          // .then(function(session){
          //
          // })
        .catch(function(err) {
          console.error('Request failed', err && err.response ? err.response.status : '');
          self.showPopup("ERROR", "Unknown error occurred. Please try later or call restaurant");
        })
      },
      chargeCreditCard: function() {
        let self = this;
        Stripe.card.createToken({
          number: this.$data.stripeCardPayment.cardNumber,
          exp_month: this.$data.stripeCardPayment.expMonth,
          exp_year:  this.$data.stripeCardPayment.expYear,
          cvc:  this.$data.stripeCardPayment.cvc,

        }, (status, response) => {
          if (status === 200) {
            let token = response.id;
            // self.chargeCard(token);
            // console.log("Response from Stripe");
            // console.log(token);
            // console.log(response);
          } else {
            // console.log(response.error.message);
          }
        })
      },
      setPageMeta: function() {
        // console.log("Set PAge Meta");
        const titleEl = document.querySelector('head title');
        const descEl = document.querySelector('head meta[name="description"]');
        const keywordsEl = document.querySelector('head meta[name="keywords"]');

        let title =this.$data.currentMerchantItem.title;
        let key = this.$data.currentMerchantItem.title;
        let description = "Simple click and collect & Takeaway order for " + this.$data.currentMerchantItem.title;
        if(this.$data.currentMerchantItem.region !== undefined && this.$data.currentMerchantItem.region != null && this.$data.currentMerchantItem.region.length > 0) {
          title += " in " + this.$data.currentMerchantItem.region;
          key += "," + this.$data.currentMerchantItem.region;
          description += " in " + this.$data.currentMerchantItem.region;
        }
        key += ", takeaway";
        if(this.$data.currentMerchantItem.tags !== undefined && this.$data.currentMerchantItem.tags != null && this.$data.currentMerchantItem.tags.length > 0) {
          key += "," + this.$data.currentMerchantItem.tags;
        }
        title += " Takeaway | Menu | Price | Show Me The Menu";
        titleEl.textContent = title;

        // console.log("Set title to " + title);
        // console.log("Set Description to " + description);
        descEl.setAttribute('content', description);
        keywordsEl.setAttribute('content', key);

      },
      // chargeCard: function(token) {
      //   const headers = new Headers({'token': token, 'amount': 100});
      //   this.http.post('http://192.:9090/payment/charge', {}, {headers: headers})
      //     .subscribe(resp => {
      //       console.log(resp);
      //     })
      // }
    }
  }
</script>

<style scoped>
  .slider-indicator-icon {
    background-color: white;
  }

  .wait-accept {
    background-color: #FFE9E9;
  }

  .select-item-container {
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid gray;
    font-size: 20px;
  }
  .select-item-container-active {
    font-weight: bold;
    background-color: #fff100;
  }
  .select-item-container > div {
    line-height: 40px;
  }
  .item-amount-btn-container {
    height: 40px; width: 25px;
    line-height: 40px;
  }
  .item-amount-button {
    height: 40px; width: 40px;
    line-height: 40px;
    border-radius: 20px;
    /*background-color: green;*/
    color: white;
  }
  .negative-item {
    background-color: red;
  }
  .ic-plus {
    background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-plus-orange-ic.png');
    background-size: 40px 40px;
    background-position: center;
    background-repeat: no-repeat;

  }
  .ic-minus {
    background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/kh-minus-gray-ic.png');
    background-size: 40px 40px;
    background-position: center;
    background-repeat: no-repeat;

  }
  .alcohol-icon-old {
    width: 40px;
    height: 40px;
    background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/beta/icon/ic-beer.png');
    background-size: 40px 40px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .alcohol-icon {
    width: 20px; height: 20px;
    margin-left: 5px;
  }

  .info-icon {
    height: 18px;

  }
  .search-bar-container {
    background: #ECECEC;
    border-radius: 10px;
    padding: 7px 0;
    display: flex;
  }
  .search-bar-container input {
    background-color: #ECECEC;
    width: calc(100% - 30px);
    padding-left: 10px;
    border: none;
  }
  .search-bar-container img {
    width: 20px;
    height: 20px;
    margin-top: 3px;
    margin-right: 10px;
  }
  .list-group-item {
    padding: 10px 5px;
  }

  .order-section-selector-container {
    //width: 100%;
    height: 50px;
    display: flex;
    margin-top: 10px;
    margin-left: -15px;
    margin-right: -15px;

  }
  .order-section-selector-container .order-section-selector {
    font-weight: 400;
    font-size: 16px;
    line-height: 46px;
    width: 50%;
    border-bottom: 4px solid #ECECEC;
  }
  .order-section-selector-container .order-section-selector.active {
    color: #EF5C29;
    font-weight: 600;
    border-bottom: 4px solid #EF5C29;
  }
  .basket-table {
    width: 100%;
  }
  .basket-table td {
    line-height: 24px;
    padding-top:10px;
    padding-bottom: 10px;
    vertical-align: top;
  }

  .basket-table .summary-row td {
    padding-top: 3px;
    padding-bottom: 3px;
    padding-left: 15px;
  }
  .row.fixed-bottom {
    padding: 15px;
  }

  .bottom-divider {
    border-bottom: 8px solid #F3F4F7;
  }

  .delay-message {
    padding-top: 10px;
    padding-bottom: 10px;
    color: red;
    font-weight: 600;
  }

  .has-delivery-address-bar {
    box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.08);
  }
  .has-delivery-address-bar .bottom-btn-container {
    margin-top: 8px;
  }
  .delivery-address-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 10px 14px;
    border-top: 1px solid #ececec;
    background: #f7f8fa;
    border-radius: 10px 10px 0 0;
    cursor: pointer;
  }
  .delivery-address-bar-main {
    min-width: 0;
    flex: 1;
    text-align: left;
  }
  .delivery-address-bar-label {
    font-size: 11px;
    font-weight: 600;
    color: #888;
    line-height: 14px;
  }
  .delivery-address-bar-text {
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
  }
  .delivery-address-bar-meta {
    flex-shrink: 0;
    text-align: right;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }
  .delivery-address-bar-change {
    display: block;
    color: #EF5C29;
    font-size: 12px;
    margin-top: 2px;
  }
  .basket-page {
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    height: 100dvh;
    max-height: 100dvh;
    overflow: hidden;
  }
  .basket-page-inner {
    background-color: white;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }
  #basket-scroll-container {
    flex: 0 0 50px;
    height: 50px;
  }
  #basket-body-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 100px;
    -webkit-overflow-scrolling: touch;
  }
  .basket-footer {
    margin-left: -15px;
    margin-right: -15px;
    margin-top: 16px;
  }
  .basket-address-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
  }
  .basket-address-change {
    flex-shrink: 0;
    cursor: pointer;
  }
  .head-count-stepper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 220px;
    margin-top: 6px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 6px 12px;
    background: #fff;
    box-sizing: border-box;
  }
  .head-count-stepper.need-selection {
    background-color: #EF5C29;
    color: white;
    border-color: #EF5C29;
  }
  .head-count-stepper-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    min-height: 32px;
    cursor: pointer;
  }
  .head-count-stepper-value {
    min-width: 64px;
    text-align: center;
  }
  .popup-logo {
    width: 60px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .popup-title {
    font-size: 20px;
    font-weight: bold;
  }
  .popup-container >>> a[href^="tel:"] {
    color: #EF5C29;
    font-weight: 700;
    text-decoration: underline;
    white-space: nowrap;
  }

  .smtm-btn {
    background: #EF5C29;
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 30px;
    cursor: pointer;
  }

  .mandatory-text {
    font-weight: bold;
    color: #E7344C;
  }
  .gcs-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Restaurant.vue